import { GraphQLClient } from 'graphql-request';
import { GraphQLClientRequestHeaders } from 'graphql-request/build/cjs/types';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any; }
};

export type ActivityLogInput = {
  actionName: Scalars['String']['input'];
  /** @deprecated removed table id */
  boardId?: InputMaybe<Scalars['Int']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  dbFormId?: InputMaybe<Scalars['Int']['input']>;
  dbResponseId?: InputMaybe<Scalars['Int']['input']>;
  eventUnixTime: Scalars['Int']['input'];
  fac?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  pageName: Scalars['String']['input'];
  path: Scalars['String']['input'];
  /** @deprecated removed table id */
  postId?: InputMaybe<Scalars['Int']['input']>;
  questId?: InputMaybe<Scalars['Int']['input']>;
  userAgent: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of AddGenre */
export type AddGenreInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Autogenerated return type of AddGenre. */
export type AddGenrePayload = {
  __typename?: 'AddGenrePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  genre: Genre;
};

/** Autogenerated input type of AddRadioResponse */
export type AddRadioResponseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  radioSegmentId: Scalars['Int']['input'];
  userMediumReferenceIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Autogenerated return type of AddRadioResponse. */
export type AddRadioResponsePayload = {
  __typename?: 'AddRadioResponsePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  radioResponse?: Maybe<RadioResponse>;
};

/** Autogenerated input type of AddRadioSegment */
export type AddRadioSegmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  radioChannelId: Scalars['Int']['input'];
};

/** Autogenerated return type of AddRadioSegment. */
export type AddRadioSegmentPayload = {
  __typename?: 'AddRadioSegmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  radioSegment?: Maybe<RadioSegment>;
};

/** Autogenerated input type of AddYoutubeMembershipSubscriptionEvents */
export type AddYoutubeMembershipSubscriptionEventsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  events: Array<YoutubeMembershipSubscriptionEventsInput>;
};

/** Autogenerated return type of AddYoutubeMembershipSubscriptionEvents. */
export type AddYoutubeMembershipSubscriptionEventsPayload = {
  __typename?: 'AddYoutubeMembershipSubscriptionEventsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AdoptRadioResponse2 */
export type AdoptRadioResponse2Input = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 放送日時 UTCで入力してください */
  featuredAt: Scalars['ISO8601DateTime']['input'];
  radioResponseId: Scalars['Int']['input'];
};

/** Autogenerated return type of AdoptRadioResponse2. */
export type AdoptRadioResponse2Payload = {
  __typename?: 'AdoptRadioResponse2Payload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  radioResponse?: Maybe<RadioResponse>;
};

/** Autogenerated input type of AdoptRadioResponse */
export type AdoptRadioResponseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  radioResponseId: Scalars['Int']['input'];
};

/** Autogenerated return type of AdoptRadioResponse. */
export type AdoptRadioResponsePayload = {
  __typename?: 'AdoptRadioResponsePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  radioResponse?: Maybe<RadioResponse>;
};

export type AnswerInput = {
  answerTypeEnum: AnswerTypeEnum;
  dateAnswer?: InputMaybe<DateAnswerInput>;
  locationAnswer?: InputMaybe<LocationAnswerInput>;
  numberAnswer?: InputMaybe<NumberAnswerInput>;
  questionId: Scalars['Int']['input'];
  /** reference to response */
  referenceAnswer?: InputMaybe<ReferenceAnswerInput>;
  /** accept answer type short text, long text, url, image url */
  textAnswer?: InputMaybe<TextAnswerInput>;
};

export enum AnswerTypeEnum {
  /** Date */
  Date = 'date',
  /** Image URL */
  ImageUrl = 'image_url',
  /** Location */
  Location = 'location',
  /** Long Text */
  LongText = 'long_text',
  /** Number */
  Number = 'number',
  /** Reference */
  Reference = 'reference',
  /** Short Text */
  ShortText = 'short_text',
  /**
   * Text
   * @deprecated Use SHORT_TEXT or LONG_TEXT instead
   */
  Text = 'text',
  /** URL */
  Url = 'url'
}

/** Union of answer types */
export type AnswerUnion = DateAnswer | ImageUrlAnswer | LocationAnswer | LongTextAnswer | NumberAnswer | ReferenceAnswer | ShortTextAnswer | TextAnswer | UrlAnswer;

/** Autogenerated input type of ApplyQuestTaskDone */
export type ApplyQuestTaskDoneInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  items: Array<ApplyQuestTaskDoneItem>;
  questTaskId: Scalars['Int']['input'];
};

export type ApplyQuestTaskDoneItem = {
  filename: Scalars['String']['input'];
  image: Scalars['String']['input'];
  position: Scalars['Int']['input'];
};

/** Autogenerated return type of ApplyQuestTaskDone. */
export type ApplyQuestTaskDonePayload = {
  __typename?: 'ApplyQuestTaskDonePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ApplyQuestTaskStart */
export type ApplyQuestTaskStartInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  questTaskId: Scalars['Int']['input'];
};

/** Autogenerated return type of ApplyQuestTaskStart. */
export type ApplyQuestTaskStartPayload = {
  __typename?: 'ApplyQuestTaskStartPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AttachGenre */
export type AttachGenreInput = {
  categoryId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  genreId: Scalars['Int']['input'];
};

/** Autogenerated return type of AttachGenre. */
export type AttachGenrePayload = {
  __typename?: 'AttachGenrePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AuthorityRole = {
  __typename?: 'AuthorityRole';
  contentsDeleteFlag: ContentsDeleteFlag;
  contentsWriteFlag: ContentsWriteFlag;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** The connection type for AuthorityRole. */
export type AuthorityRoleConnection = {
  __typename?: 'AuthorityRoleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AuthorityRoleEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AuthorityRole>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AuthorityRoleEdge = {
  __typename?: 'AuthorityRoleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AuthorityRole>;
};

/** Autogenerated input type of CancelPartnerCategoryMembership */
export type CancelPartnerCategoryMembershipInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of CancelPartnerCategoryMembership. */
export type CancelPartnerCategoryMembershipPayload = {
  __typename?: 'CancelPartnerCategoryMembershipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Category = FussyEventReferenceEventableInterface & {
  __typename?: 'Category';
  /** may produce N+1 */
  accumulatedPoint: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentRaid?: Maybe<CategoryRaid>;
  currentUserIsFollowing: Scalars['Boolean']['output'];
  examProducts: Array<ExamProduct>;
  fanLimitedContents: Array<FanLimitedContent>;
  followersCount: Scalars['Int']['output'];
  forms: Array<Form>;
  furigana: Scalars['String']['output'];
  fussyAttestations: Array<FussyAttestation>;
  fussyEventReferences: Array<FussyEventReference>;
  genres: Array<Genre>;
  id: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** may produce N+1 */
  kinzokubatSignageAccumulatedPoint: Scalars['Int']['output'];
  membershipLimitedContents: Array<MembershipLimitedContent>;
  name: Scalars['String']['output'];
  partnerCategoryMemberships: Array<PartnerCategoryMembership>;
  quests: Array<Quest>;
  raids: Array<CategoryRaid>;
  summarizedAllFandomVolumes: Array<SummarizedAllFandomVolume>;
  summarizedFanFandomVolumes: Array<SummarizedFanFandomVolume>;
  summarizedFussyMembershipFandomVolumes: Array<SummarizedFussyMembershipFandomVolume>;
  summarizedQuestCompletedFandomVolumes: Array<SummarizedQuestCompletedFandomVolume>;
  summarizedYoutubeMembershipFandomVolumes: Array<SummarizedYoutubeMembershipFandomVolume>;
  taggedQuests: Array<Quest>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum CategoryColumnEnum {
  /** created_at */
  CreatedAt = 'CREATED_AT',
  /** furigana */
  Furigana = 'FURIGANA',
  /** id */
  Id = 'ID',
  /** name */
  Name = 'NAME'
}

export type CategoryRaid = {
  __typename?: 'CategoryRaid';
  achieved: Scalars['Boolean']['output'];
  achievementPoint: Scalars['Int']['output'];
  bannerImageUrl: Scalars['String']['output'];
  category: Category;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  stage: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

/** Autogenerated input type of ChangeOpenedAllNotifications */
export type ChangeOpenedAllNotificationsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ChangeOpenedAllNotifications. */
export type ChangeOpenedAllNotificationsPayload = {
  __typename?: 'ChangeOpenedAllNotificationsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ChangeOpenedNotification */
export type ChangeOpenedNotificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of ChangeOpenedNotification. */
export type ChangeOpenedNotificationPayload = {
  __typename?: 'ChangeOpenedNotificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ChangeResponseUser */
export type ChangeResponseUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newUserId: Scalars['Int']['input'];
  responseId: Scalars['Int']['input'];
};

/** Autogenerated return type of ChangeResponseUser. */
export type ChangeResponseUserPayload = {
  __typename?: 'ChangeResponseUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CheckInKintai */
export type CheckInKintaiInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  isAttend: Scalars['Boolean']['input'];
};

/** Autogenerated return type of CheckInKintai. */
export type CheckInKintaiPayload = {
  __typename?: 'CheckInKintaiPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  kintai?: Maybe<Kintai>;
};

export type ContentsDeleteFlag = {
  __typename?: 'ContentsDeleteFlag';
  boardDeletable: Scalars['Boolean']['output'];
  categoryDeletable: Scalars['Boolean']['output'];
  postDeletable: Scalars['Boolean']['output'];
};

export type ContentsWriteFlag = {
  __typename?: 'ContentsWriteFlag';
  boardWritable: Scalars['Boolean']['output'];
  categoryWritable: Scalars['Boolean']['output'];
  postWritable: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateCategory */
export type CreateCategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  furigana: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Autogenerated return type of CreateCategory. */
export type CreateCategoryPayload = {
  __typename?: 'CreateCategoryPayload';
  category: Category;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateExamPaymentLink */
export type CreateExamPaymentLinkInput = {
  categoryId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  examMakerId: Scalars['String']['input'];
};

/** Autogenerated return type of CreateExamPaymentLink. */
export type CreateExamPaymentLinkPayload = {
  __typename?: 'CreateExamPaymentLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  isFree: Scalars['Boolean']['output'];
  paymentLink?: Maybe<PaymentLink>;
};

/** Autogenerated input type of CreateExamProduct */
export type CreateExamProductInput = {
  categoryId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  examAvailableFrom?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  examAvailableTo?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  examMakerId: Scalars['String']['input'];
  isFree?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  passingScore: Scalars['Int']['input'];
  price: Scalars['Int']['input'];
  requiredExamId?: InputMaybe<Scalars['ID']['input']>;
  requiredQuestId?: InputMaybe<Scalars['ID']['input']>;
  signupDescription?: InputMaybe<Scalars['String']['input']>;
  signupSlug?: InputMaybe<Scalars['String']['input']>;
  signupVisualAlt?: InputMaybe<Scalars['String']['input']>;
  signupVisualUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateExamProduct. */
export type CreateExamProductPayload = {
  __typename?: 'CreateExamProductPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  examProduct?: Maybe<ExamProduct>;
};

/** Autogenerated input type of CreateForm */
export type CreateFormInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  form: FormInput;
};

/** Autogenerated return type of CreateForm. */
export type CreateFormPayload = {
  __typename?: 'CreateFormPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  form?: Maybe<Form>;
};

/** Autogenerated input type of CreateFussyAccessToken */
export type CreateFussyAccessTokenInput = {
  callbackUrl: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  iconImageUrl?: InputMaybe<Scalars['String']['input']>;
  serviceName: Scalars['String']['input'];
  serviceUrl: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};

/** Autogenerated return type of CreateFussyAccessToken. */
export type CreateFussyAccessTokenPayload = {
  __typename?: 'CreateFussyAccessTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateLimitedContent */
export type CreateLimitedContentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  membershipIds: Array<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateLimitedContent. */
export type CreateLimitedContentPayload = {
  __typename?: 'CreateLimitedContentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  membershipLimitedContent?: Maybe<MembershipLimitedContent>;
};

/** Autogenerated input type of CreatePartnerCategoryMembership */
export type CreatePartnerCategoryMembershipInput = {
  categoryId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
  pricePerMonth: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

/** Autogenerated return type of CreatePartnerCategoryMembership. */
export type CreatePartnerCategoryMembershipPayload = {
  __typename?: 'CreatePartnerCategoryMembershipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  partnerCategoryMembership?: Maybe<PartnerCategoryMembership>;
};

/** Autogenerated input type of CreatePopCommentForm */
export type CreatePopCommentFormInput = {
  categoryIds: Array<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreatePopCommentForm. */
export type CreatePopCommentFormPayload = {
  __typename?: 'CreatePopCommentFormPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateQuest */
export type CreateQuestInput = {
  categoryId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  endAt: Scalars['ISO8601DateTime']['input'];
  fussyPoint: FussyPointInput;
  questTasks: Array<QuestTaskInput>;
  startAt: Scalars['ISO8601DateTime']['input'];
  title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateQuest. */
export type CreateQuestPayload = {
  __typename?: 'CreateQuestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  quest: Quest;
};

/** Autogenerated input type of CreateResponse */
export type CreateResponseInput = {
  answers: Array<AnswerInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  formId: Scalars['Int']['input'];
  /** step to UNDER_REVIEWING  */
  questTaskId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateResponse. */
export type CreateResponsePayload = {
  __typename?: 'CreateResponsePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  response?: Maybe<Response>;
};

/** Autogenerated input type of CreateSpecialMessage */
export type CreateSpecialMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  fussyAttestationIds: Array<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateSpecialMessage. */
export type CreateSpecialMessagePayload = {
  __typename?: 'CreateSpecialMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateUserExamResult */
export type CreateUserExamResultInput = {
  certificateImageUrl?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalExamId: Scalars['ID']['input'];
  responseId?: InputMaybe<Scalars['Int']['input']>;
  resultHash?: InputMaybe<Scalars['String']['input']>;
  score: Scalars['Float']['input'];
  squareExamPurchaseId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateUserExamResult. */
export type CreateUserExamResultPayload = {
  __typename?: 'CreateUserExamResultPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  userExamResult?: Maybe<UserExamResult>;
};

/** Autogenerated input type of CreateUserWithIdToken */
export type CreateUserWithIdTokenInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  firebaseIdToken: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** Autogenerated return type of CreateUserWithIdToken. */
export type CreateUserWithIdTokenPayload = {
  __typename?: 'CreateUserWithIdTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

/** Autogenerated input type of CreateYoutubeAccount */
export type CreateYoutubeAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  youtubeChannelId: Scalars['String']['input'];
};

/** Autogenerated return type of CreateYoutubeAccount. */
export type CreateYoutubeAccountPayload = {
  __typename?: 'CreateYoutubeAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DateAnswer = {
  __typename?: 'DateAnswer';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  question: Question;
  questionId: Scalars['Int']['output'];
  response: Response;
  responseId: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  value: Scalars['ISO8601Date']['output'];
};

export type DateAnswerInput = {
  value: Scalars['ISO8601Date']['input'];
};

/** Autogenerated input type of DeleteAccount */
export type DeleteAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DeleteAccount. */
export type DeleteAccountPayload = {
  __typename?: 'DeleteAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DetachGenre */
export type DetachGenreInput = {
  categoryId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  genreId: Scalars['Int']['input'];
};

/** Autogenerated return type of DetachGenre. */
export type DetachGenrePayload = {
  __typename?: 'DetachGenrePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DiscoveryAd = {
  __typename?: 'DiscoveryAd';
  content: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  endAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  imageUrl: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  shortDescription: Scalars['String']['output'];
  startAt: Scalars['ISO8601DateTime']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of DowngradeMembershipPlan */
export type DowngradeMembershipPlanInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currentMembershipId: Scalars['ID']['input'];
  newMembershipId: Scalars['ID']['input'];
};

/** Autogenerated return type of DowngradeMembershipPlan. */
export type DowngradeMembershipPlanPayload = {
  __typename?: 'DowngradeMembershipPlanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EditAnswer */
export type EditAnswerInput = {
  answer: AnswerInput;
  answerId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EditAnswer. */
export type EditAnswerPayload = {
  __typename?: 'EditAnswerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EditForm */
export type EditFormInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  formId: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EditForm. */
export type EditFormPayload = {
  __typename?: 'EditFormPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EditKintaiWebhookUrl */
export type EditKintaiWebhookUrlInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EditKintaiWebhookUrl. */
export type EditKintaiWebhookUrlPayload = {
  __typename?: 'EditKintaiWebhookUrlPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EditUser2 */
export type EditUser2Input = {
  avatarImageUrl: Scalars['String']['input'];
  bio: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Autogenerated return type of EditUser2. */
export type EditUser2Payload = {
  __typename?: 'EditUser2Payload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

/** Autogenerated input type of EditUser */
export type EditUserInput = {
  bio: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Autogenerated return type of EditUser. */
export type EditUserPayload = {
  __typename?: 'EditUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type EnabledMembership = {
  __typename?: 'EnabledMembership';
  expiredAt: Scalars['ISO8601DateTime']['output'];
  partnerCategoryMembership: PartnerCategoryMembership;
  startedAt: Scalars['ISO8601DateTime']['output'];
  userId: Scalars['Int']['output'];
};

export type ExamAccessValidation = {
  __typename?: 'ExamAccessValidation';
  /** ユーザーが検定にアクセス可能かどうか */
  canAccess: Scalars['Boolean']['output'];
  canRetake?: Maybe<Scalars['Boolean']['output']>;
  /** The purchase/access status (e.g., PURCHASED, TAKEN, NOT_PURCHASED, AUTH_REQUIRED, EXAM_NOT_FOUND) */
  status: Scalars['String']['output'];
};

export type ExamContent = {
  __typename?: 'ExamContent';
  categories: Array<Category>;
};

export type ExamDetails = {
  __typename?: 'ExamDetails';
  categoryId: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  examAvailableFrom?: Maybe<Scalars['ISO8601DateTime']['output']>;
  examAvailableTo?: Maybe<Scalars['ISO8601DateTime']['output']>;
  examMakerId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isFree: Scalars['Boolean']['output'];
  level?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  passingScore: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  questionCount: Scalars['Int']['output'];
};

export type ExamProduct = {
  __typename?: 'ExamProduct';
  categoryId: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  examAvailableFrom?: Maybe<Scalars['ISO8601DateTime']['output']>;
  examAvailableTo?: Maybe<Scalars['ISO8601DateTime']['output']>;
  examMakerId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  internalId: Scalars['String']['output'];
  isFree: Scalars['Boolean']['output'];
  level?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  passingScore: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  signupDescription?: Maybe<Scalars['String']['output']>;
  signupSlug?: Maybe<Scalars['String']['output']>;
  signupVisualAlt?: Maybe<Scalars['String']['output']>;
  signupVisualUrl?: Maybe<Scalars['String']['output']>;
  squareItemId?: Maybe<Scalars['String']['output']>;
  squareVariationId?: Maybe<Scalars['String']['output']>;
};

export type ExamRanking = {
  __typename?: 'ExamRanking';
  externalExamId: Scalars['ID']['output'];
  generatedAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
};

export type ExamRankingEntry = {
  __typename?: 'ExamRankingEntry';
  id: Scalars['ID']['output'];
  rank: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
  user: User;
};

export type ExamRankingResponse = {
  __typename?: 'ExamRankingResponse';
  entries: Array<ExamRankingEntry>;
  externalExam?: Maybe<ExternalExam>;
  isSufficientParticipants: Scalars['Boolean']['output'];
  minimumParticipantsRequired: Scalars['Int']['output'];
  participantCount: Scalars['Int']['output'];
  /** 満点合格者数（madososhi-advanced のみ算出） */
  perfectScoreCount: Scalars['Int']['output'];
  ranking?: Maybe<ExamRanking>;
  squareExamProduct?: Maybe<SquareExamProduct>;
};

/** Represents an external exam entity, potentially linked to a product */
export type ExternalExam = {
  __typename?: 'ExternalExam';
  category: Category;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** 受験開始日時 */
  examAvailableFrom?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 受験終了日時 */
  examAvailableTo?: Maybe<Scalars['ISO8601DateTime']['output']>;
  examMakerId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Internal ID for URL routing */
  internalId: Scalars['String']['output'];
  isFree: Scalars['Boolean']['output'];
  level?: Maybe<Scalars['Int']['output']>;
  /** The name of the exam product from SquareExamProduct */
  name: Scalars['String']['output'];
  passingScore: Scalars['Int']['output'];
  /** The price of the exam product from SquareExamProduct */
  price: Scalars['Int']['output'];
  /** Required quest for this exam */
  requiredQuest?: Maybe<Quest>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type FanLimitedContent = {
  __typename?: 'FanLimitedContent';
  content: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  fussyAttestations: Array<FussyAttestation>;
  id: Scalars['Int']['output'];
  publishedUser: User;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of FollowCategory */
export type FollowCategoryInput = {
  categoryId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of FollowCategory. */
export type FollowCategoryPayload = {
  __typename?: 'FollowCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Form = FussyEventReferenceEventableInterface & {
  __typename?: 'Form';
  categories: Array<Category>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description: Scalars['String']['output'];
  fussyEventReferences: Array<FussyEventReference>;
  id: Scalars['Int']['output'];
  labels: Array<FormLabel>;
  lastResponseAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  questions: Array<Question>;
  responseSize: Scalars['Int']['output'];
  responses: Array<Response>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
  userId: Scalars['Int']['output'];
};

export type FormInput = {
  categoryIds: Array<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
  questions: Array<QuestionInput>;
  title: Scalars['String']['input'];
};

export type FormLabel = {
  __typename?: 'FormLabel';
  id: Scalars['Int']['output'];
  name: FormLabelNameEnum;
};

export enum FormLabelNameEnum {
  /** Pop */
  Pop = 'pop',
  /** Recruit Quest */
  RecruitQuest = 'recruit_quest'
}

export type FussyAttestation = {
  __typename?: 'FussyAttestation';
  category: Category;
  createdAt: Scalars['ISO8601DateTime']['output'];
  fussyAttestationEvent: FussyAttestationEvent;
  fussyAttestationMethods: Array<FussyAttestationMethod>;
  fussyAttestedAchievement: FussyAttestedAchievement;
  holders: Array<User>;
  id: Scalars['Int']['output'];
  imageUrl: Scalars['String']['output'];
  issuers: Array<User>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type FussyAttestationCard = {
  __typename?: 'FussyAttestationCard';
  createdAt: Scalars['ISO8601DateTime']['output'];
  fussyAttestation: FussyAttestation;
  id: Scalars['Int']['output'];
  issuedAt: Scalars['ISO8601DateTime']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};

export type FussyAttestationEvent = {
  __typename?: 'FussyAttestationEvent';
  eventAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  /** @deprecated Use FUSSY Attestation Issuer */
  issuers: Array<User>;
  title: Scalars['String']['output'];
};

export type FussyAttestationMethod = {
  __typename?: 'FussyAttestationMethod';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type FussyAttestedAchievement = {
  __typename?: 'FussyAttestedAchievement';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum FussyEventEnum {
  CompleteQuest = 'COMPLETE_QUEST',
  CreateCategory = 'CREATE_CATEGORY',
  CreateForm = 'CREATE_FORM',
  CreateQuest = 'CREATE_QUEST',
  CreateResponse = 'CREATE_RESPONSE'
}

export type FussyEventReference = {
  __typename?: 'FussyEventReference';
  category: Category;
  eventAt: Scalars['ISO8601DateTime']['output'];
  eventable: FussyEventReferenceEventableInterface;
  eventableType?: Maybe<Scalars['String']['output']>;
  fussyEventType: FussyEventEnum;
  id: Scalars['Int']['output'];
};

export type FussyEventReferenceEventableInterface = {
  id: Scalars['Int']['output'];
};

export type FussyPoint = {
  __typename?: 'FussyPoint';
  category: Category;
  categoryId: Scalars['Int']['output'];
  creatorPoint: Scalars['Int']['output'];
  curatorPoint: Scalars['Int']['output'];
  evangelistPoint: Scalars['Int']['output'];
  expertPoint: Scalars['Int']['output'];
  supporterPoint: Scalars['Int']['output'];
  user: User;
  userId: Scalars['Int']['output'];
};

export type FussyPointInput = {
  creatorPoint: Scalars['Int']['input'];
  curatorPoint: Scalars['Int']['input'];
  evangelistPoint: Scalars['Int']['input'];
  expertPoint: Scalars['Int']['input'];
  supporterPoint: Scalars['Int']['input'];
};

export type FussyPointWithDate = {
  __typename?: 'FussyPointWithDate';
  date: Scalars['ISO8601Date']['output'];
  point: FussyPoint;
};

export type FussyPointWithMonth = {
  __typename?: 'FussyPointWithMonth';
  point: FussyPoint;
  yearAndMonth: Scalars['String']['output'];
};

export type Genre = {
  __typename?: 'Genre';
  categories: Array<Category>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type GeoLocation = {
  __typename?: 'GeoLocation';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

/** Autogenerated input type of GiveFan */
export type GiveFanInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fanId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

/** Autogenerated return type of GiveFan. */
export type GiveFanPayload = {
  __typename?: 'GiveFanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  fussyAttestationCard?: Maybe<FussyAttestationCard>;
};

/** Autogenerated input type of HideMembershipLimitedContent */
export type HideMembershipLimitedContentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of HideMembershipLimitedContent. */
export type HideMembershipLimitedContentPayload = {
  __typename?: 'HideMembershipLimitedContentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ImageUrlAnswer = {
  __typename?: 'ImageUrlAnswer';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  question: Question;
  questionId: Scalars['Int']['output'];
  response: Response;
  responseId: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  value: Scalars['String']['output'];
};

/** Autogenerated input type of IncrementVisitorCount */
export type IncrementVisitorCountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

/** Autogenerated return type of IncrementVisitorCount. */
export type IncrementVisitorCountPayload = {
  __typename?: 'IncrementVisitorCountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of IssueFussyAccessToken */
export type IssueFussyAccessTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
};

/** Autogenerated return type of IssueFussyAccessToken. */
export type IssueFussyAccessTokenPayload = {
  __typename?: 'IssueFussyAccessTokenPayload';
  accessToken?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of IssueMembershipLink */
export type IssueMembershipLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  partnerCategoryMembershipId: Scalars['Int']['input'];
};

/** Autogenerated return type of IssueMembershipLink. */
export type IssueMembershipLinkPayload = {
  __typename?: 'IssueMembershipLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of IssueShortenUrls */
export type IssueShortenUrlsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  keywords: Array<Scalars['String']['input']>;
  paths: Array<Scalars['String']['input']>;
};

/** Autogenerated return type of IssueShortenUrls. */
export type IssueShortenUrlsPayload = {
  __typename?: 'IssueShortenUrlsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  shortenUrls: Array<ShortenUrl>;
};

/** Autogenerated input type of KeepRadioResponse */
export type KeepRadioResponseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  radioResponseId: Scalars['Int']['input'];
};

/** Autogenerated return type of KeepRadioResponse. */
export type KeepRadioResponsePayload = {
  __typename?: 'KeepRadioResponsePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  radioResponse?: Maybe<RadioResponse>;
};

export type Kintai = {
  __typename?: 'Kintai';
  eventAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  isAttend: Scalars['Boolean']['output'];
  user: User;
};

export type LocationAnswer = {
  __typename?: 'LocationAnswer';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  question: Question;
  questionId: Scalars['Int']['output'];
  response: Response;
  responseId: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  value: GeoLocation;
};

export type LocationAnswerInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type LocationNearInput = {
  /** the unit is `meter` */
  distance: Scalars['Float']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type LongTextAnswer = {
  __typename?: 'LongTextAnswer';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  question: Question;
  questionId: Scalars['Int']['output'];
  response: Response;
  responseId: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  value: Scalars['String']['output'];
};

export enum MediumType {
  /** Audio */
  Audio = 'AUDIO',
  /** Image */
  Image = 'IMAGE',
  /** Video */
  Video = 'VIDEO'
}

export type MembershipLimitedContent = {
  __typename?: 'MembershipLimitedContent';
  content: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  hideAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** このコンテンツを視聴できるMembership */
  visiblePartnerCategoryMemberships: Array<PartnerCategoryMembership>;
};

/** Autogenerated input type of MintFan */
export type MintFanInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fanId: Scalars['Int']['input'];
};

/** Autogenerated return type of MintFan. */
export type MintFanPayload = {
  __typename?: 'MintFanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  fussyAttestationCard?: Maybe<FussyAttestationCard>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addGenre?: Maybe<AddGenrePayload>;
  addRadioResponse?: Maybe<AddRadioResponsePayload>;
  addRadioSegment?: Maybe<AddRadioSegmentPayload>;
  addYoutubeMembershipSubscriptionEvents?: Maybe<AddYoutubeMembershipSubscriptionEventsPayload>;
  adoptRadioResponse?: Maybe<AdoptRadioResponsePayload>;
  adoptRadioResponse2?: Maybe<AdoptRadioResponse2Payload>;
  applyQuestTaskDone: ApplyQuestTaskDonePayload;
  applyQuestTaskStart: ApplyQuestTaskStartPayload;
  attachGenre?: Maybe<AttachGenrePayload>;
  cancelPartnerCategoryMembership?: Maybe<CancelPartnerCategoryMembershipPayload>;
  changeOpenedAllNotifications?: Maybe<ChangeOpenedAllNotificationsPayload>;
  changeOpenedNotification?: Maybe<ChangeOpenedNotificationPayload>;
  changeResponseUser: ChangeResponseUserPayload;
  checkInKintai?: Maybe<CheckInKintaiPayload>;
  createCategory?: Maybe<CreateCategoryPayload>;
  createExamPaymentLink?: Maybe<CreateExamPaymentLinkPayload>;
  createExamProduct?: Maybe<CreateExamProductPayload>;
  createForm?: Maybe<CreateFormPayload>;
  createFussyAccessToken: CreateFussyAccessTokenPayload;
  createLimitedContent?: Maybe<CreateLimitedContentPayload>;
  /** Admin 向けメンバーシップの作成 */
  createPartnerCategoryMembership?: Maybe<CreatePartnerCategoryMembershipPayload>;
  createPopCommentForm: CreatePopCommentFormPayload;
  createQuest: CreateQuestPayload;
  createResponse?: Maybe<CreateResponsePayload>;
  createSpecialMessage?: Maybe<CreateSpecialMessagePayload>;
  createUserExamResult?: Maybe<CreateUserExamResultPayload>;
  createUserWithIdToken: CreateUserWithIdTokenPayload;
  createYoutubeAccount?: Maybe<CreateYoutubeAccountPayload>;
  /** Delete user account and all related data */
  deleteAccount?: Maybe<DeleteAccountPayload>;
  detachGenre?: Maybe<DetachGenrePayload>;
  downgradeMembershipPlan?: Maybe<DowngradeMembershipPlanPayload>;
  editAnswer?: Maybe<EditAnswerPayload>;
  editForm: EditFormPayload;
  editKintaiWebhookUrl?: Maybe<EditKintaiWebhookUrlPayload>;
  /** @deprecated use edit_user2 */
  editUser: EditUserPayload;
  editUser2: EditUser2Payload;
  followCategory: FollowCategoryPayload;
  giveFan?: Maybe<GiveFanPayload>;
  hideMembershipLimitedContent?: Maybe<HideMembershipLimitedContentPayload>;
  incrementVisitorCount?: Maybe<IncrementVisitorCountPayload>;
  /** you can get access token at once */
  issueFussyAccessToken?: Maybe<IssueFussyAccessTokenPayload>;
  /** 課金リンクの発行 */
  issueMembershipLink?: Maybe<IssueMembershipLinkPayload>;
  issueShortenUrls?: Maybe<IssueShortenUrlsPayload>;
  keepRadioResponse?: Maybe<KeepRadioResponsePayload>;
  mintFan?: Maybe<MintFanPayload>;
  /** ユーザーを会員に登録する */
  registerUserToMembership?: Maybe<RegisterUserToMembershipPayload>;
  rejectAdoptRadioResponse?: Maybe<RejectAdoptRadioResponsePayload>;
  rejectAdoptRadioResponse2?: Maybe<RejectAdoptRadioResponse2Payload>;
  rejectQuestTask?: Maybe<RejectQuestTaskPayload>;
  requestVerifyUserQuest: RequestVerifyUserQuestPayload;
  reshowMembershipLimitedContent?: Maybe<ReshowMembershipLimitedContentPayload>;
  sampleDiscordNotification?: Maybe<SampleDiscordNotificationPayload>;
  sendActivityLog: SendActivityLogPayload;
  startExam?: Maybe<StartExamPayload>;
  unKeepRadioResponse?: Maybe<UnKeepRadioResponsePayload>;
  unfollowCategory: UnfollowCategoryPayload;
  updateAuthorityRole?: Maybe<UpdateAuthorityRolePayload>;
  updateCertificateImage?: Maybe<UpdateCertificateImagePayload>;
  updateExamProduct?: Maybe<UpdateExamProductPayload>;
  updateFormLabel?: Maybe<UpdateFormLabelPayload>;
  updateSquareExamPurchase?: Maybe<UpdateSquareExamPurchasePayload>;
  updateUserAuthorityRoles?: Maybe<UpdateUserAuthorityRolesPayload>;
  upgradeMembershipPlan?: Maybe<UpgradeMembershipPlanPayload>;
  uploadExamSignupVisual?: Maybe<UploadSignupVisualPayload>;
  /** upload media file. Uploaded files are manage by fussy policy */
  uploadFile: UploadFilePayload;
  uploadStaticFile?: Maybe<UploadStaticFilePayload>;
  verifyUserQuestTask: VerifyUserQuestTaskPayload;
  writeBlogWithLlm: WriteBlogWithLlmPayload;
};


export type MutationAddGenreArgs = {
  input: AddGenreInput;
};


export type MutationAddRadioResponseArgs = {
  input: AddRadioResponseInput;
};


export type MutationAddRadioSegmentArgs = {
  input: AddRadioSegmentInput;
};


export type MutationAddYoutubeMembershipSubscriptionEventsArgs = {
  input: AddYoutubeMembershipSubscriptionEventsInput;
};


export type MutationAdoptRadioResponseArgs = {
  input: AdoptRadioResponseInput;
};


export type MutationAdoptRadioResponse2Args = {
  input: AdoptRadioResponse2Input;
};


export type MutationApplyQuestTaskDoneArgs = {
  input: ApplyQuestTaskDoneInput;
};


export type MutationApplyQuestTaskStartArgs = {
  input: ApplyQuestTaskStartInput;
};


export type MutationAttachGenreArgs = {
  input: AttachGenreInput;
};


export type MutationCancelPartnerCategoryMembershipArgs = {
  input: CancelPartnerCategoryMembershipInput;
};


export type MutationChangeOpenedAllNotificationsArgs = {
  input: ChangeOpenedAllNotificationsInput;
};


export type MutationChangeOpenedNotificationArgs = {
  input: ChangeOpenedNotificationInput;
};


export type MutationChangeResponseUserArgs = {
  input: ChangeResponseUserInput;
};


export type MutationCheckInKintaiArgs = {
  input: CheckInKintaiInput;
};


export type MutationCreateCategoryArgs = {
  input: CreateCategoryInput;
};


export type MutationCreateExamPaymentLinkArgs = {
  input: CreateExamPaymentLinkInput;
};


export type MutationCreateExamProductArgs = {
  input: CreateExamProductInput;
};


export type MutationCreateFormArgs = {
  input: CreateFormInput;
};


export type MutationCreateFussyAccessTokenArgs = {
  input: CreateFussyAccessTokenInput;
};


export type MutationCreateLimitedContentArgs = {
  input: CreateLimitedContentInput;
};


export type MutationCreatePartnerCategoryMembershipArgs = {
  input: CreatePartnerCategoryMembershipInput;
};


export type MutationCreatePopCommentFormArgs = {
  input: CreatePopCommentFormInput;
};


export type MutationCreateQuestArgs = {
  input: CreateQuestInput;
};


export type MutationCreateResponseArgs = {
  input: CreateResponseInput;
};


export type MutationCreateSpecialMessageArgs = {
  input: CreateSpecialMessageInput;
};


export type MutationCreateUserExamResultArgs = {
  input: CreateUserExamResultInput;
};


export type MutationCreateUserWithIdTokenArgs = {
  input: CreateUserWithIdTokenInput;
};


export type MutationCreateYoutubeAccountArgs = {
  input: CreateYoutubeAccountInput;
};


export type MutationDeleteAccountArgs = {
  input: DeleteAccountInput;
};


export type MutationDetachGenreArgs = {
  input: DetachGenreInput;
};


export type MutationDowngradeMembershipPlanArgs = {
  input: DowngradeMembershipPlanInput;
};


export type MutationEditAnswerArgs = {
  input: EditAnswerInput;
};


export type MutationEditFormArgs = {
  input: EditFormInput;
};


export type MutationEditKintaiWebhookUrlArgs = {
  input: EditKintaiWebhookUrlInput;
};


export type MutationEditUserArgs = {
  input: EditUserInput;
};


export type MutationEditUser2Args = {
  input: EditUser2Input;
};


export type MutationFollowCategoryArgs = {
  input: FollowCategoryInput;
};


export type MutationGiveFanArgs = {
  input: GiveFanInput;
};


export type MutationHideMembershipLimitedContentArgs = {
  input: HideMembershipLimitedContentInput;
};


export type MutationIncrementVisitorCountArgs = {
  input: IncrementVisitorCountInput;
};


export type MutationIssueFussyAccessTokenArgs = {
  input: IssueFussyAccessTokenInput;
};


export type MutationIssueMembershipLinkArgs = {
  input: IssueMembershipLinkInput;
};


export type MutationIssueShortenUrlsArgs = {
  input: IssueShortenUrlsInput;
};


export type MutationKeepRadioResponseArgs = {
  input: KeepRadioResponseInput;
};


export type MutationMintFanArgs = {
  input: MintFanInput;
};


export type MutationRegisterUserToMembershipArgs = {
  input: RegisterUserToMembershipInput;
};


export type MutationRejectAdoptRadioResponseArgs = {
  input: RejectAdoptRadioResponseInput;
};


export type MutationRejectAdoptRadioResponse2Args = {
  input: RejectAdoptRadioResponse2Input;
};


export type MutationRejectQuestTaskArgs = {
  input: RejectQuestTaskInput;
};


export type MutationRequestVerifyUserQuestArgs = {
  input: RequestVerifyUserQuestInput;
};


export type MutationReshowMembershipLimitedContentArgs = {
  input: ReshowMembershipLimitedContentInput;
};


export type MutationSampleDiscordNotificationArgs = {
  input: SampleDiscordNotificationInput;
};


export type MutationSendActivityLogArgs = {
  input: SendActivityLogInput;
};


export type MutationStartExamArgs = {
  input: StartExamInput;
};


export type MutationUnKeepRadioResponseArgs = {
  input: UnKeepRadioResponseInput;
};


export type MutationUnfollowCategoryArgs = {
  input: UnfollowCategoryInput;
};


export type MutationUpdateAuthorityRoleArgs = {
  input: UpdateAuthorityRoleInput;
};


export type MutationUpdateCertificateImageArgs = {
  input: UpdateCertificateImageInput;
};


export type MutationUpdateExamProductArgs = {
  input: UpdateExamProductInput;
};


export type MutationUpdateFormLabelArgs = {
  input: UpdateFormLabelInput;
};


export type MutationUpdateSquareExamPurchaseArgs = {
  input: UpdateSquareExamPurchaseInput;
};


export type MutationUpdateUserAuthorityRolesArgs = {
  input: UpdateUserAuthorityRolesInput;
};


export type MutationUpgradeMembershipPlanArgs = {
  input: UpgradeMembershipPlanInput;
};


export type MutationUploadExamSignupVisualArgs = {
  input: UploadSignupVisualInput;
};


export type MutationUploadFileArgs = {
  input: UploadFileInput;
};


export type MutationUploadStaticFileArgs = {
  input: UploadStaticFileInput;
};


export type MutationVerifyUserQuestTaskArgs = {
  input: VerifyUserQuestTaskInput;
};


export type MutationWriteBlogWithLlmArgs = {
  input: WriteBlogWithLlmInput;
};

export type NumberAnswer = {
  __typename?: 'NumberAnswer';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  question: Question;
  questionId: Scalars['Int']['output'];
  response: Response;
  responseId: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  value: Scalars['Int']['output'];
};

export type NumberAnswerInput = {
  value: Scalars['Int']['input'];
};

export enum OrderEnum {
  /** Ascending order */
  Asc = 'asc',
  /** Descending order */
  Desc = 'desc'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PartnerCategoryMembership = {
  __typename?: 'PartnerCategoryMembership';
  category: Category;
  closed: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  hasUserCanceled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isCurrentPlan: Scalars['Boolean']['output'];
  membershipLimitedContents: Array<MembershipLimitedContent>;
  partner: User;
  pricePerMonth: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type PaymentLink = {
  __typename?: 'PaymentLink';
  /** 支払いリンクのURL */
  url: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  authorityRoles: Array<AuthorityRole>;
  categories: Array<Category>;
  category: Category;
  currentUserQuestProgresses: Array<UserQuestProgress>;
  currentUserQuestTaskProgresses: Array<UserQuestTaskProgress>;
  /** 認証に利用する一時的なコードの発行 */
  currentUserQuestVerifyCode: Scalars['String']['output'];
  discoveryAd: DiscoveryAd;
  discoveryAds: Array<DiscoveryAd>;
  examContent: ExamContent;
  examRanking?: Maybe<ExamRankingResponse>;
  fanLimitedContents: Array<FanLimitedContent>;
  form: Form;
  forms: Array<Form>;
  fussyAttestation: FussyAttestation;
  fussyAttestations: Array<FussyAttestation>;
  fussyEventReferences: Array<FussyEventReference>;
  genre: Genre;
  genres: Array<Genre>;
  getAvailablePurchase?: Maybe<SquareExamPurchase>;
  getExamDetails?: Maybe<ExamDetails>;
  getExamResultByHash?: Maybe<UserExamResult>;
  /** current user's data. need access token */
  me: User;
  quest: Quest;
  questTask: QuestTask;
  quests: Array<Quest>;
  radioChannel: RadioChannel;
  radioChannels: Array<RadioChannel>;
  radioResponse: RadioResponse;
  radioResponses: Array<RadioResponse>;
  radioSegment: RadioSegment;
  radioSegments: Array<RadioSegment>;
  raid: CategoryRaid;
  raids: Array<CategoryRaid>;
  reachedFirstReleaseCapacity: Scalars['Boolean']['output'];
  response: Response;
  responses: Array<Response>;
  s3StaticFiles: Array<S3StaticFile>;
  serviceNotification: UserServiceNotification;
  serviceNotifications: Array<UserServiceNotification>;
  shortenUrl: ShortenUrl;
  shortenUrls: Array<ShortenUrl>;
  signupExamContext?: Maybe<SignupExamContext>;
  summarizedAllFandomVolumes: Array<SummarizedAllFandomVolume>;
  summarizedFanFandomVolumes: Array<SummarizedFanFandomVolume>;
  summarizedFussyMembershipFandomVolumes: Array<SummarizedFussyMembershipFandomVolume>;
  summarizedQuestCompletedFandomVolumes: Array<SummarizedQuestCompletedFandomVolume>;
  summarizedYoutubeMembershipFandomVolumes: Array<SummarizedYoutubeMembershipFandomVolume>;
  templateDbForms: Array<TemplateDbForm>;
  templateQuest: TemplateQuest;
  templateQuests: Array<TemplateQuest>;
  underReviewUserQuestTaskProgresses: Array<UserQuestTaskProgress>;
  /** find a user by access token */
  userByAccessToken?: Maybe<User>;
  /** find a user by firebase auth id */
  userByFirebaseAuthId?: Maybe<User>;
  /** Get user's exam attempts for a specific exam */
  userExamAttempts?: Maybe<Array<UserExamResult>>;
  userVisibleMembershipLimitedContents: Array<MembershipLimitedContent>;
  users: Array<User>;
  validateExamAccess: ExamAccessValidation;
};


export type QueryCategoriesArgs = {
  column?: InputMaybe<CategoryColumnEnum>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderEnum>;
};


export type QueryCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCurrentUserQuestProgressesArgs = {
  questIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryCurrentUserQuestTaskProgressesArgs = {
  questTaskIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryCurrentUserQuestVerifyCodeArgs = {
  questId: Scalars['Int']['input'];
};


export type QueryDiscoveryAdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDiscoveryAdsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryExamRankingArgs = {
  internalId: Scalars['String']['input'];
};


export type QueryFanLimitedContentsArgs = {
  categoryId: Scalars['Int']['input'];
};


export type QueryFormArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFormsArgs = {
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationNearby?: InputMaybe<LocationNearInput>;
  order?: InputMaybe<OrderEnum>;
};


export type QueryFussyAttestationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFussyEventReferencesArgs = {
  following?: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGenreArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetAvailablePurchaseArgs = {
  externalExamId: Scalars['ID']['input'];
  includeStarted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetExamDetailsArgs = {
  internalId: Scalars['String']['input'];
};


export type QueryGetExamResultByHashArgs = {
  resultHash: Scalars['String']['input'];
};


export type QueryQuestArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQuestTaskArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRadioChannelArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRadioChannelsArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRadioResponseArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRadioResponsesArgs = {
  radioSegmentId: Scalars['Int']['input'];
};


export type QueryRadioSegmentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRadioSegmentsArgs = {
  radioChannelId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRaidArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRaidsArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  raidIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryResponseArgs = {
  id: Scalars['Int']['input'];
};


export type QueryResponsesArgs = {
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  formIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  locationNearby?: InputMaybe<LocationNearInput>;
  order?: InputMaybe<OrderEnum>;
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryServiceNotificationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryServiceNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderEnum>;
};


export type QueryShortenUrlArgs = {
  token: Scalars['String']['input'];
};


export type QuerySignupExamContextArgs = {
  slug: Scalars['String']['input'];
};


export type QuerySummarizedAllFandomVolumesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderEnum>;
};


export type QuerySummarizedFanFandomVolumesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderEnum>;
};


export type QuerySummarizedFussyMembershipFandomVolumesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderEnum>;
};


export type QuerySummarizedQuestCompletedFandomVolumesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderEnum>;
};


export type QuerySummarizedYoutubeMembershipFandomVolumesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderEnum>;
};


export type QueryTemplateQuestArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUserByAccessTokenArgs = {
  accessToken: Scalars['String']['input'];
};


export type QueryUserByFirebaseAuthIdArgs = {
  firebaseAuthId: Scalars['String']['input'];
};


export type QueryUserExamAttemptsArgs = {
  externalExamId: Scalars['ID']['input'];
};


export type QueryUserVisibleMembershipLimitedContentsArgs = {
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  membershipIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryUsersArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryValidateExamAccessArgs = {
  internalId: Scalars['String']['input'];
};

export type Quest = FussyEventReferenceEventableInterface & {
  __typename?: 'Quest';
  category: Category;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creatorPoint: Scalars['Int']['output'];
  curatorPoint: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  endAt: Scalars['ISO8601DateTime']['output'];
  evangelistPoint: Scalars['Int']['output'];
  expertPoint: Scalars['Int']['output'];
  /** External exams that require this quest */
  externalExams: Array<ExternalExam>;
  fussyAttestations: Array<FussyAttestation>;
  fussyEventReferences: Array<FussyEventReference>;
  id: Scalars['Int']['output'];
  progress: UserQuestProgress;
  questGenreTags: Array<QuestGenreTag>;
  questTasks: Array<QuestTask>;
  startAt: Scalars['ISO8601DateTime']['output'];
  supporterPoint: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};

export type QuestGenreTag = {
  __typename?: 'QuestGenreTag';
  createdAt: Scalars['ISO8601DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  quests: Array<Quest>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type QuestTask = {
  __typename?: 'QuestTask';
  description: Scalars['String']['output'];
  form?: Maybe<Form>;
  id: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  progress?: Maybe<UserQuestTaskProgress>;
  quest: Quest;
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type QuestTaskInput = {
  description: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type Question = {
  __typename?: 'Question';
  answerType: AnswerTypeEnum;
  /** @deprecated Use `description` instead */
  content: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  form: Form;
  formId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type QuestionInput = {
  answerTypeEnum: AnswerTypeEnum;
  /** @deprecated Use `title`, `description` and `label` instead properly. */
  content?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type RadioChannel = {
  __typename?: 'RadioChannel';
  category: Category;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customer: User;
  id: Scalars['Int']['output'];
  radioSegments: Array<RadioSegment>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type RadioResponse = {
  __typename?: 'RadioResponse';
  content: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  featuredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  /** @deprecated Use `adopted_at` instead */
  isAdopted: Scalars['Boolean']['output'];
  isKept: Scalars['Boolean']['output'];
  radioSegment: RadioSegment;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
  userMediumReferences: Array<UserMediumReference>;
};

export type RadioSegment = {
  __typename?: 'RadioSegment';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  radioChannel: RadioChannel;
  radioResponses: Array<RadioResponse>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ReferenceAnswer = {
  __typename?: 'ReferenceAnswer';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  question: Question;
  questionId: Scalars['Int']['output'];
  /** referenced response */
  referencedResponse: Response;
  response: Response;
  responseId: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** referenced response id */
  value: Scalars['Int']['output'];
};

export type ReferenceAnswerInput = {
  /** response id for reference */
  value: Scalars['Int']['input'];
};

/** Autogenerated input type of RegisterUserToMembership */
export type RegisterUserToMembershipInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  squareSubscriptionId: Scalars['String']['input'];
};

/** Autogenerated return type of RegisterUserToMembership. */
export type RegisterUserToMembershipPayload = {
  __typename?: 'RegisterUserToMembershipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RejectAdoptRadioResponse2 */
export type RejectAdoptRadioResponse2Input = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  radioResponseId: Scalars['Int']['input'];
};

/** Autogenerated return type of RejectAdoptRadioResponse2. */
export type RejectAdoptRadioResponse2Payload = {
  __typename?: 'RejectAdoptRadioResponse2Payload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  radioResponse?: Maybe<RadioResponse>;
};

/** Autogenerated input type of RejectAdoptRadioResponse */
export type RejectAdoptRadioResponseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  radioResponseId: Scalars['Int']['input'];
};

/** Autogenerated return type of RejectAdoptRadioResponse. */
export type RejectAdoptRadioResponsePayload = {
  __typename?: 'RejectAdoptRadioResponsePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  radioResponse?: Maybe<RadioResponse>;
};

/** Autogenerated input type of RejectQuestTask */
export type RejectQuestTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userQuestTaskVerifyProgressId: Scalars['Int']['input'];
};

/** Autogenerated return type of RejectQuestTask. */
export type RejectQuestTaskPayload = {
  __typename?: 'RejectQuestTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of RequestVerifyUserQuest */
export type RequestVerifyUserQuestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  questId: Scalars['Int']['input'];
};

/** Autogenerated return type of RequestVerifyUserQuest. */
export type RequestVerifyUserQuestPayload = {
  __typename?: 'RequestVerifyUserQuestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ReshowMembershipLimitedContent */
export type ReshowMembershipLimitedContentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of ReshowMembershipLimitedContent. */
export type ReshowMembershipLimitedContentPayload = {
  __typename?: 'ReshowMembershipLimitedContentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Response = {
  __typename?: 'Response';
  answers: Array<AnswerUnion>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  form: Form;
  formId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
  userId: Scalars['Int']['output'];
};

export type S3StaticFile = {
  __typename?: 'S3StaticFile';
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Autogenerated input type of SampleDiscordNotification */
export type SampleDiscordNotificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
};

/** Autogenerated return type of SampleDiscordNotification. */
export type SampleDiscordNotificationPayload = {
  __typename?: 'SampleDiscordNotificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Autogenerated input type of SendActivityLog */
export type SendActivityLogInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  item: ActivityLogInput;
};

/** Autogenerated return type of SendActivityLog. */
export type SendActivityLogPayload = {
  __typename?: 'SendActivityLogPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum ServiceNotificationKindNameEnum {
  /** Complete quest event */
  CompleteQuestEvent = 'complete_quest_event',
  /** Create response event */
  CreateResponseEvent = 'create_response_event',
  /** Quest task rejected */
  QuestTaskRejected = 'quest_task_rejected',
  /** Report weekly action */
  ReportWeeklyAction = 'report_weekly_action',
  /** Response gained point */
  ResponseGainedPoint = 'response_gained_point',
  /** Special message */
  SpecialMessage = 'special_message'
}

export type ShortTextAnswer = {
  __typename?: 'ShortTextAnswer';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  question: Question;
  questionId: Scalars['Int']['output'];
  response: Response;
  responseId: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  value: Scalars['String']['output'];
};

export type ShortenUrl = {
  __typename?: 'ShortenUrl';
  createdAt: Scalars['ISO8601DateTime']['output'];
  destination: Scalars['String']['output'];
  shortenUrlExpandEvents: Array<ShortenUrlExpandEvent>;
  shortenUrlOgp?: Maybe<ShortenUrlOgp>;
  token: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
  visitorCount: Scalars['Int']['output'];
};

export type ShortenUrlExpandEvent = {
  __typename?: 'ShortenUrlExpandEvent';
  id: Scalars['Int']['output'];
  shortenUrlId: Scalars['Int']['output'];
};

export type ShortenUrlOgp = {
  __typename?: 'ShortenUrlOgp';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type SignupExamContext = {
  __typename?: 'SignupExamContext';
  categoryId: Scalars['ID']['output'];
  examDesc?: Maybe<Scalars['String']['output']>;
  examName: Scalars['String']['output'];
  examSlug: Scalars['String']['output'];
  examVisual?: Maybe<SignupExamVisual>;
  internalId: Scalars['String']['output'];
};

export type SignupExamVisual = {
  __typename?: 'SignupExamVisual';
  alt: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SquareExamProduct = {
  __typename?: 'SquareExamProduct';
  externalExamId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type SquareExamPurchase = {
  __typename?: 'SquareExamPurchase';
  createdAt: Scalars['ISO8601DateTime']['output'];
  examStatus: Scalars['String']['output'];
  externalExam: ExternalExam;
  externalExamId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  purchasedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  resultHash?: Maybe<Scalars['String']['output']>;
  squareOrderId: Scalars['String']['output'];
  squarePaymentId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  used: Scalars['Boolean']['output'];
  userId: Scalars['ID']['output'];
};

/** Autogenerated input type of StartExam */
export type StartExamInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  purchaseId: Scalars['ID']['input'];
};

/** Autogenerated return type of StartExam. */
export type StartExamPayload = {
  __typename?: 'StartExamPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  examStatus: Scalars['String']['output'];
  prerequisiteCategoryId?: Maybe<Scalars['ID']['output']>;
  prerequisiteExamId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SummarizedAllFandomVolume = {
  __typename?: 'SummarizedAllFandomVolume';
  category: Category;
  id: Scalars['Int']['output'];
  summarizedAt: Scalars['ISO8601Date']['output'];
  volume: Scalars['Int']['output'];
};

export type SummarizedFanFandomVolume = {
  __typename?: 'SummarizedFanFandomVolume';
  category: Category;
  fussyAttestation: FussyAttestation;
  id: Scalars['Int']['output'];
  summarizedAt: Scalars['ISO8601Date']['output'];
  volume: Scalars['Int']['output'];
};

export type SummarizedFussyMembershipFandomVolume = {
  __typename?: 'SummarizedFussyMembershipFandomVolume';
  category: Category;
  id: Scalars['Int']['output'];
  partnerCategoryMembership: PartnerCategoryMembership;
  summarizedAt: Scalars['ISO8601Date']['output'];
  volume: Scalars['Int']['output'];
};

export type SummarizedQuestCompletedFandomVolume = {
  __typename?: 'SummarizedQuestCompletedFandomVolume';
  category: Category;
  id: Scalars['Int']['output'];
  summarizedAt: Scalars['ISO8601Date']['output'];
  volume: Scalars['Int']['output'];
};

export type SummarizedYoutubeMembershipFandomVolume = {
  __typename?: 'SummarizedYoutubeMembershipFandomVolume';
  category: Category;
  id: Scalars['Int']['output'];
  summarizedAt: Scalars['ISO8601Date']['output'];
  volume: Scalars['Int']['output'];
};

export type TemplateDbForm = {
  __typename?: 'TemplateDbForm';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  templateDbQuestions: Array<TemplateDbQuestion>;
  title: Scalars['String']['output'];
};

export type TemplateDbQuestion = {
  __typename?: 'TemplateDbQuestion';
  answerType: AnswerTypeEnum;
  description?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type TemplateQuest = {
  __typename?: 'TemplateQuest';
  createdAt: Scalars['ISO8601DateTime']['output'];
  creatorPoint: Scalars['Int']['output'];
  curatorPoint: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  endAt: Scalars['ISO8601DateTime']['output'];
  evangelistPoint: Scalars['Int']['output'];
  expertPoint: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  startAt: Scalars['ISO8601DateTime']['output'];
  supporterPoint: Scalars['Int']['output'];
  templateQuestTasks: Array<TemplateQuestTask>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type TemplateQuestTask = {
  __typename?: 'TemplateQuestTask';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type TextAnswer = {
  __typename?: 'TextAnswer';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  question: Question;
  questionId: Scalars['Int']['output'];
  response: Response;
  responseId: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  value: Scalars['String']['output'];
};

export type TextAnswerInput = {
  value: Scalars['String']['input'];
};

/** Autogenerated input type of UnKeepRadioResponse */
export type UnKeepRadioResponseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  radioResponseId: Scalars['Int']['input'];
};

/** Autogenerated return type of UnKeepRadioResponse. */
export type UnKeepRadioResponsePayload = {
  __typename?: 'UnKeepRadioResponsePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  radioResponse?: Maybe<RadioResponse>;
};

/** Autogenerated input type of UnfollowCategory */
export type UnfollowCategoryInput = {
  categoryId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UnfollowCategory. */
export type UnfollowCategoryPayload = {
  __typename?: 'UnfollowCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateAuthorityRole */
export type UpdateAuthorityRoleInput = {
  authorityRoleId: Scalars['Int']['input'];
  boardDeletable: Scalars['Boolean']['input'];
  boardWritable: Scalars['Boolean']['input'];
  categoryDeletable: Scalars['Boolean']['input'];
  categoryWritable: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  databaseFormDeletable?: InputMaybe<Scalars['Boolean']['input']>;
  databaseFormWritable?: InputMaybe<Scalars['Boolean']['input']>;
  databaseResponseDeletable?: InputMaybe<Scalars['Boolean']['input']>;
  databaseResponseWritable?: InputMaybe<Scalars['Boolean']['input']>;
  notificationDeletable?: InputMaybe<Scalars['Boolean']['input']>;
  notificationWritable?: InputMaybe<Scalars['Boolean']['input']>;
  postDeletable: Scalars['Boolean']['input'];
  postWritable: Scalars['Boolean']['input'];
};

/** Autogenerated return type of UpdateAuthorityRole. */
export type UpdateAuthorityRolePayload = {
  __typename?: 'UpdateAuthorityRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  updatedAuthorityRole: AuthorityRole;
};

/** Autogenerated input type of UpdateCertificateImage */
export type UpdateCertificateImageInput = {
  certificateImageUrl: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userExamResultId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateCertificateImage. */
export type UpdateCertificateImagePayload = {
  __typename?: 'UpdateCertificateImagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  userExamResult?: Maybe<UserExamResult>;
};

/** Autogenerated input type of UpdateExamProduct */
export type UpdateExamProductInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  examAvailableFrom?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  examAvailableTo?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  id: Scalars['ID']['input'];
  isFree?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  signupDescription?: InputMaybe<Scalars['String']['input']>;
  signupSlug?: InputMaybe<Scalars['String']['input']>;
  signupVisualAlt?: InputMaybe<Scalars['String']['input']>;
  signupVisualUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateExamProduct. */
export type UpdateExamProductPayload = {
  __typename?: 'UpdateExamProductPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  examProduct?: Maybe<ExamProduct>;
};

/** Autogenerated input type of UpdateFormLabel */
export type UpdateFormLabelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  formId: Scalars['Int']['input'];
  labelNames: Array<FormLabelNameEnum>;
};

/** Autogenerated return type of UpdateFormLabel. */
export type UpdateFormLabelPayload = {
  __typename?: 'UpdateFormLabelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateSquareExamPurchase */
export type UpdateSquareExamPurchaseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  examStatus?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  resultHash?: InputMaybe<Scalars['String']['input']>;
  used?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateSquareExamPurchase. */
export type UpdateSquareExamPurchasePayload = {
  __typename?: 'UpdateSquareExamPurchasePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  purchase?: Maybe<SquareExamPurchase>;
};

/** Autogenerated input type of UpdateUserAuthorityRoles */
export type UpdateUserAuthorityRolesInput = {
  authorityRoleIds: Array<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};

/** Autogenerated return type of UpdateUserAuthorityRoles. */
export type UpdateUserAuthorityRolesPayload = {
  __typename?: 'UpdateUserAuthorityRolesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

/** Autogenerated input type of UpgradeMembershipPlan */
export type UpgradeMembershipPlanInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currentMembershipId: Scalars['ID']['input'];
  newMembershipId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpgradeMembershipPlan. */
export type UpgradeMembershipPlanPayload = {
  __typename?: 'UpgradeMembershipPlanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UploadFile */
export type UploadFileInput = {
  base64EncodedFile: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  public?: Scalars['Boolean']['input'];
};

/** Autogenerated return type of UploadFile. */
export type UploadFilePayload = {
  __typename?: 'UploadFilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  mediumReference: UserMediumReference;
  url: Scalars['String']['output'];
};

/** Autogenerated input type of UploadSignupVisual */
export type UploadSignupVisualInput = {
  base64EncodedFile: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UploadSignupVisual. */
export type UploadSignupVisualPayload = {
  __typename?: 'UploadSignupVisualPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

/** Autogenerated input type of UploadStaticFile */
export type UploadStaticFileInput = {
  base64EncodedFile: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
};

/** Autogenerated return type of UploadStaticFile. */
export type UploadStaticFilePayload = {
  __typename?: 'UploadStaticFilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type UrlAnswer = {
  __typename?: 'UrlAnswer';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  question: Question;
  questionId: Scalars['Int']['output'];
  response: Response;
  responseId: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  value: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  authorityRoles?: Maybe<AuthorityRoleConnection>;
  avatarImageUrl?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  completedQuests: Array<Quest>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  enabledMemberships: Array<EnabledMembership>;
  firebaseAuthId: Scalars['String']['output'];
  followingCategories: Array<Category>;
  forms: Array<Form>;
  fussyAttestationCards: Array<FussyAttestationCard>;
  fussyPoint?: Maybe<FussyPoint>;
  fussyPoints: Array<FussyPoint>;
  fussyPointsByDate: Array<FussyPointWithDate>;
  fussyPointsByMonth: Array<FussyPointWithMonth>;
  id: Scalars['Int']['output'];
  isAdmin: Scalars['Boolean']['output'];
  isPartner: Scalars['Boolean']['output'];
  isStaff: Scalars['Boolean']['output'];
  issuedFussyAttestations: Array<FussyAttestation>;
  kintaiWebhookUrl?: Maybe<Scalars['String']['output']>;
  kintais: Array<Kintai>;
  /** Partnerとして管理しているFave */
  managingCategories: Array<Category>;
  name: Scalars['String']['output'];
  radioResponses: Array<RadioResponse>;
  responses: Array<Response>;
  squareExamPurchases: Array<SquareExamPurchase>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userExamResults: Array<UserExamResult>;
  userQuestProgresses: Array<UserQuestProgress>;
  userQuestTaskProgresses: Array<UserQuestTaskProgress>;
};


export type UserAuthorityRolesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserFussyPointArgs = {
  categoryId: Scalars['Int']['input'];
};


export type UserFussyPointsArgs = {
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type UserResponsesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderEnum>;
};


export type UserSquareExamPurchasesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderEnum>;
};


export type UserUserExamResultsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderEnum>;
};


export type UserUserQuestProgressesArgs = {
  questIds: Array<Scalars['Int']['input']>;
};


export type UserUserQuestTaskProgressesArgs = {
  questTaskIds: Array<Scalars['Int']['input']>;
};

export type UserExamResult = {
  __typename?: 'UserExamResult';
  certificateImageUrl?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  externalExam: ExternalExam;
  externalExamId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  passed: Scalars['Boolean']['output'];
  responseId?: Maybe<Scalars['Int']['output']>;
  resultHash?: Maybe<Scalars['String']['output']>;
  score: Scalars['Float']['output'];
  squareExamPurchaseId: Scalars['ID']['output'];
  startedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type UserMediumReference = {
  __typename?: 'UserMediumReference';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  mediumType: MediumType;
  s3Key: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** うしろで S3 クライアントを使っているから、都度取得するようにする */
  url: Scalars['String']['output'];
  user: User;
  userId: Scalars['Int']['output'];
};

export type UserQuestProgress = {
  __typename?: 'UserQuestProgress';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  quest: Quest;
  questId: Scalars['Int']['output'];
  status: UserQuestProgressStatus;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userId: Scalars['Int']['output'];
};

/** ユーザーのクエスト進捗の状態 */
export enum UserQuestProgressStatus {
  /** 進行中 */
  Doing = 'doing',
  /** 未申請 */
  NotRequestedYet = 'not_requested_yet',
  /** 審査中 */
  UnderReviewing = 'under_reviewing',
  /** 承認済み */
  Verified = 'verified'
}

export type UserQuestTaskProgress = {
  __typename?: 'UserQuestTaskProgress';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  media: Array<UserMediumReference>;
  questTask: QuestTask;
  questTaskId: Scalars['Int']['output'];
  status: UserQuestTaskProgressStatus;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
  userId: Scalars['Int']['output'];
};

/** ユーザーのクエストタスク進捗の状態 */
export enum UserQuestTaskProgressStatus {
  /** 実施中 */
  Doing = 'doing',
  /**
   * 未申請
   * @deprecated not_started_yet に統合されました
   */
  NotRequestedYet = 'not_requested_yet',
  /** 未実施 */
  NotStartedYet = 'not_started_yet',
  /** 審査中 */
  UnderReviewing = 'under_reviewing',
  /** 承認済み */
  Verified = 'verified'
}

export type UserServiceNotification = {
  __typename?: 'UserServiceNotification';
  content: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  isRead: Scalars['Boolean']['output'];
  publishedUser: User;
  serviceNotificationKindName: ServiceNotificationKindNameEnum;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userId: Scalars['Int']['output'];
};

/** Autogenerated input type of VerifyUserQuestTask */
export type VerifyUserQuestTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  questTaskId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

/** Autogenerated return type of VerifyUserQuestTask. */
export type VerifyUserQuestTaskPayload = {
  __typename?: 'VerifyUserQuestTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of WriteBlogWithLlm */
export type WriteBlogWithLlmInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
};

/** Autogenerated return type of WriteBlogWithLlm. */
export type WriteBlogWithLlmPayload = {
  __typename?: 'WriteBlogWithLlmPayload';
  adviceText?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  draftText?: Maybe<Scalars['String']['output']>;
};

export type YoutubeMembershipSubscriptionEventsInput = {
  creatorChannelId: Scalars['String']['input'];
  memberSince: Scalars['ISO8601DateTime']['input'];
  memberTotalDurationMonths: Scalars['Int']['input'];
  userChannelId: Scalars['String']['input'];
};

export type AccountSignUpContentQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountSignUpContentQuery = { __typename?: 'Query', reachedFirstReleaseCapacity: boolean };

export type SignupExamContextQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type SignupExamContextQuery = { __typename?: 'Query', signupExamContext?: { __typename?: 'SignupExamContext', examSlug: string, examName: string, examDesc?: string | null, categoryId: string, internalId: string, examVisual?: { __typename?: 'SignupExamVisual', url: string, alt: string } | null } | null };

export type EditUserMutationVariables = Exact<{
  name: Scalars['String']['input'];
  bio: Scalars['String']['input'];
  avatarImageUrl: Scalars['String']['input'];
}>;


export type EditUserMutation = { __typename?: 'Mutation', editUser2: { __typename?: 'EditUser2Payload', user: { __typename?: 'User', id: number, name: string, bio?: string | null, avatarImageUrl?: string | null } } };

export type UploadFileForProfileMutationVariables = Exact<{
  input: UploadFileInput;
}>;


export type UploadFileForProfileMutation = { __typename?: 'Mutation', uploadFile: { __typename?: 'UploadFilePayload', url: string } };

export type DeleteAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAccountMutation = { __typename?: 'Mutation', deleteAccount?: { __typename?: 'DeleteAccountPayload', success: boolean } | null };

export type AdminCategoryAttachGenreQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminCategoryAttachGenreQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: number, name: string, genres: Array<{ __typename?: 'Genre', id: number, name: string }> }>, genres: Array<{ __typename?: 'Genre', id: number, name: string }> };

export type AttachGenreToCategoryMutationVariables = Exact<{
  input: AttachGenreInput;
}>;


export type AttachGenreToCategoryMutation = { __typename?: 'Mutation', attachGenre?: { __typename?: 'AttachGenrePayload', success: boolean } | null };

export type DetachGenreFromCategoryMutationVariables = Exact<{
  input: DetachGenreInput;
}>;


export type DetachGenreFromCategoryMutation = { __typename?: 'Mutation', detachGenre?: { __typename?: 'DetachGenrePayload', success: boolean } | null };

export type AddGenreMutationVariables = Exact<{
  input: AddGenreInput;
}>;


export type AddGenreMutation = { __typename?: 'Mutation', addGenre?: { __typename?: 'AddGenrePayload', genre: { __typename?: 'Genre', id: number, name: string } } | null };

export type AdminDatabaseTemplateDatabaseContentQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminDatabaseTemplateDatabaseContentQuery = { __typename?: 'Query', templateDbForms: Array<{ __typename?: 'TemplateDbForm', id: number, title: string, description: string, templateDbQuestions: Array<{ __typename?: 'TemplateDbQuestion', title: string, description?: string | null, label: string, answerType: AnswerTypeEnum, position: number }> }>, categories: Array<{ __typename?: 'Category', id: number, name: string, forms: Array<{ __typename?: 'Form', id: number, title: string }> }> };

export type AdminMembershipContentQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminMembershipContentQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: number, name: string, managingCategories: Array<{ __typename?: 'Category', id: number, name: string, partnerCategoryMemberships: Array<{ __typename?: 'PartnerCategoryMembership', id: number, title: string, description: string, pricePerMonth: number, closed: boolean, partner: { __typename?: 'User', id: number, name: string } }> }> }> };

export type CreateMembershipPlanMutationVariables = Exact<{
  input: CreatePartnerCategoryMembershipInput;
}>;


export type CreateMembershipPlanMutation = { __typename?: 'Mutation', createPartnerCategoryMembership?: { __typename?: 'CreatePartnerCategoryMembershipPayload', partnerCategoryMembership?: { __typename?: 'PartnerCategoryMembership', id: number, title: string, description: string, pricePerMonth: number } | null } | null };

export type IssuePaymentLinkMutationVariables = Exact<{
  input: IssueMembershipLinkInput;
}>;


export type IssuePaymentLinkMutation = { __typename?: 'Mutation', issueMembershipLink?: { __typename?: 'IssueMembershipLinkPayload', url?: string | null } | null };

export type IssueShortenUrlContentQueryVariables = Exact<{ [key: string]: never; }>;


export type IssueShortenUrlContentQuery = { __typename?: 'Query', shortenUrls: Array<{ __typename?: 'ShortenUrl', token: string, destination: string, createdAt: any }> };

export type IssueShortenUrlsMutationVariables = Exact<{
  paths: Array<Scalars['String']['input']> | Scalars['String']['input'];
  keywords: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type IssueShortenUrlsMutation = { __typename?: 'Mutation', issueShortenUrls?: { __typename?: 'IssueShortenUrlsPayload', shortenUrls: Array<{ __typename?: 'ShortenUrl', token: string, destination: string, createdAt: any, visitorCount: number }> } | null };

export type CategoriesContentQueryVariables = Exact<{ [key: string]: never; }>;


export type CategoriesContentQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: number, name: string, furigana: string, imageUrl?: string | null }> };

export type CreateCategoryMutationVariables = Exact<{
  name: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  furigana: Scalars['String']['input'];
}>;


export type CreateCategoryMutation = { __typename?: 'Mutation', createCategory?: { __typename?: 'CreateCategoryPayload', category: { __typename?: 'Category', id: number } } | null };

export type KintaiContentQueryVariables = Exact<{ [key: string]: never; }>;


export type KintaiContentQuery = { __typename?: 'Query', me: { __typename?: 'User', kintaiWebhookUrl?: string | null, kintais: Array<{ __typename?: 'Kintai', id: number, eventAt: any, isAttend: boolean }> } };

export type CheckKintaiMutationVariables = Exact<{
  isAttend: Scalars['Boolean']['input'];
  eventAt: Scalars['ISO8601DateTime']['input'];
}>;


export type CheckKintaiMutation = { __typename?: 'Mutation', checkInKintai?: { __typename?: 'CheckInKintaiPayload', kintai?: { __typename?: 'Kintai', id: number } | null } | null };

export type EditWebhookMutationVariables = Exact<{
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditWebhookMutation = { __typename?: 'Mutation', editKintaiWebhookUrl?: { __typename?: 'EditKintaiWebhookUrlPayload', success: boolean } | null };

export type SampleDiscordWebhookMutationVariables = Exact<{ [key: string]: never; }>;


export type SampleDiscordWebhookMutation = { __typename?: 'Mutation', sampleDiscordNotification?: { __typename?: 'SampleDiscordNotificationPayload', message: string } | null };

export type CreatePopCommentContentQueryVariables = Exact<{ [key: string]: never; }>;


export type CreatePopCommentContentQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: number, name: string }> };

export type FetchFormsByCategoriesQueryVariables = Exact<{
  categoryIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type FetchFormsByCategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: number, name: string, forms: Array<{ __typename?: 'Form', id: number, title: string }> }> };

export type CreatePopCommentFormMutationVariables = Exact<{
  categoryIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type CreatePopCommentFormMutation = { __typename?: 'Mutation', createPopCommentForm: { __typename?: 'CreatePopCommentFormPayload', success: boolean } };

export type ChangeResponseUserContentQueryVariables = Exact<{ [key: string]: never; }>;


export type ChangeResponseUserContentQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: number, name: string }>, forms: Array<{ __typename?: 'Form', id: number, title: string, responses: Array<{ __typename?: 'Response', id: number, createdAt: any, form: { __typename?: 'Form', id: number, title: string, questions: Array<{ __typename?: 'Question', id: number, position: number, label: string }> }, user: { __typename?: 'User', id: number, name: string }, answers: Array<{ __typename: 'DateAnswer', id: number, questionId: number, dateValue: any } | { __typename: 'ImageUrlAnswer', id: number, questionId: number, imageUrlValue: string } | { __typename: 'LocationAnswer', id: number, questionId: number, locationValue: { __typename?: 'GeoLocation', latitude: number, longitude: number } } | { __typename: 'LongTextAnswer', id: number, questionId: number, longTextValue: string } | { __typename: 'NumberAnswer', id: number, questionId: number, numberValue: number } | { __typename: 'ReferenceAnswer', id: number, questionId: number, referenceValue: number } | { __typename: 'ShortTextAnswer', id: number, questionId: number, shortTextValue: string } | { __typename: 'TextAnswer', id: number, questionId: number, textValue: string } | { __typename: 'UrlAnswer', id: number, questionId: number, urlValue: string }> }> }> };

export type ChangeResponseUserMutationVariables = Exact<{
  input: ChangeResponseUserInput;
}>;


export type ChangeResponseUserMutation = { __typename?: 'Mutation', changeResponseUser: { __typename?: 'ChangeResponseUserPayload', success: boolean } };

export type StaticFilesContentQueryVariables = Exact<{ [key: string]: never; }>;


export type StaticFilesContentQuery = { __typename?: 'Query', s3StaticFiles: Array<{ __typename?: 'S3StaticFile', key: string, url: string }> };

export type AdminQuestDetailContentQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type AdminQuestDetailContentQuery = { __typename?: 'Query', quest: { __typename?: 'Quest', id: number, title: string, description: string, startAt: any, endAt: any, curatorPoint: number, creatorPoint: number, evangelistPoint: number, supporterPoint: number, expertPoint: number, category: { __typename?: 'Category', id: number, name: string }, user: { __typename?: 'User', id: number, name: string }, questTasks: Array<{ __typename?: 'QuestTask', id: number, title: string, description: string, url?: string | null }> } };

export type AdminQuestCreateContentQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminQuestCreateContentQuery = { __typename?: 'Query', quests: Array<{ __typename?: 'Quest', id: number, title: string, description: string, questTasks: Array<{ __typename?: 'QuestTask', id: number, title: string, description: string, url?: string | null, position: number }> }>, categories: Array<{ __typename?: 'Category', id: number, name: string }> };

export type CreateQuestMutationVariables = Exact<{
  input: CreateQuestInput;
}>;


export type CreateQuestMutation = { __typename?: 'Mutation', createQuest: { __typename?: 'CreateQuestPayload', quest: { __typename?: 'Quest', id: number } } };

export type AdminQuestIndexContentQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminQuestIndexContentQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: number, name: string, quests: Array<{ __typename?: 'Quest', id: number, title: string }> }> };

export type AdminQuestTemplateContentQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminQuestTemplateContentQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: number, name: string, quests: Array<{ __typename?: 'Quest', id: number, title: string, startAt: any, endAt: any }>, forms: Array<{ __typename?: 'Form', id: number, title: string }> }>, templateQuests: Array<{ __typename?: 'TemplateQuest', id: number, title: string, description: string, startAt: any, endAt: any, creatorPoint: number, curatorPoint: number, evangelistPoint: number, expertPoint: number, supporterPoint: number, templateQuestTasks: Array<{ __typename?: 'TemplateQuestTask', position: number, title: string, description: string, url?: string | null }> }> };

export type VerifyQuestTaskContentQueryVariables = Exact<{ [key: string]: never; }>;


export type VerifyQuestTaskContentQuery = { __typename?: 'Query', underReviewUserQuestTaskProgresses: Array<{ __typename?: 'UserQuestTaskProgress', id: number, updatedAt: any, media: Array<{ __typename?: 'UserMediumReference', id: number, url: string }>, questTask: { __typename?: 'QuestTask', id: number, title: string, description: string, quest: { __typename?: 'Quest', id: number, title: string, description: string }, form?: { __typename?: 'Form', id: number, responses: Array<{ __typename?: 'Response', id: number, userId: number }> } | null }, user: { __typename?: 'User', id: number, name: string } }> };

export type VerifyQuestTaskMutationVariables = Exact<{
  input: VerifyUserQuestTaskInput;
}>;


export type VerifyQuestTaskMutation = { __typename?: 'Mutation', verifyUserQuestTask: { __typename?: 'VerifyUserQuestTaskPayload', success: boolean } };

export type RejectQuestTaskMutationVariables = Exact<{
  input: RejectQuestTaskInput;
}>;


export type RejectQuestTaskMutation = { __typename?: 'Mutation', rejectQuestTask?: { __typename?: 'RejectQuestTaskPayload', clientMutationId?: string | null } | null };

export type CreateFussyAccessTokenMutationVariables = Exact<{
  sessionId: Scalars['String']['input'];
  serviceName: Scalars['String']['input'];
  serviceUrl: Scalars['String']['input'];
  iconImageUrl?: InputMaybe<Scalars['String']['input']>;
  callbackUrl: Scalars['String']['input'];
}>;


export type CreateFussyAccessTokenMutation = { __typename?: 'Mutation', createFussyAccessToken: { __typename?: 'CreateFussyAccessTokenPayload', success: boolean } };

export type CategoryDetailMembershipIndexContentQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type CategoryDetailMembershipIndexContentQuery = { __typename?: 'Query', category: { __typename?: 'Category', id: number, name: string, partnerCategoryMemberships: Array<{ __typename?: 'PartnerCategoryMembership', id: number, title: string, description: string, pricePerMonth: number, closed: boolean, partner: { __typename?: 'User', id: number, name: string } }> } };

export type CategoryDetailMembershipDetailContentQueryVariables = Exact<{
  categoryId: Scalars['Int']['input'];
}>;


export type CategoryDetailMembershipDetailContentQuery = { __typename?: 'Query', category: { __typename?: 'Category', id: number, name: string, partnerCategoryMemberships: Array<{ __typename?: 'PartnerCategoryMembership', id: number, title: string, description: string, pricePerMonth: number, closed: boolean, partner: { __typename?: 'User', id: number, name: string } }> } };

export type RegisterMembershipMutationVariables = Exact<{
  subscriptionId: Scalars['String']['input'];
}>;


export type RegisterMembershipMutation = { __typename?: 'Mutation', registerUserToMembership?: { __typename?: 'RegisterUserToMembershipPayload', success: boolean } | null };

export type MeJoinedMembershipQueryVariables = Exact<{ [key: string]: never; }>;


export type MeJoinedMembershipQuery = { __typename?: 'Query', me: { __typename?: 'User', id: number, enabledMemberships: Array<{ __typename?: 'EnabledMembership', startedAt: any, expiredAt: any, partnerCategoryMembership: { __typename?: 'PartnerCategoryMembership', id: number, title: string, closed: boolean, isCurrentPlan: boolean, pricePerMonth: number, hasUserCanceled: boolean, category: { __typename?: 'Category', id: number } } }> } };

export type CategoryDetailsForGspQueryVariables = Exact<{ [key: string]: never; }>;


export type CategoryDetailsForGspQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: number }> };

export type CategoryDetailQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type CategoryDetailQuery = { __typename?: 'Query', category: { __typename?: 'Category', id: number, name: string, forms: Array<{ __typename?: 'Form', id: number, title: string, createdAt: any, lastResponseAt?: any | null, categories: Array<{ __typename?: 'Category', id: number, name: string }>, responses: Array<{ __typename?: 'Response', id: number }>, labels: Array<{ __typename?: 'FormLabel', id: number, name: FormLabelNameEnum }> }>, quests: Array<{ __typename?: 'Quest', id: number, title: string, description: string, startAt: any, endAt: any, createdAt: any, curatorPoint: number, creatorPoint: number, evangelistPoint: number, supporterPoint: number, expertPoint: number, questTasks: Array<{ __typename?: 'QuestTask', id: number, title: string, description: string, url?: string | null, position: number }>, user: { __typename?: 'User', id: number, name: string }, fussyAttestations: Array<{ __typename?: 'FussyAttestation', id: number, imageUrl: string }>, questGenreTags: Array<{ __typename?: 'QuestGenreTag', id: number, name: string }> }>, membershipLimitedContents: Array<{ __typename?: 'MembershipLimitedContent', id: number, title: string, createdAt: any, hideAt?: any | null, visiblePartnerCategoryMemberships: Array<{ __typename?: 'PartnerCategoryMembership', id: number, title: string }> }>, fanLimitedContents: Array<{ __typename?: 'FanLimitedContent', id: number, title: string, createdAt: any, fussyAttestations: Array<{ __typename?: 'FussyAttestation', id: number, imageUrl: string, fussyAttestationEvent: { __typename?: 'FussyAttestationEvent', id: number, title: string } }> }> } };

export type MeEligibleLimitationQueryVariables = Exact<{
  categoryId: Scalars['Int']['input'];
}>;


export type MeEligibleLimitationQuery = { __typename?: 'Query', me: { __typename?: 'User', fussyAttestationCards: Array<{ __typename?: 'FussyAttestationCard', fussyAttestation: { __typename?: 'FussyAttestation', id: number } }>, enabledMemberships: Array<{ __typename?: 'EnabledMembership', partnerCategoryMembership: { __typename?: 'PartnerCategoryMembership', id: number } }> }, fanLimitedContents: Array<{ __typename?: 'FanLimitedContent', id: number, title: string, content: string }> };

export type CategoryIndexContentQueryVariables = Exact<{ [key: string]: never; }>;


export type CategoryIndexContentQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: number, name: string, furigana: string, imageUrl?: string | null, accumulatedPoint: number, currentRaid?: { __typename?: 'CategoryRaid', id: number, stage: number, achievementPoint: number } | null, quests: Array<{ __typename?: 'Quest', id: number }>, genres: Array<{ __typename?: 'Genre', id: number, name: string }> }>, genres: Array<{ __typename?: 'Genre', id: number, name: string }> };

export type UserQuestProgressQueryVariables = Exact<{
  questIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  questTaskIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type UserQuestProgressQuery = { __typename?: 'Query', currentUserQuestProgresses: Array<{ __typename?: 'UserQuestProgress', id: number, questId: number, status: UserQuestProgressStatus }>, currentUserQuestTaskProgresses: Array<{ __typename?: 'UserQuestTaskProgress', id: number, questTaskId: number, status: UserQuestTaskProgressStatus }> };

export type RaidContentQueryVariables = Exact<{
  categoryId: Scalars['Int']['input'];
}>;


export type RaidContentQuery = { __typename?: 'Query', category: { __typename?: 'Category', raids: Array<{ __typename?: 'CategoryRaid', id: number, title: string, description: string, stage: number, bannerImageUrl: string, achievementPoint: number, achieved: boolean }> } };

export type CurrentUserNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserNotificationsQuery = { __typename?: 'Query', serviceNotifications: Array<{ __typename?: 'UserServiceNotification', id: number, isRead: boolean }> };

export type IsFollowingCategoryQueryVariables = Exact<{
  categoryId: Scalars['Int']['input'];
}>;


export type IsFollowingCategoryQuery = { __typename?: 'Query', category: { __typename?: 'Category', currentUserIsFollowing: boolean } };

export type IsFollowingCategoriesQueryVariables = Exact<{
  categoryIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type IsFollowingCategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: number, currentUserIsFollowing: boolean }> };

export type FollowCategoryMutationVariables = Exact<{
  categoryId: Scalars['Int']['input'];
}>;


export type FollowCategoryMutation = { __typename?: 'Mutation', followCategory: { __typename?: 'FollowCategoryPayload', success: boolean } };

export type UnfollowCategoryMutationVariables = Exact<{
  categoryId: Scalars['Int']['input'];
}>;


export type UnfollowCategoryMutation = { __typename?: 'Mutation', unfollowCategory: { __typename?: 'UnfollowCategoryPayload', success: boolean } };

export type ListCategoriesQueryVariables = Exact<{
  order?: InputMaybe<OrderEnum>;
  column?: InputMaybe<CategoryColumnEnum>;
}>;


export type ListCategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: number, name: string, currentUserIsFollowing: boolean }> };

export type CreateShortenUrlsMutationVariables = Exact<{
  paths: Array<Scalars['String']['input']> | Scalars['String']['input'];
  keywords: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CreateShortenUrlsMutation = { __typename?: 'Mutation', issueShortenUrls?: { __typename?: 'IssueShortenUrlsPayload', shortenUrls: Array<{ __typename?: 'ShortenUrl', token: string, destination: string, createdAt: any, visitorCount: number }> } | null };

export type DatabaseDetailContentQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DatabaseDetailContentQuery = { __typename?: 'Query', form: { __typename: 'Form', id: number, title: string, description: string, createdAt: any, responseSize: number, categories: Array<{ __typename?: 'Category', id: number, name: string }>, questions: Array<{ __typename?: 'Question', id: number, position: number, answerType: AnswerTypeEnum, title: string, description?: string | null, label: string }>, user: { __typename?: 'User', id: number, name: string } } };

export type DatabaseDetailTableContentQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DatabaseDetailTableContentQuery = { __typename?: 'Query', form: { __typename?: 'Form', responses: Array<{ __typename?: 'Response', id: number, createdAt: any, answers: Array<{ __typename: 'DateAnswer', id: number, position: number, questionId: number, dateValue: any } | { __typename: 'ImageUrlAnswer', id: number, position: number, questionId: number, imageUrlValue: string } | { __typename: 'LocationAnswer', id: number, position: number, questionId: number, locationValue: { __typename?: 'GeoLocation', latitude: number, longitude: number } } | { __typename: 'LongTextAnswer', id: number, position: number, questionId: number, longTextValue: string } | { __typename: 'NumberAnswer', id: number, position: number, questionId: number, numberValue: number } | { __typename: 'ReferenceAnswer', id: number, position: number, questionId: number, referenceValue: number } | { __typename: 'ShortTextAnswer', id: number, position: number, questionId: number, shortTextValue: string } | { __typename: 'TextAnswer', id: number, position: number, questionId: number, textValue: string } | { __typename: 'UrlAnswer', id: number, position: number, questionId: number, urlValue: string }>, user: { __typename?: 'User', id: number, name: string } }> } };

export type ResponseFragmentFragment = { __typename?: 'Response', id: number, createdAt: any, answers: Array<{ __typename: 'DateAnswer', id: number, position: number, questionId: number, dateValue: any } | { __typename: 'ImageUrlAnswer', id: number, position: number, questionId: number, imageUrlValue: string } | { __typename: 'LocationAnswer', id: number, position: number, questionId: number, locationValue: { __typename?: 'GeoLocation', latitude: number, longitude: number } } | { __typename: 'LongTextAnswer', id: number, position: number, questionId: number, longTextValue: string } | { __typename: 'NumberAnswer', id: number, position: number, questionId: number, numberValue: number } | { __typename: 'ReferenceAnswer', id: number, position: number, questionId: number, referenceValue: number } | { __typename: 'ShortTextAnswer', id: number, position: number, questionId: number, shortTextValue: string } | { __typename: 'TextAnswer', id: number, position: number, questionId: number, textValue: string } | { __typename: 'UrlAnswer', id: number, position: number, questionId: number, urlValue: string }>, user: { __typename?: 'User', id: number, name: string } };

export type CreateResponseMutationVariables = Exact<{
  input: CreateResponseInput;
}>;


export type CreateResponseMutation = { __typename?: 'Mutation', createResponse?: { __typename?: 'CreateResponsePayload', response?: { __typename?: 'Response', id: number } | null } | null };

export type EditAnswerMutationVariables = Exact<{
  input: EditAnswerInput;
}>;


export type EditAnswerMutation = { __typename?: 'Mutation', editAnswer?: { __typename?: 'EditAnswerPayload', success: boolean } | null };

export type UpdateFormMutationVariables = Exact<{
  input: EditFormInput;
}>;


export type UpdateFormMutation = { __typename?: 'Mutation', editForm: { __typename?: 'EditFormPayload', success: boolean } };

export type UploadFileForResponseMutationVariables = Exact<{
  input: UploadFileInput;
}>;


export type UploadFileForResponseMutation = { __typename?: 'Mutation', uploadFile: { __typename?: 'UploadFilePayload', url: string } };

export type DatabaseDetailCsvContentQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DatabaseDetailCsvContentQuery = { __typename?: 'Query', form: { __typename: 'Form', id: number, title: string, questions: Array<{ __typename?: 'Question', id: number, position: number, label: string }>, responses: Array<{ __typename?: 'Response', id: number, createdAt: any, answers: Array<{ __typename: 'DateAnswer', id: number, position: number, questionId: number, dateValue: any } | { __typename: 'ImageUrlAnswer', id: number, position: number, questionId: number, imageUrlValue: string } | { __typename: 'LocationAnswer', id: number, position: number, questionId: number, locationValue: { __typename?: 'GeoLocation', latitude: number, longitude: number } } | { __typename: 'LongTextAnswer', id: number, position: number, questionId: number, longTextValue: string } | { __typename: 'NumberAnswer', id: number, position: number, questionId: number, numberValue: number } | { __typename: 'ReferenceAnswer', id: number, position: number, questionId: number, referenceValue: number } | { __typename: 'ShortTextAnswer', id: number, position: number, questionId: number, shortTextValue: string } | { __typename: 'TextAnswer', id: number, position: number, questionId: number, textValue: string } | { __typename: 'UrlAnswer', id: number, position: number, questionId: number, urlValue: string }>, user: { __typename?: 'User', id: number, name: string } }> } };

export type DatabaseCreateContentQueryVariables = Exact<{ [key: string]: never; }>;


export type DatabaseCreateContentQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: number, name: string }> };

export type CreateFormMutationVariables = Exact<{
  input: CreateFormInput;
}>;


export type CreateFormMutation = { __typename?: 'Mutation', createForm?: { __typename?: 'CreateFormPayload', form?: { __typename?: 'Form', id: number } | null } | null };

export type DatabaseContentQueryVariables = Exact<{ [key: string]: never; }>;


export type DatabaseContentQuery = { __typename?: 'Query', forms: Array<{ __typename?: 'Form', id: number, title: string, description: string, createdAt: any, categories: Array<{ __typename?: 'Category', id: number, name: string }>, responses: Array<{ __typename?: 'Response', id: number }> }> };

export type CreateExamPaymentLinkMutationVariables = Exact<{
  input: CreateExamPaymentLinkInput;
}>;


export type CreateExamPaymentLinkMutation = { __typename?: 'Mutation', createExamPaymentLink?: { __typename?: 'CreateExamPaymentLinkPayload', isFree: boolean, errors: Array<string>, paymentLink?: { __typename?: 'PaymentLink', url: string } | null } | null };

export type CreateExamProductMutationVariables = Exact<{
  input: CreateExamProductInput;
}>;


export type CreateExamProductMutation = { __typename?: 'Mutation', createExamProduct?: { __typename?: 'CreateExamProductPayload', errors: Array<string>, examProduct?: { __typename?: 'ExamProduct', id: string, internalId: string, examMakerId: string, categoryId: number, name: string, price: number, level?: number | null, passingScore: number, description: string, isFree: boolean, signupSlug?: string | null, signupDescription?: string | null, signupVisualUrl?: string | null } | null } | null };

export type CreateUserExamResultMutationVariables = Exact<{
  input: CreateUserExamResultInput;
}>;


export type CreateUserExamResultMutation = { __typename?: 'Mutation', createUserExamResult?: { __typename?: 'CreateUserExamResultPayload', errors: Array<string>, userExamResult?: { __typename?: 'UserExamResult', id: string, userId: string, externalExamId: string, score: number, passed: boolean, resultHash?: string | null, responseId?: number | null, createdAt: any, updatedAt: any } | null } | null };

export type UpdateSquareExamPurchaseMutationVariables = Exact<{
  input: UpdateSquareExamPurchaseInput;
}>;


export type UpdateSquareExamPurchaseMutation = { __typename?: 'Mutation', updateSquareExamPurchase?: { __typename?: 'UpdateSquareExamPurchasePayload', errors: Array<string>, purchase?: { __typename?: 'SquareExamPurchase', id: string, used: boolean, status: string, examStatus: string, resultHash?: string | null, updatedAt: any } | null } | null };

export type UpdateCertificateImageMutationVariables = Exact<{
  input: UpdateCertificateImageInput;
}>;


export type UpdateCertificateImageMutation = { __typename?: 'Mutation', updateCertificateImage?: { __typename?: 'UpdateCertificateImagePayload', errors: Array<string>, userExamResult?: { __typename?: 'UserExamResult', id: string, certificateImageUrl?: string | null } | null } | null };

export type StartExamMutationVariables = Exact<{
  input: StartExamInput;
}>;


export type StartExamMutation = { __typename?: 'Mutation', startExam?: { __typename?: 'StartExamPayload', success: boolean, errors: Array<string>, examStatus: string, prerequisiteExamId?: string | null, prerequisiteCategoryId?: string | null } | null };

export type UploadCertificateImageMutationVariables = Exact<{
  input: UploadFileInput;
}>;


export type UploadCertificateImageMutation = { __typename?: 'Mutation', uploadFile: { __typename?: 'UploadFilePayload', url: string } };

export type ExamContentQueryVariables = Exact<{ [key: string]: never; }>;


export type ExamContentQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: number, name: string, examProducts: Array<{ __typename?: 'ExamProduct', id: string, internalId: string, examMakerId: string, categoryId: number, name: string, price: number, level?: number | null, passingScore: number, description: string, examAvailableFrom?: any | null, examAvailableTo?: any | null, isFree: boolean, signupSlug?: string | null, signupDescription?: string | null, signupVisualUrl?: string | null }> }> };

export type GetExamDetailsQueryVariables = Exact<{
  internalId: Scalars['String']['input'];
}>;


export type GetExamDetailsQuery = { __typename?: 'Query', getExamDetails?: { __typename?: 'ExamDetails', id: string, examMakerId: string, categoryId: string, name: string, price: number, level?: number | null, passingScore: number, description: string, examAvailableFrom?: any | null, examAvailableTo?: any | null, isFree: boolean } | null };

export type GetAvailablePurchaseQueryVariables = Exact<{
  externalExamId: Scalars['ID']['input'];
  includeStarted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAvailablePurchaseQuery = { __typename?: 'Query', getAvailablePurchase?: { __typename?: 'SquareExamPurchase', id: string, userId: string, externalExamId: string, squareOrderId: string, squarePaymentId?: string | null, used: boolean, status: string, examStatus: string, purchasedAt?: any | null, createdAt: any, updatedAt: any } | null };

export type ValidateExamAccessQueryVariables = Exact<{
  internalId: Scalars['String']['input'];
}>;


export type ValidateExamAccessQuery = { __typename?: 'Query', validateExamAccess: { __typename?: 'ExamAccessValidation', canAccess: boolean, status: string, canRetake?: boolean | null } };

export type GetExamResultByHashQueryVariables = Exact<{
  resultHash: Scalars['String']['input'];
}>;


export type GetExamResultByHashQuery = { __typename?: 'Query', getExamResultByHash?: { __typename?: 'UserExamResult', id: string, score: number, passed: boolean, squareExamPurchaseId: string, certificateImageUrl?: string | null, externalExam: { __typename?: 'ExternalExam', name: string, passingScore: number, examMakerId: string }, user: { __typename?: 'User', name: string } } | null };

export type UpdateExamProductMutationVariables = Exact<{
  input: UpdateExamProductInput;
}>;


export type UpdateExamProductMutation = { __typename?: 'Mutation', updateExamProduct?: { __typename?: 'UpdateExamProductPayload', errors: Array<string>, examProduct?: { __typename?: 'ExamProduct', id: string, examAvailableFrom?: any | null, examAvailableTo?: any | null, description: string, name: string, isFree: boolean, signupSlug?: string | null, signupDescription?: string | null, signupVisualUrl?: string | null } | null } | null };

export type UploadExamSignupVisualMutationVariables = Exact<{
  input: UploadSignupVisualInput;
}>;


export type UploadExamSignupVisualMutation = { __typename?: 'Mutation', uploadExamSignupVisual?: { __typename?: 'UploadSignupVisualPayload', url: string } | null };

export type GetExamRankingQueryVariables = Exact<{
  internalId: Scalars['String']['input'];
}>;


export type GetExamRankingQuery = { __typename?: 'Query', examRanking?: { __typename?: 'ExamRankingResponse', isSufficientParticipants: boolean, participantCount: number, minimumParticipantsRequired: number, externalExam?: { __typename?: 'ExternalExam', id: string, level?: number | null, name: string, isFree: boolean } | null, squareExamProduct?: { __typename?: 'SquareExamProduct', id: string, name: string } | null, ranking?: { __typename?: 'ExamRanking', id: string, generatedAt: any } | null, entries: Array<{ __typename?: 'ExamRankingEntry', id: string, rank: number, score: number, user: { __typename?: 'User', id: number, name: string, avatarImageUrl?: string | null } }> } | null };

export type ItemDetailQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ItemDetailQuery = { __typename?: 'Query', response: { __typename?: 'Response', id: number, createdAt: any, form: { __typename?: 'Form', id: number, title: string, questions: Array<{ __typename?: 'Question', id: number, position: number, label: string }> }, user: { __typename?: 'User', id: number, name: string }, answers: Array<{ __typename: 'DateAnswer', id: number, questionId: number, dateValue: any } | { __typename: 'ImageUrlAnswer', id: number, questionId: number, imageUrlValue: string } | { __typename: 'LocationAnswer', id: number, questionId: number, locationValue: { __typename?: 'GeoLocation', latitude: number, longitude: number } } | { __typename: 'LongTextAnswer', id: number, questionId: number, longTextValue: string } | { __typename: 'NumberAnswer', id: number, questionId: number, numberValue: number } | { __typename: 'ReferenceAnswer', id: number, questionId: number, referenceValue: number } | { __typename: 'ShortTextAnswer', id: number, questionId: number, shortTextValue: string } | { __typename: 'TextAnswer', id: number, questionId: number, textValue: string } | { __typename: 'UrlAnswer', id: number, questionId: number, urlValue: string }> } };

export type WriteBlogWithLlmForYabaiMutationVariables = Exact<{
  input: WriteBlogWithLlmInput;
}>;


export type WriteBlogWithLlmForYabaiMutation = { __typename?: 'Mutation', writeBlogWithLlm: { __typename?: 'WriteBlogWithLlmPayload', adviceText?: string | null, draftText?: string | null } };

export type FindUserQueryVariables = Exact<{
  firebaseAuthId: Scalars['String']['input'];
}>;


export type FindUserQuery = { __typename?: 'Query', userByFirebaseAuthId?: { __typename?: 'User', name: string, bio?: string | null } | null };

export type UserByFirebaseAuthIdQueryVariables = Exact<{
  firebaseAuthId: Scalars['String']['input'];
}>;


export type UserByFirebaseAuthIdQuery = { __typename?: 'Query', userByFirebaseAuthId?: { __typename?: 'User', name: string } | null };

export type CreateUserWithIdTokenMutationVariables = Exact<{
  name: Scalars['String']['input'];
  bio?: InputMaybe<Scalars['String']['input']>;
  firebaseIdToken: Scalars['String']['input'];
}>;


export type CreateUserWithIdTokenMutation = { __typename?: 'Mutation', createUserWithIdToken: { __typename?: 'CreateUserWithIdTokenPayload', user: { __typename?: 'User', id: number } } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: number, name: string, bio?: string | null, avatarImageUrl?: string | null, isAdmin: boolean } };

export type ListStaticFileUrlsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListStaticFileUrlsQuery = { __typename?: 'Query', s3StaticFiles: Array<{ __typename?: 'S3StaticFile', url: string }> };

export type CreateStaticFileMutationVariables = Exact<{
  base64EncodedFile: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
}>;


export type CreateStaticFileMutation = { __typename?: 'Mutation', uploadStaticFile?: { __typename?: 'UploadStaticFilePayload', url?: string | null } | null };

export type SendActivityLogMutationVariables = Exact<{
  actionName: Scalars['String']['input'];
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  dbFormId?: InputMaybe<Scalars['Int']['input']>;
  dbResponseId?: InputMaybe<Scalars['Int']['input']>;
  eventUnixTime: Scalars['Int']['input'];
  fac?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  pageName: Scalars['String']['input'];
  path: Scalars['String']['input'];
  questId?: InputMaybe<Scalars['Int']['input']>;
  userAgent: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendActivityLogMutation = { __typename?: 'Mutation', sendActivityLog: { __typename?: 'SendActivityLogPayload', success: boolean } };

export type MeShortAccountContentQueryVariables = Exact<{ [key: string]: never; }>;


export type MeShortAccountContentQuery = { __typename?: 'Query', me: { __typename?: 'User', id: number, name: string, bio?: string | null, avatarImageUrl?: string | null } };

export type PointFragment = { __typename?: 'FussyPoint', creatorPoint: number, curatorPoint: number, evangelistPoint: number, expertPoint: number, supporterPoint: number, category: { __typename?: 'Category', id: number, name: string } };

export type MePointReportQueryVariables = Exact<{ [key: string]: never; }>;


export type MePointReportQuery = { __typename?: 'Query', me: { __typename?: 'User', fussyPoints: Array<{ __typename?: 'FussyPoint', creatorPoint: number, curatorPoint: number, evangelistPoint: number, expertPoint: number, supporterPoint: number, category: { __typename?: 'Category', id: number, name: string } }>, fussyPointsByDate: Array<{ __typename?: 'FussyPointWithDate', date: any, point: { __typename?: 'FussyPoint', creatorPoint: number, curatorPoint: number, evangelistPoint: number, expertPoint: number, supporterPoint: number, category: { __typename?: 'Category', id: number, name: string } } }>, fussyPointsByMonth: Array<{ __typename?: 'FussyPointWithMonth', yearAndMonth: string, point: { __typename?: 'FussyPoint', creatorPoint: number, curatorPoint: number, evangelistPoint: number, expertPoint: number, supporterPoint: number, category: { __typename?: 'Category', id: number, name: string } } }> } };

export type MeQuestTaskContentQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuestTaskContentQuery = { __typename?: 'Query', me: { __typename?: 'User', userQuestTaskProgresses: Array<{ __typename?: 'UserQuestTaskProgress', id: number, status: UserQuestTaskProgressStatus, createdAt: any, media: Array<{ __typename?: 'UserMediumReference', id: number, url: string }>, questTask: { __typename?: 'QuestTask', id: number, title: string, description: string, quest: { __typename?: 'Quest', id: number, title: string, description: string } }, user: { __typename?: 'User', id: number, name: string } }> } };

export type MeCommittedDatabaseQueryVariables = Exact<{ [key: string]: never; }>;


export type MeCommittedDatabaseQuery = { __typename?: 'Query', me: { __typename?: 'User', responses: Array<{ __typename?: 'Response', createdAt: any, form: { __typename?: 'Form', id: number, title: string, categories: Array<{ __typename?: 'Category', id: number, name: string }> } }> } };

export type MeQuestContentQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuestContentQuery = { __typename?: 'Query', me: { __typename?: 'User', userQuestProgresses: Array<{ __typename?: 'UserQuestProgress', id: number, status: UserQuestProgressStatus, quest: { __typename?: 'Quest', id: number, title: string, creatorPoint: number, curatorPoint: number, evangelistPoint: number, expertPoint: number, supporterPoint: number, startAt: any, endAt: any, category: { __typename?: 'Category', id: number, name: string }, user: { __typename?: 'User', id: number, name: string } } }> } };

export type MeRadioResponseMemoryContentQueryVariables = Exact<{ [key: string]: never; }>;


export type MeRadioResponseMemoryContentQuery = { __typename?: 'Query', me: { __typename?: 'User', radioResponses: Array<{ __typename?: 'RadioResponse', id: number, content: string, isAdopted: boolean, createdAt: any, radioSegment: { __typename?: 'RadioSegment', id: number, name: string, radioChannel: { __typename?: 'RadioChannel', id: number, title: string } } }> } };

export type MeFussyAttestationContentQueryVariables = Exact<{ [key: string]: never; }>;


export type MeFussyAttestationContentQuery = { __typename?: 'Query', me: { __typename?: 'User', fussyAttestationCards: Array<{ __typename?: 'FussyAttestationCard', id: number, issuedAt: any, user: { __typename?: 'User', id: number, name: string }, fussyAttestation: { __typename?: 'FussyAttestation', id: number, imageUrl: string, issuers: Array<{ __typename?: 'User', id: number, name: string }>, fussyAttestationEvent: { __typename?: 'FussyAttestationEvent', id: number, title: string, eventAt?: any | null }, fussyAttestationMethods: Array<{ __typename?: 'FussyAttestationMethod', id: number, name: string }>, fussyAttestedAchievement: { __typename?: 'FussyAttestedAchievement', id: number, name: string } } }> } };

export type RegisterUserYoutubeAccountMutationVariables = Exact<{
  youtubeChannelId: Scalars['String']['input'];
}>;


export type RegisterUserYoutubeAccountMutation = { __typename?: 'Mutation', createYoutubeAccount?: { __typename?: 'CreateYoutubeAccountPayload', success: boolean } | null };

export type MeMembershipShortcutContentQueryVariables = Exact<{ [key: string]: never; }>;


export type MeMembershipShortcutContentQuery = { __typename?: 'Query', me: { __typename?: 'User', id: number, enabledMemberships: Array<{ __typename?: 'EnabledMembership', userId: number, startedAt: any, expiredAt: any, partnerCategoryMembership: { __typename?: 'PartnerCategoryMembership', id: number, title: string, pricePerMonth: number, closed: boolean, partner: { __typename?: 'User', id: number, name: string }, category: { __typename?: 'Category', id: number, name: string } } }> } };

export type MeExamHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type MeExamHistoryQuery = { __typename?: 'Query', me: { __typename?: 'User', userExamResults: Array<{ __typename?: 'UserExamResult', id: string, squareExamPurchaseId: string, resultHash?: string | null, completedAt?: any | null, createdAt: any, externalExam: { __typename?: 'ExternalExam', internalId: string, name: string, category: { __typename?: 'Category', id: number } } }>, squareExamPurchases: Array<{ __typename?: 'SquareExamPurchase', id: string, examStatus: string, resultHash?: string | null, purchasedAt?: any | null, createdAt: any, updatedAt: any, externalExam: { __typename?: 'ExternalExam', internalId: string, name: string, category: { __typename?: 'Category', id: number } } }> } };

export type CancelMembershipMutationVariables = Exact<{
  membershipId: Scalars['Int']['input'];
}>;


export type CancelMembershipMutation = { __typename?: 'Mutation', cancelPartnerCategoryMembership?: { __typename?: 'CancelPartnerCategoryMembershipPayload', success: boolean } | null };

export type MarkAsReadNotificationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type MarkAsReadNotificationMutation = { __typename?: 'Mutation', changeOpenedNotification?: { __typename?: 'ChangeOpenedNotificationPayload', success: boolean } | null };

export type MarkAsReadAllNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAsReadAllNotificationsMutation = { __typename?: 'Mutation', changeOpenedAllNotifications?: { __typename?: 'ChangeOpenedAllNotificationsPayload', success: boolean } | null };

export type NotificationIndexContentQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationIndexContentQuery = { __typename?: 'Query', serviceNotifications: Array<{ __typename?: 'UserServiceNotification', id: number, title: string, serviceNotificationKindName: ServiceNotificationKindNameEnum, isRead: boolean, createdAt: any, publishedUser: { __typename?: 'User', id: number, name: string } }> };

export type NotificationDetailContentQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type NotificationDetailContentQuery = { __typename?: 'Query', serviceNotification: { __typename?: 'UserServiceNotification', id: number, title: string, content: string, serviceNotificationKindName: ServiceNotificationKindNameEnum, isRead: boolean, createdAt: any, publishedUser: { __typename?: 'User', id: number, name: string } } };

export type FetchPartnerDetailAdminContentQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchPartnerDetailAdminContentQuery = { __typename?: 'Query', me: { __typename?: 'User', id: number, name: string, isPartner: boolean, issuedFussyAttestations: Array<{ __typename?: 'FussyAttestation', id: number, imageUrl: string, fussyAttestationEvent: { __typename?: 'FussyAttestationEvent', id: number, title: string, eventAt?: any | null }, fussyAttestationMethods: Array<{ __typename?: 'FussyAttestationMethod', id: number, name: string }>, holders: Array<{ __typename?: 'User', id: number }> }>, managingCategories: Array<{ __typename?: 'Category', id: number, name: string, partnerCategoryMemberships: Array<{ __typename?: 'PartnerCategoryMembership', id: number, title: string, description: string, pricePerMonth: number, closed: boolean }>, membershipLimitedContents: Array<{ __typename?: 'MembershipLimitedContent', id: number, title: string, content: string, createdAt: any, hideAt?: any | null, visiblePartnerCategoryMemberships: Array<{ __typename?: 'PartnerCategoryMembership', id: number, title: string, pricePerMonth: number }> }> }> } };

export type FetchPartnerDetailAdminContentUserDetailsQueryVariables = Exact<{
  categoryIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  userIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type FetchPartnerDetailAdminContentUserDetailsQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: number, name: string, fussyPoints: Array<{ __typename?: 'FussyPoint', creatorPoint: number, curatorPoint: number, expertPoint: number, evangelistPoint: number, supporterPoint: number, category: { __typename?: 'Category', id: number, name: string } }>, completedQuests: Array<{ __typename?: 'Quest', id: number, title: string, category: { __typename?: 'Category', id: number, name: string } }> }> };

export type CreateSpecialMessageMutationVariables = Exact<{
  title: Scalars['String']['input'];
  content: Scalars['String']['input'];
  attestationIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type CreateSpecialMessageMutation = { __typename?: 'Mutation', createSpecialMessage?: { __typename?: 'CreateSpecialMessagePayload', success: boolean } | null };

export type CreateMembershipLimitedMessageMutationVariables = Exact<{
  title: Scalars['String']['input'];
  content: Scalars['String']['input'];
  membershipIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type CreateMembershipLimitedMessageMutation = { __typename?: 'Mutation', createLimitedContent?: { __typename?: 'CreateLimitedContentPayload', membershipLimitedContent?: { __typename?: 'MembershipLimitedContent', id: number, title: string, content: string } | null } | null };

export type FetchMembershipLimitedContentQueryVariables = Exact<{
  membershipId: Scalars['Int']['input'];
}>;


export type FetchMembershipLimitedContentQuery = { __typename?: 'Query', userVisibleMembershipLimitedContents: Array<{ __typename?: 'MembershipLimitedContent', id: number, title: string, content: string, createdAt: any }> };

export type HideMembershipLimitedContentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type HideMembershipLimitedContentMutation = { __typename?: 'Mutation', hideMembershipLimitedContent?: { __typename?: 'HideMembershipLimitedContentPayload', success: boolean } | null };

export type ReshowMembershipLimitedContentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ReshowMembershipLimitedContentMutation = { __typename?: 'Mutation', reshowMembershipLimitedContent?: { __typename?: 'ReshowMembershipLimitedContentPayload', success: boolean } | null };

export type QuestDetailContentQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type QuestDetailContentQuery = { __typename?: 'Query', quest: { __typename?: 'Quest', id: number, title: string, description: string, startAt: any, endAt: any, creatorPoint: number, curatorPoint: number, expertPoint: number, evangelistPoint: number, supporterPoint: number, questTasks: Array<{ __typename?: 'QuestTask', id: number, title: string, description: string, url?: string | null, position: number, form?: { __typename?: 'Form', id: number, title: string, questions: Array<{ __typename?: 'Question', id: number, position: number, answerType: AnswerTypeEnum, title: string, description?: string | null, label: string }> } | null }>, user: { __typename?: 'User', id: number, name: string }, category: { __typename?: 'Category', id: number, name: string }, externalExams: Array<{ __typename?: 'ExternalExam', id: string, name: string, description?: string | null, examMakerId: string, internalId: string, examAvailableFrom?: any | null, examAvailableTo?: any | null }> } };

export type ApplyQuestTaskStartMutationVariables = Exact<{
  input: ApplyQuestTaskStartInput;
}>;


export type ApplyQuestTaskStartMutation = { __typename?: 'Mutation', applyQuestTaskStart: { __typename?: 'ApplyQuestTaskStartPayload', success: boolean } };

export type UploadEvidenceMutationVariables = Exact<{
  input: UploadFileInput;
}>;


export type UploadEvidenceMutation = { __typename?: 'Mutation', uploadFile: { __typename?: 'UploadFilePayload', url: string } };

export type ApplyQuestTaskDoneMutationVariables = Exact<{
  input: ApplyQuestTaskDoneInput;
}>;


export type ApplyQuestTaskDoneMutation = { __typename?: 'Mutation', applyQuestTaskDone: { __typename?: 'ApplyQuestTaskDonePayload', success: boolean } };

export type FetchCurrentUserVerifyCodeQueryVariables = Exact<{
  questId: Scalars['Int']['input'];
}>;


export type FetchCurrentUserVerifyCodeQuery = { __typename?: 'Query', currentUserQuestVerifyCode: string };

export type QuestIndexContentQueryVariables = Exact<{ [key: string]: never; }>;


export type QuestIndexContentQuery = { __typename?: 'Query', quests: Array<{ __typename?: 'Quest', id: number, title: string, description: string, startAt: any, endAt: any, createdAt: any, updatedAt: any, category: { __typename?: 'Category', id: number, name: string }, questTasks: Array<{ __typename?: 'QuestTask', id: number }> }>, categories: Array<{ __typename?: 'Category', id: number, name: string, furigana: string }> };

export type RadioChannelsForSsgQueryVariables = Exact<{ [key: string]: never; }>;


export type RadioChannelsForSsgQuery = { __typename?: 'Query', radioChannels: Array<{ __typename?: 'RadioChannel', id: number }> };

export type RadioFormContentQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RadioFormContentQuery = { __typename?: 'Query', radioChannel: { __typename?: 'RadioChannel', id: number, title: string, createdAt: any, updatedAt: any, customer: { __typename?: 'User', id: number, name: string }, category: { __typename?: 'Category', id: number, name: string }, radioSegments: Array<{ __typename?: 'RadioSegment', id: number, name: string }> } };

export type AddRadioResponseMutationVariables = Exact<{
  input: AddRadioResponseInput;
}>;


export type AddRadioResponseMutation = { __typename?: 'Mutation', addRadioResponse?: { __typename?: 'AddRadioResponsePayload', radioResponse?: { __typename?: 'RadioResponse', id: number } | null } | null };

export type UploadFileForRadioResponseMutationVariables = Exact<{
  input: UploadFileInput;
}>;


export type UploadFileForRadioResponseMutation = { __typename?: 'Mutation', uploadFile: { __typename?: 'UploadFilePayload', url: string, mediumReference: { __typename?: 'UserMediumReference', id: number, mediumType: MediumType } } };

export type RadioChannelsQueryVariables = Exact<{ [key: string]: never; }>;


export type RadioChannelsQuery = { __typename?: 'Query', radioChannels: Array<{ __typename?: 'RadioChannel', id: number, title: string, createdAt: any, updatedAt: any, category: { __typename?: 'Category', id: number, name: string }, customer: { __typename?: 'User', id: number, name: string }, radioSegments: Array<{ __typename?: 'RadioSegment', id: number, name: string }> }> };

export type RadioAdminContentQueryVariables = Exact<{
  channelId: Scalars['Int']['input'];
}>;


export type RadioAdminContentQuery = { __typename?: 'Query', radioChannel: { __typename?: 'RadioChannel', id: number, title: string, createdAt: any, updatedAt: any, customer: { __typename?: 'User', id: number, name: string, issuedFussyAttestations: Array<{ __typename?: 'FussyAttestation', id: number, category: { __typename?: 'Category', id: number, name: string }, fussyAttestationEvent: { __typename?: 'FussyAttestationEvent', id: number, title: string, eventAt?: any | null } }> }, category: { __typename?: 'Category', id: number, name: string }, radioSegments: Array<{ __typename?: 'RadioSegment', id: number, name: string, radioResponses: Array<{ __typename?: 'RadioResponse', id: number, content: string, createdAt: any, updatedAt: any, isAdopted: boolean, isKept: boolean, user: { __typename?: 'User', id: number, name: string }, userMediumReferences: Array<{ __typename?: 'UserMediumReference', id: number, url: string, mediumType: MediumType, createdAt: any }> }> }> } };

export type AddRadioSegmentMutationVariables = Exact<{
  input: AddRadioSegmentInput;
}>;


export type AddRadioSegmentMutation = { __typename?: 'Mutation', addRadioSegment?: { __typename?: 'AddRadioSegmentPayload', radioSegment?: { __typename?: 'RadioSegment', id: number } | null } | null };

export type AdoptRadioResponseMutationVariables = Exact<{
  input: AdoptRadioResponseInput;
}>;


export type AdoptRadioResponseMutation = { __typename?: 'Mutation', adoptRadioResponse?: { __typename?: 'AdoptRadioResponsePayload', radioResponse?: { __typename?: 'RadioResponse', id: number } | null } | null };

export type RejectRadioResponseMutationVariables = Exact<{
  input: RejectAdoptRadioResponseInput;
}>;


export type RejectRadioResponseMutation = { __typename?: 'Mutation', rejectAdoptRadioResponse?: { __typename?: 'RejectAdoptRadioResponsePayload', radioResponse?: { __typename?: 'RadioResponse', id: number } | null } | null };

export type KeepRadioResponseMutationVariables = Exact<{
  input: KeepRadioResponseInput;
}>;


export type KeepRadioResponseMutation = { __typename?: 'Mutation', keepRadioResponse?: { __typename?: 'KeepRadioResponsePayload', radioResponse?: { __typename?: 'RadioResponse', id: number } | null } | null };

export type UnKeepRadioResponseMutationVariables = Exact<{
  input: UnKeepRadioResponseInput;
}>;


export type UnKeepRadioResponseMutation = { __typename?: 'Mutation', unKeepRadioResponse?: { __typename?: 'UnKeepRadioResponsePayload', radioResponse?: { __typename?: 'RadioResponse', id: number } | null } | null };

export type GiveRadioFanMutationVariables = Exact<{
  input: GiveFanInput;
}>;


export type GiveRadioFanMutation = { __typename?: 'Mutation', giveFan?: { __typename?: 'GiveFanPayload', fussyAttestationCard?: { __typename?: 'FussyAttestationCard', id: number } | null } | null };

export type RaidIndexContentForSsgQueryVariables = Exact<{ [key: string]: never; }>;


export type RaidIndexContentForSsgQuery = { __typename?: 'Query', raids: Array<{ __typename?: 'CategoryRaid', id: number }> };

export type RaidDetailContentQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RaidDetailContentQuery = { __typename?: 'Query', raid: { __typename?: 'CategoryRaid', id: number, title: string, description: string, bannerImageUrl: string, stage: number, achievementPoint: number, category: { __typename?: 'Category', id: number, accumulatedPoint: number, name: string, raids: Array<{ __typename?: 'CategoryRaid', id: number, title: string, stage: number, bannerImageUrl: string }> } } };

export type ShareIndexContentQueryVariables = Exact<{ [key: string]: never; }>;


export type ShareIndexContentQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: number, name: string }> };

export type FetchSitemapContentQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchSitemapContentQuery = { __typename?: 'Query', forms: Array<{ __typename?: 'Form', id: number }>, categories: Array<{ __typename?: 'Category', id: number }>, responses: Array<{ __typename?: 'Response', id: number }>, quests: Array<{ __typename?: 'Quest', id: number }> };

export type RetrievePopCommentQueryVariables = Exact<{
  formIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type RetrievePopCommentQuery = { __typename?: 'Query', forms: Array<{ __typename?: 'Form', responses: Array<{ __typename?: 'Response', id: number, answers: Array<{ __typename: 'DateAnswer', id: number, position: number, dateValue: any } | { __typename: 'ImageUrlAnswer', id: number, position: number, imageUrlValue: string } | { __typename: 'LocationAnswer', id: number, position: number, locationValue: { __typename?: 'GeoLocation', latitude: number, longitude: number } } | { __typename: 'LongTextAnswer', id: number, position: number, longTextValue: string } | { __typename: 'NumberAnswer', id: number, position: number, numberValue: number } | { __typename: 'ReferenceAnswer', id: number, position: number, referenceValue: number } | { __typename: 'ShortTextAnswer', id: number, position: number, shortTextValue: string } | { __typename: 'TextAnswer', id: number, position: number, textValue: string } | { __typename: 'UrlAnswer', id: number, position: number, urlValue: string }>, user: { __typename?: 'User', id: number, name: string }, form: { __typename?: 'Form', categories: Array<{ __typename?: 'Category', id: number }> } }> }> };

export type CurrentUserQuestProgressQueryVariables = Exact<{
  questIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  questTaskIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type CurrentUserQuestProgressQuery = { __typename?: 'Query', me: { __typename?: 'User', id: number, name: string, userQuestProgresses: Array<{ __typename?: 'UserQuestProgress', id: number, status: UserQuestProgressStatus, questId: number }>, userQuestTaskProgresses: Array<{ __typename?: 'UserQuestTaskProgress', id: number, status: UserQuestTaskProgressStatus, questTaskId: number }> } };

export type SpecialLiveSaihateContentQueryVariables = Exact<{
  formId: Scalars['Int']['input'];
}>;


export type SpecialLiveSaihateContentQuery = { __typename?: 'Query', form: { __typename?: 'Form', id: number, questions: Array<{ __typename?: 'Question', id: number, position: number, answerType: AnswerTypeEnum }> } };

export type SpecialLiveSaihateCommentsQueryVariables = Exact<{
  formId: Scalars['Int']['input'];
}>;


export type SpecialLiveSaihateCommentsQuery = { __typename?: 'Query', form: { __typename?: 'Form', responses: Array<{ __typename?: 'Response', id: number, createdAt: any, answers: Array<{ __typename: 'DateAnswer', id: number, position: number, dateValue: any } | { __typename: 'ImageUrlAnswer', id: number, position: number, imageUrlValue: string } | { __typename: 'LocationAnswer', id: number, position: number, locationValue: { __typename?: 'GeoLocation', latitude: number, longitude: number } } | { __typename: 'LongTextAnswer', id: number, position: number, longTextValue: string } | { __typename: 'NumberAnswer', id: number, position: number, numberValue: number } | { __typename: 'ReferenceAnswer', id: number, position: number, referenceValue: number } | { __typename: 'ShortTextAnswer', id: number, position: number, shortTextValue: string } | { __typename: 'TextAnswer', id: number, position: number, textValue: string } | { __typename: 'UrlAnswer', id: number, position: number, urlValue: string }> }> } };

export type SpecialLiveSaihateCreateCommentMutationVariables = Exact<{
  input: CreateResponseInput;
}>;


export type SpecialLiveSaihateCreateCommentMutation = { __typename?: 'Mutation', createResponse?: { __typename?: 'CreateResponsePayload', response?: { __typename?: 'Response', id: number } | null } | null };

export type SpecialComedianRadio2024SpringContentQueryVariables = Exact<{ [key: string]: never; }>;


export type SpecialComedianRadio2024SpringContentQuery = { __typename?: 'Query', popForms: Array<{ __typename?: 'Form', id: number, categories: Array<{ __typename?: 'Category', id: number, name: string }>, questions: Array<{ __typename?: 'Question', id: number, position: number, answerType: AnswerTypeEnum }>, responses: Array<{ __typename?: 'Response', id: number, createdAt: any, answers: Array<{ __typename: 'DateAnswer', id: number, position: number, dateValue: any } | { __typename: 'ImageUrlAnswer', id: number, position: number, imageUrlValue: string } | { __typename: 'LocationAnswer', id: number, position: number, locationValue: { __typename?: 'GeoLocation', latitude: number, longitude: number } } | { __typename: 'LongTextAnswer', id: number, position: number, longTextValue: string } | { __typename: 'NumberAnswer', id: number, position: number, numberValue: number } | { __typename: 'ReferenceAnswer', id: number, position: number, referenceValue: number } | { __typename: 'ShortTextAnswer', id: number, position: number, shortTextValue: string } | { __typename: 'TextAnswer', id: number, position: number, textValue: string } | { __typename: 'UrlAnswer', id: number, position: number, urlValue: string }>, user: { __typename?: 'User', id: number, name: string } }> }>, recommendedForms: Array<{ __typename?: 'Form', id: number, categories: Array<{ __typename?: 'Category', id: number, name: string }>, questions: Array<{ __typename?: 'Question', id: number, position: number, answerType: AnswerTypeEnum }>, responses: Array<{ __typename?: 'Response', id: number, createdAt: any, answers: Array<{ __typename: 'DateAnswer', id: number, position: number, dateValue: any } | { __typename: 'ImageUrlAnswer', id: number, position: number, imageUrlValue: string } | { __typename: 'LocationAnswer', id: number, position: number, locationValue: { __typename?: 'GeoLocation', latitude: number, longitude: number } } | { __typename: 'LongTextAnswer', id: number, position: number, longTextValue: string } | { __typename: 'NumberAnswer', id: number, position: number, numberValue: number } | { __typename: 'ReferenceAnswer', id: number, position: number, referenceValue: number } | { __typename: 'ShortTextAnswer', id: number, position: number, shortTextValue: string } | { __typename: 'TextAnswer', id: number, position: number, textValue: string } | { __typename: 'UrlAnswer', id: number, position: number, urlValue: string }>, user: { __typename?: 'User', id: number, name: string } }> }>, listenerForms: Array<{ __typename?: 'Form', id: number, categories: Array<{ __typename?: 'Category', id: number, name: string }>, questions: Array<{ __typename?: 'Question', id: number, position: number, answerType: AnswerTypeEnum }>, responses: Array<{ __typename?: 'Response', id: number, createdAt: any, answers: Array<{ __typename: 'DateAnswer', id: number, position: number, dateValue: any } | { __typename: 'ImageUrlAnswer', id: number, position: number, imageUrlValue: string } | { __typename: 'LocationAnswer', id: number, position: number, locationValue: { __typename?: 'GeoLocation', latitude: number, longitude: number } } | { __typename: 'LongTextAnswer', id: number, position: number, longTextValue: string } | { __typename: 'NumberAnswer', id: number, position: number, numberValue: number } | { __typename: 'ReferenceAnswer', id: number, position: number, referenceValue: number } | { __typename: 'ShortTextAnswer', id: number, position: number, shortTextValue: string } | { __typename: 'TextAnswer', id: number, position: number, textValue: string } | { __typename: 'UrlAnswer', id: number, position: number, urlValue: string }>, user: { __typename?: 'User', id: number, name: string } }> }> };

export type RadioFormFragmentFragment = { __typename?: 'Form', id: number, categories: Array<{ __typename?: 'Category', id: number, name: string }>, questions: Array<{ __typename?: 'Question', id: number, position: number, answerType: AnswerTypeEnum }>, responses: Array<{ __typename?: 'Response', id: number, createdAt: any, answers: Array<{ __typename: 'DateAnswer', id: number, position: number, dateValue: any } | { __typename: 'ImageUrlAnswer', id: number, position: number, imageUrlValue: string } | { __typename: 'LocationAnswer', id: number, position: number, locationValue: { __typename?: 'GeoLocation', latitude: number, longitude: number } } | { __typename: 'LongTextAnswer', id: number, position: number, longTextValue: string } | { __typename: 'NumberAnswer', id: number, position: number, numberValue: number } | { __typename: 'ReferenceAnswer', id: number, position: number, referenceValue: number } | { __typename: 'ShortTextAnswer', id: number, position: number, shortTextValue: string } | { __typename: 'TextAnswer', id: number, position: number, textValue: string } | { __typename: 'UrlAnswer', id: number, position: number, urlValue: string }>, user: { __typename?: 'User', id: number, name: string } }> };

export type CheckInSaihateEvent202407MutationVariables = Exact<{ [key: string]: never; }>;


export type CheckInSaihateEvent202407Mutation = { __typename?: 'Mutation', mintFan?: { __typename?: 'MintFanPayload', fussyAttestationCard?: { __typename?: 'FussyAttestationCard', id: number } | null } | null };

export type SpecialWelcomeSaihateContentQueryVariables = Exact<{ [key: string]: never; }>;


export type SpecialWelcomeSaihateContentQuery = { __typename?: 'Query', forms: Array<{ __typename?: 'Form', id: number, title: string, description: string, responses: Array<{ __typename?: 'Response', id: number, createdAt: any, answers: Array<{ __typename: 'DateAnswer', id: number, position: number, dateValue: any } | { __typename: 'ImageUrlAnswer', id: number, position: number, imageUrlValue: string } | { __typename: 'LocationAnswer', id: number, position: number, locationValue: { __typename?: 'GeoLocation', latitude: number, longitude: number } } | { __typename: 'LongTextAnswer', id: number, position: number, longTextValue: string } | { __typename: 'NumberAnswer', id: number, position: number, numberValue: number } | { __typename: 'ReferenceAnswer', id: number, position: number, referenceValue: number } | { __typename: 'ShortTextAnswer', id: number, position: number, shortTextValue: string } | { __typename: 'TextAnswer', id: number, position: number, textValue: string } | { __typename: 'UrlAnswer', id: number, position: number, urlValue: string }>, user: { __typename?: 'User', id: number, name: string, avatarImageUrl?: string | null } }>, questions: Array<{ __typename?: 'Question', id: number, position: number, answerType: AnswerTypeEnum, title: string, description?: string | null, label: string }>, categories: Array<{ __typename?: 'Category', id: number, name: string }> }> };

export type FormResponseFragment = { __typename?: 'Response', id: number, createdAt: any, answers: Array<{ __typename: 'DateAnswer', id: number, position: number, dateValue: any } | { __typename: 'ImageUrlAnswer', id: number, position: number, imageUrlValue: string } | { __typename: 'LocationAnswer', id: number, position: number, locationValue: { __typename?: 'GeoLocation', latitude: number, longitude: number } } | { __typename: 'LongTextAnswer', id: number, position: number, longTextValue: string } | { __typename: 'NumberAnswer', id: number, position: number, numberValue: number } | { __typename: 'ReferenceAnswer', id: number, position: number, referenceValue: number } | { __typename: 'ShortTextAnswer', id: number, position: number, shortTextValue: string } | { __typename: 'TextAnswer', id: number, position: number, textValue: string } | { __typename: 'UrlAnswer', id: number, position: number, urlValue: string }>, user: { __typename?: 'User', id: number, name: string, avatarImageUrl?: string | null } };

export type CheckInAbcRadioMatsuri202411MutationVariables = Exact<{ [key: string]: never; }>;


export type CheckInAbcRadioMatsuri202411Mutation = { __typename?: 'Mutation', mintFan?: { __typename?: 'MintFanPayload', fussyAttestationCard?: { __typename?: 'FussyAttestationCard', id: number } | null } | null };

export type CheckInNyanPokoraFes202411MutationVariables = Exact<{ [key: string]: never; }>;


export type CheckInNyanPokoraFes202411Mutation = { __typename?: 'Mutation', mintFan?: { __typename?: 'MintFanPayload', fussyAttestationCard?: { __typename?: 'FussyAttestationCard', id: number } | null } | null };

export type FindDestinationQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type FindDestinationQuery = { __typename?: 'Query', shortenUrl: { __typename?: 'ShortenUrl', destination: string, shortenUrlOgp?: { __typename?: 'ShortenUrlOgp', id: number, title: string, description: string, imageUrl?: string | null } | null } };

export type IncrementVisitorCountMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type IncrementVisitorCountMutation = { __typename?: 'Mutation', incrementVisitorCount?: { __typename?: 'IncrementVisitorCountPayload', clientMutationId?: string | null } | null };

export type TopContentQueryVariables = Exact<{ [key: string]: never; }>;


export type TopContentQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: number, name: string, accumulatedPoint: number, imageUrl?: string | null, quests: Array<{ __typename?: 'Quest', id: number }>, currentRaid?: { __typename?: 'CategoryRaid', stage: number, achievementPoint: number } | null }>, fussyEventReferences: Array<{ __typename?: 'FussyEventReference', id: number, fussyEventType: FussyEventEnum, eventAt: any, eventable: { __typename: 'Category', id: number, name: string } | { __typename: 'Form', id: number, title: string } | { __typename: 'Quest', id: number, title: string }, category: { __typename?: 'Category', id: number, name: string } }> };

export type TopContentFollowingCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type TopContentFollowingCategoriesQuery = { __typename?: 'Query', me: { __typename?: 'User', followingCategories: Array<{ __typename?: 'Category', id: number, name: string, accumulatedPoint: number, imageUrl?: string | null, quests: Array<{ __typename?: 'Quest', id: number }>, currentRaid?: { __typename?: 'CategoryRaid', id: number, stage: number, achievementPoint: number } | null }> } };

export type TopContentJoinedMembershipContentsQueryVariables = Exact<{ [key: string]: never; }>;


export type TopContentJoinedMembershipContentsQuery = { __typename?: 'Query', userVisibleMembershipLimitedContents: Array<{ __typename?: 'MembershipLimitedContent', id: number, title: string, content: string, createdAt: any, visiblePartnerCategoryMemberships: Array<{ __typename?: 'PartnerCategoryMembership', id: number, title: string, pricePerMonth: number, category: { __typename?: 'Category', id: number, name: string } }> }> };

export type CurrentUserContentQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserContentQuery = { __typename?: 'Query', currentUserQuestProgresses: Array<{ __typename?: 'UserQuestProgress', questId: number, status: UserQuestProgressStatus, updatedAt: any, quest: { __typename?: 'Quest', id: number, title: string, description: string, startAt: any, endAt: any, category: { __typename?: 'Category', id: number, name: string } } }> };

export type DiscoveryFeedFragment = { __typename?: 'FussyEventReference', id: number, fussyEventType: FussyEventEnum, eventAt: any, eventable: { __typename: 'Category', id: number, name: string } | { __typename: 'Form', id: number, title: string } | { __typename: 'Quest', id: number, title: string }, category: { __typename?: 'Category', id: number, name: string } };

export const ResponseFragmentFragmentDoc = gql`
    fragment responseFragment on Response {
  id
  answers {
    __typename
    ... on LocationAnswer {
      id
      position
      locationValue: value {
        latitude
        longitude
      }
      questionId
    }
    ... on NumberAnswer {
      id
      position
      numberValue: value
      questionId
    }
    ... on TextAnswer {
      id
      position
      textValue: value
      questionId
    }
    ... on ReferenceAnswer {
      id
      position
      referenceValue: value
      questionId
    }
    ... on DateAnswer {
      id
      position
      dateValue: value
      questionId
    }
    ... on ShortTextAnswer {
      id
      position
      shortTextValue: value
      questionId
    }
    ... on LongTextAnswer {
      id
      position
      longTextValue: value
      questionId
    }
    ... on UrlAnswer {
      id
      position
      urlValue: value
      questionId
    }
    ... on ImageUrlAnswer {
      id
      position
      imageUrlValue: value
      questionId
    }
  }
  user {
    id
    name
  }
  createdAt
}
    `;
export const PointFragmentDoc = gql`
    fragment point on FussyPoint {
  category {
    id
    name
  }
  creatorPoint
  curatorPoint
  evangelistPoint
  expertPoint
  supporterPoint
}
    `;
export const RadioFormFragmentFragmentDoc = gql`
    fragment radioFormFragment on Form {
  id
  categories {
    id
    name
  }
  questions {
    id
    position
    answerType
  }
  responses {
    id
    createdAt
    answers {
      __typename
      ... on LocationAnswer {
        id
        position
        locationValue: value {
          latitude
          longitude
        }
      }
      ... on NumberAnswer {
        id
        position
        numberValue: value
      }
      ... on TextAnswer {
        id
        position
        textValue: value
      }
      ... on ReferenceAnswer {
        id
        position
        referenceValue: value
      }
      ... on DateAnswer {
        id
        position
        dateValue: value
      }
      ... on ShortTextAnswer {
        id
        position
        shortTextValue: value
      }
      ... on LongTextAnswer {
        id
        position
        longTextValue: value
      }
      ... on UrlAnswer {
        id
        position
        urlValue: value
      }
      ... on ImageUrlAnswer {
        id
        position
        imageUrlValue: value
      }
    }
    user {
      id
      name
    }
  }
}
    `;
export const FormResponseFragmentDoc = gql`
    fragment formResponse on Response {
  id
  createdAt
  answers {
    __typename
    ... on LocationAnswer {
      id
      position
      locationValue: value {
        latitude
        longitude
      }
    }
    ... on NumberAnswer {
      id
      position
      numberValue: value
    }
    ... on TextAnswer {
      id
      position
      textValue: value
    }
    ... on ReferenceAnswer {
      id
      position
      referenceValue: value
    }
    ... on DateAnswer {
      id
      position
      dateValue: value
    }
    ... on ShortTextAnswer {
      id
      position
      shortTextValue: value
    }
    ... on LongTextAnswer {
      id
      position
      longTextValue: value
    }
    ... on UrlAnswer {
      id
      position
      urlValue: value
    }
    ... on ImageUrlAnswer {
      id
      position
      imageUrlValue: value
    }
  }
  user {
    id
    name
    avatarImageUrl
  }
}
    `;
export const DiscoveryFeedFragmentDoc = gql`
    fragment discoveryFeed on FussyEventReference {
  id
  fussyEventType
  eventAt
  eventable {
    ... on Quest {
      __typename
      id
      title
    }
    ... on Category {
      __typename
      id
      name
    }
    ... on Form {
      __typename
      id
      title
    }
  }
  category {
    id
    name
  }
}
    `;
export const AccountSignUpContentDocument = gql`
    query accountSignUpContent {
  reachedFirstReleaseCapacity
}
    `;
export const SignupExamContextDocument = gql`
    query SignupExamContext($slug: String!) {
  signupExamContext(slug: $slug) {
    examSlug
    examName
    examDesc
    categoryId
    internalId
    examVisual {
      url
      alt
    }
  }
}
    `;
export const EditUserDocument = gql`
    mutation editUser($name: String!, $bio: String!, $avatarImageUrl: String!) {
  editUser2(input: {name: $name, bio: $bio, avatarImageUrl: $avatarImageUrl}) {
    user {
      id
      name
      bio
      avatarImageUrl
    }
  }
}
    `;
export const UploadFileForProfileDocument = gql`
    mutation uploadFileForProfile($input: UploadFileInput!) {
  uploadFile(input: $input) {
    url
  }
}
    `;
export const DeleteAccountDocument = gql`
    mutation deleteAccount {
  deleteAccount(input: {}) {
    success
  }
}
    `;
export const AdminCategoryAttachGenreDocument = gql`
    query adminCategoryAttachGenre {
  categories {
    id
    name
    genres {
      id
      name
    }
  }
  genres {
    id
    name
  }
}
    `;
export const AttachGenreToCategoryDocument = gql`
    mutation attachGenreToCategory($input: AttachGenreInput!) {
  attachGenre(input: $input) {
    success
  }
}
    `;
export const DetachGenreFromCategoryDocument = gql`
    mutation detachGenreFromCategory($input: DetachGenreInput!) {
  detachGenre(input: $input) {
    success
  }
}
    `;
export const AddGenreDocument = gql`
    mutation addGenre($input: AddGenreInput!) {
  addGenre(input: $input) {
    genre {
      id
      name
    }
  }
}
    `;
export const AdminDatabaseTemplateDatabaseContentDocument = gql`
    query adminDatabaseTemplateDatabaseContent {
  templateDbForms {
    id
    title
    description
    templateDbQuestions {
      title
      description
      label
      answerType
      position
    }
  }
  categories(order: asc, column: FURIGANA) {
    id
    name
    forms {
      id
      title
    }
  }
}
    `;
export const AdminMembershipContentDocument = gql`
    query adminMembershipContent {
  users {
    id
    name
    managingCategories {
      id
      name
      partnerCategoryMemberships {
        id
        title
        description
        pricePerMonth
        closed
        partner {
          id
          name
        }
      }
    }
  }
}
    `;
export const CreateMembershipPlanDocument = gql`
    mutation createMembershipPlan($input: CreatePartnerCategoryMembershipInput!) {
  createPartnerCategoryMembership(input: $input) {
    partnerCategoryMembership {
      id
      title
      description
      pricePerMonth
    }
  }
}
    `;
export const IssuePaymentLinkDocument = gql`
    mutation issuePaymentLink($input: IssueMembershipLinkInput!) {
  issueMembershipLink(input: $input) {
    url
  }
}
    `;
export const IssueShortenUrlContentDocument = gql`
    query issueShortenUrlContent {
  shortenUrls {
    token
    destination
    createdAt
  }
}
    `;
export const IssueShortenUrlsDocument = gql`
    mutation issueShortenUrls($paths: [String!]!, $keywords: [String!]!) {
  issueShortenUrls(input: {paths: $paths, keywords: $keywords}) {
    shortenUrls {
      token
      destination
      createdAt
      visitorCount
    }
  }
}
    `;
export const CategoriesContentDocument = gql`
    query categoriesContent {
  categories(order: asc, column: FURIGANA) {
    id
    name
    furigana
    imageUrl
  }
}
    `;
export const CreateCategoryDocument = gql`
    mutation createCategory($name: String!, $imageUrl: String, $furigana: String!) {
  createCategory(input: {name: $name, imageUrl: $imageUrl, furigana: $furigana}) {
    category {
      id
    }
  }
}
    `;
export const KintaiContentDocument = gql`
    query kintaiContent {
  me {
    kintais {
      id
      eventAt
      isAttend
    }
    kintaiWebhookUrl
  }
}
    `;
export const CheckKintaiDocument = gql`
    mutation checkKintai($isAttend: Boolean!, $eventAt: ISO8601DateTime!) {
  checkInKintai(input: {eventAt: $eventAt, isAttend: $isAttend}) {
    kintai {
      id
    }
  }
}
    `;
export const EditWebhookDocument = gql`
    mutation editWebhook($webhookUrl: String) {
  editKintaiWebhookUrl(input: {webhookUrl: $webhookUrl}) {
    success
  }
}
    `;
export const SampleDiscordWebhookDocument = gql`
    mutation sampleDiscordWebhook {
  sampleDiscordNotification(input: {message: "Hello, world!"}) {
    message
  }
}
    `;
export const CreatePopCommentContentDocument = gql`
    query createPopCommentContent {
  categories(order: asc, column: FURIGANA) {
    id
    name
  }
}
    `;
export const FetchFormsByCategoriesDocument = gql`
    query fetchFormsByCategories($categoryIds: [Int!]!) {
  categories(ids: $categoryIds) {
    id
    name
    forms {
      id
      title
    }
  }
}
    `;
export const CreatePopCommentFormDocument = gql`
    mutation createPopCommentForm($categoryIds: [Int!]!) {
  createPopCommentForm(input: {categoryIds: $categoryIds}) {
    success
  }
}
    `;
export const ChangeResponseUserContentDocument = gql`
    query changeResponseUserContent {
  users {
    id
    name
  }
  forms {
    id
    title
    responses {
      id
      form {
        id
        title
        questions {
          id
          position
          label
        }
      }
      user {
        id
        name
      }
      answers {
        ... on LongTextAnswer {
          __typename
          id
          questionId
          longTextValue: value
        }
        ... on ShortTextAnswer {
          __typename
          id
          questionId
          shortTextValue: value
        }
        ... on ReferenceAnswer {
          __typename
          id
          questionId
          referenceValue: value
        }
        ... on DateAnswer {
          __typename
          id
          questionId
          dateValue: value
        }
        ... on NumberAnswer {
          __typename
          id
          questionId
          numberValue: value
        }
        ... on LocationAnswer {
          __typename
          id
          questionId
          locationValue: value {
            latitude
            longitude
          }
        }
        ... on TextAnswer {
          __typename
          id
          questionId
          textValue: value
        }
        ... on UrlAnswer {
          __typename
          id
          questionId
          urlValue: value
        }
        ... on ImageUrlAnswer {
          __typename
          id
          questionId
          imageUrlValue: value
        }
      }
      createdAt
    }
  }
}
    `;
export const ChangeResponseUserDocument = gql`
    mutation changeResponseUser($input: ChangeResponseUserInput!) {
  changeResponseUser(input: $input) {
    success
  }
}
    `;
export const StaticFilesContentDocument = gql`
    query staticFilesContent {
  s3StaticFiles {
    key
    url
  }
}
    `;
export const AdminQuestDetailContentDocument = gql`
    query adminQuestDetailContent($id: Int!) {
  quest(id: $id) {
    id
    title
    description
    startAt
    endAt
    category {
      id
      name
    }
    user {
      id
      name
    }
    questTasks {
      id
      title
      description
      url
    }
    curatorPoint
    creatorPoint
    evangelistPoint
    supporterPoint
    expertPoint
  }
}
    `;
export const AdminQuestCreateContentDocument = gql`
    query adminQuestCreateContent {
  quests {
    id
    title
    description
    questTasks {
      id
      title
      description
      url
      position
    }
  }
  categories(column: FURIGANA, order: asc) {
    id
    name
  }
}
    `;
export const CreateQuestDocument = gql`
    mutation createQuest($input: CreateQuestInput!) {
  createQuest(input: $input) {
    quest {
      id
    }
  }
}
    `;
export const AdminQuestIndexContentDocument = gql`
    query adminQuestIndexContent {
  categories(order: asc, column: FURIGANA) {
    id
    name
    quests {
      id
      title
    }
  }
}
    `;
export const AdminQuestTemplateContentDocument = gql`
    query adminQuestTemplateContent {
  categories(column: FURIGANA, order: asc) {
    id
    name
    quests {
      id
      title
      startAt
      endAt
    }
    forms {
      id
      title
    }
  }
  templateQuests {
    id
    title
    description
    startAt
    endAt
    creatorPoint
    curatorPoint
    evangelistPoint
    expertPoint
    supporterPoint
    templateQuestTasks {
      position
      title
      description
      url
    }
  }
}
    `;
export const VerifyQuestTaskContentDocument = gql`
    query verifyQuestTaskContent {
  underReviewUserQuestTaskProgresses {
    id
    media {
      id
      url
    }
    questTask {
      id
      title
      description
      quest {
        id
        title
        description
      }
      form {
        id
        responses {
          id
          userId
        }
      }
    }
    user {
      id
      name
    }
    updatedAt
  }
}
    `;
export const VerifyQuestTaskDocument = gql`
    mutation verifyQuestTask($input: VerifyUserQuestTaskInput!) {
  verifyUserQuestTask(input: $input) {
    success
  }
}
    `;
export const RejectQuestTaskDocument = gql`
    mutation rejectQuestTask($input: RejectQuestTaskInput!) {
  rejectQuestTask(input: $input) {
    clientMutationId
  }
}
    `;
export const CreateFussyAccessTokenDocument = gql`
    mutation createFussyAccessToken($sessionId: String!, $serviceName: String!, $serviceUrl: String!, $iconImageUrl: String, $callbackUrl: String!) {
  createFussyAccessToken(
    input: {sessionId: $sessionId, serviceName: $serviceName, serviceUrl: $serviceUrl, iconImageUrl: $iconImageUrl, callbackUrl: $callbackUrl}
  ) {
    success
  }
}
    `;
export const CategoryDetailMembershipIndexContentDocument = gql`
    query categoryDetailMembershipIndexContent($id: Int!) {
  category(id: $id) {
    id
    name
    partnerCategoryMemberships {
      id
      title
      description
      pricePerMonth
      closed
      partner {
        id
        name
      }
    }
  }
}
    `;
export const CategoryDetailMembershipDetailContentDocument = gql`
    query categoryDetailMembershipDetailContent($categoryId: Int!) {
  category(id: $categoryId) {
    id
    name
    partnerCategoryMemberships {
      id
      title
      description
      pricePerMonth
      closed
      partner {
        id
        name
      }
    }
  }
}
    `;
export const RegisterMembershipDocument = gql`
    mutation registerMembership($subscriptionId: String!) {
  registerUserToMembership(input: {squareSubscriptionId: $subscriptionId}) {
    success
  }
}
    `;
export const MeJoinedMembershipDocument = gql`
    query meJoinedMembership {
  me {
    id
    enabledMemberships {
      startedAt
      expiredAt
      partnerCategoryMembership {
        id
        title
        closed
        isCurrentPlan
        pricePerMonth
        hasUserCanceled
        category {
          id
        }
      }
    }
  }
}
    `;
export const CategoryDetailsForGspDocument = gql`
    query categoryDetailsForGsp {
  categories {
    id
  }
}
    `;
export const CategoryDetailDocument = gql`
    query categoryDetail($id: Int!) {
  category(id: $id) {
    id
    name
    forms {
      id
      title
      categories {
        id
        name
      }
      responses {
        id
      }
      createdAt
      labels {
        id
        name
      }
      lastResponseAt
    }
    quests {
      id
      title
      description
      startAt
      endAt
      createdAt
      questTasks {
        id
        title
        description
        url
        position
      }
      curatorPoint
      creatorPoint
      evangelistPoint
      supporterPoint
      expertPoint
      user {
        id
        name
      }
      fussyAttestations {
        id
        imageUrl
      }
      questGenreTags {
        id
        name
      }
    }
    membershipLimitedContents {
      id
      title
      createdAt
      hideAt
      visiblePartnerCategoryMemberships {
        id
        title
      }
    }
    fanLimitedContents {
      id
      title
      createdAt
      fussyAttestations {
        id
        fussyAttestationEvent {
          id
          title
        }
        imageUrl
      }
    }
  }
}
    `;
export const MeEligibleLimitationDocument = gql`
    query meEligibleLimitation($categoryId: Int!) {
  me {
    fussyAttestationCards {
      fussyAttestation {
        id
      }
    }
    enabledMemberships {
      partnerCategoryMembership {
        id
      }
    }
  }
  fanLimitedContents(categoryId: $categoryId) {
    id
    title
    content
  }
}
    `;
export const CategoryIndexContentDocument = gql`
    query categoryIndexContent {
  categories(column: FURIGANA, order: asc) {
    id
    name
    furigana
    imageUrl
    currentRaid {
      id
      stage
      achievementPoint
    }
    quests {
      id
    }
    accumulatedPoint
    genres {
      id
      name
    }
  }
  genres {
    id
    name
  }
}
    `;
export const UserQuestProgressDocument = gql`
    query userQuestProgress($questIds: [Int!]!, $questTaskIds: [Int!]!) {
  currentUserQuestProgresses(questIds: $questIds) {
    id
    questId
    status
  }
  currentUserQuestTaskProgresses(questTaskIds: $questTaskIds) {
    id
    questTaskId
    status
  }
}
    `;
export const RaidContentDocument = gql`
    query raidContent($categoryId: Int!) {
  category(id: $categoryId) {
    raids {
      id
      title
      description
      stage
      bannerImageUrl
      achievementPoint
      achieved
    }
  }
}
    `;
export const CurrentUserNotificationsDocument = gql`
    query currentUserNotifications {
  serviceNotifications(limit: 100, order: desc) {
    id
    isRead
  }
}
    `;
export const IsFollowingCategoryDocument = gql`
    query isFollowingCategory($categoryId: Int!) {
  category(id: $categoryId) {
    currentUserIsFollowing
  }
}
    `;
export const IsFollowingCategoriesDocument = gql`
    query isFollowingCategories($categoryIds: [Int!]!) {
  categories(ids: $categoryIds) {
    id
    currentUserIsFollowing
  }
}
    `;
export const FollowCategoryDocument = gql`
    mutation followCategory($categoryId: Int!) {
  followCategory(input: {categoryId: $categoryId}) {
    success
  }
}
    `;
export const UnfollowCategoryDocument = gql`
    mutation unfollowCategory($categoryId: Int!) {
  unfollowCategory(input: {categoryId: $categoryId}) {
    success
  }
}
    `;
export const ListCategoriesDocument = gql`
    query listCategories($order: OrderEnum = asc, $column: CategoryColumnEnum = FURIGANA) {
  categories(order: $order, column: $column) {
    id
    name
    currentUserIsFollowing
  }
}
    `;
export const CreateShortenUrlsDocument = gql`
    mutation createShortenUrls($paths: [String!]!, $keywords: [String!]!) {
  issueShortenUrls(input: {paths: $paths, keywords: $keywords}) {
    shortenUrls {
      token
      destination
      createdAt
      visitorCount
    }
  }
}
    `;
export const DatabaseDetailContentDocument = gql`
    query databaseDetailContent($id: Int!) {
  form(id: $id) {
    __typename
    id
    title
    description
    createdAt
    categories {
      id
      name
    }
    questions {
      id
      position
      answerType
      title
      description
      label
    }
    user {
      id
      name
    }
    responseSize
  }
}
    `;
export const DatabaseDetailTableContentDocument = gql`
    query databaseDetailTableContent($id: Int!) {
  form(id: $id) {
    responses {
      ...responseFragment
    }
  }
}
    ${ResponseFragmentFragmentDoc}`;
export const CreateResponseDocument = gql`
    mutation createResponse($input: CreateResponseInput!) {
  createResponse(input: $input) {
    response {
      id
    }
  }
}
    `;
export const EditAnswerDocument = gql`
    mutation editAnswer($input: EditAnswerInput!) {
  editAnswer(input: $input) {
    success
  }
}
    `;
export const UpdateFormDocument = gql`
    mutation updateForm($input: EditFormInput!) {
  editForm(input: $input) {
    success
  }
}
    `;
export const UploadFileForResponseDocument = gql`
    mutation uploadFileForResponse($input: UploadFileInput!) {
  uploadFile(input: $input) {
    url
  }
}
    `;
export const DatabaseDetailCsvContentDocument = gql`
    query databaseDetailCsvContent($id: Int!) {
  form(id: $id) {
    __typename
    id
    title
    questions {
      id
      position
      label
    }
    responses {
      ...responseFragment
    }
  }
}
    ${ResponseFragmentFragmentDoc}`;
export const DatabaseCreateContentDocument = gql`
    query databaseCreateContent {
  categories(order: asc, column: FURIGANA) {
    id
    name
  }
}
    `;
export const CreateFormDocument = gql`
    mutation createForm($input: CreateFormInput!) {
  createForm(input: $input) {
    form {
      id
    }
  }
}
    `;
export const DatabaseContentDocument = gql`
    query databaseContent {
  forms(order: desc) {
    id
    title
    description
    createdAt
    categories {
      id
      name
    }
    responses {
      id
    }
  }
}
    `;
export const CreateExamPaymentLinkDocument = gql`
    mutation createExamPaymentLink($input: CreateExamPaymentLinkInput!) {
  createExamPaymentLink(input: $input) {
    paymentLink {
      url
    }
    isFree
    errors
  }
}
    `;
export const CreateExamProductDocument = gql`
    mutation CreateExamProduct($input: CreateExamProductInput!) {
  createExamProduct(input: $input) {
    examProduct {
      id
      internalId
      examMakerId
      categoryId
      name
      price
      level
      passingScore
      description
      isFree
      signupSlug
      signupDescription
      signupVisualUrl
    }
    errors
  }
}
    `;
export const CreateUserExamResultDocument = gql`
    mutation createUserExamResult($input: CreateUserExamResultInput!) {
  createUserExamResult(input: $input) {
    userExamResult {
      id
      userId
      externalExamId
      score
      passed
      resultHash
      responseId
      createdAt
      updatedAt
    }
    errors
  }
}
    `;
export const UpdateSquareExamPurchaseDocument = gql`
    mutation UpdateSquareExamPurchase($input: UpdateSquareExamPurchaseInput!) {
  updateSquareExamPurchase(input: $input) {
    purchase {
      id
      used
      status
      examStatus
      resultHash
      updatedAt
    }
    errors
  }
}
    `;
export const UpdateCertificateImageDocument = gql`
    mutation UpdateCertificateImage($input: UpdateCertificateImageInput!) {
  updateCertificateImage(input: $input) {
    userExamResult {
      id
      certificateImageUrl
    }
    errors
  }
}
    `;
export const StartExamDocument = gql`
    mutation StartExam($input: StartExamInput!) {
  startExam(input: $input) {
    success
    errors
    examStatus
    prerequisiteExamId
    prerequisiteCategoryId
  }
}
    `;
export const UploadCertificateImageDocument = gql`
    mutation uploadCertificateImage($input: UploadFileInput!) {
  uploadFile(input: $input) {
    url
  }
}
    `;
export const ExamContentDocument = gql`
    query examContent {
  categories {
    id
    name
    examProducts {
      id
      internalId
      examMakerId
      categoryId
      name
      price
      level
      passingScore
      description
      examAvailableFrom
      examAvailableTo
      isFree
      signupSlug
      signupDescription
      signupVisualUrl
    }
  }
}
    `;
export const GetExamDetailsDocument = gql`
    query GetExamDetails($internalId: String!) {
  getExamDetails(internalId: $internalId) {
    id
    examMakerId
    categoryId
    name
    price
    level
    passingScore
    description
    examAvailableFrom
    examAvailableTo
    isFree
  }
}
    `;
export const GetAvailablePurchaseDocument = gql`
    query GetAvailablePurchase($externalExamId: ID!, $includeStarted: Boolean = false) {
  getAvailablePurchase(
    externalExamId: $externalExamId
    includeStarted: $includeStarted
  ) {
    id
    userId
    externalExamId
    squareOrderId
    squarePaymentId
    used
    status
    examStatus
    purchasedAt
    createdAt
    updatedAt
  }
}
    `;
export const ValidateExamAccessDocument = gql`
    query validateExamAccess($internalId: String!) {
  validateExamAccess(internalId: $internalId) {
    canAccess
    status
    canRetake
  }
}
    `;
export const GetExamResultByHashDocument = gql`
    query GetExamResultByHash($resultHash: String!) {
  getExamResultByHash(resultHash: $resultHash) {
    id
    score
    passed
    squareExamPurchaseId
    certificateImageUrl
    externalExam {
      name
      passingScore
      examMakerId
    }
    user {
      name
    }
  }
}
    `;
export const UpdateExamProductDocument = gql`
    mutation updateExamProduct($input: UpdateExamProductInput!) {
  updateExamProduct(input: $input) {
    examProduct {
      id
      examAvailableFrom
      examAvailableTo
      description
      name
      isFree
      signupSlug
      signupDescription
      signupVisualUrl
    }
    errors
  }
}
    `;
export const UploadExamSignupVisualDocument = gql`
    mutation uploadExamSignupVisual($input: UploadSignupVisualInput!) {
  uploadExamSignupVisual(input: $input) {
    url
  }
}
    `;
export const GetExamRankingDocument = gql`
    query GetExamRanking($internalId: String!) {
  examRanking(internalId: $internalId) {
    externalExam {
      id
      level
      name
      isFree
    }
    squareExamProduct {
      id
      name
    }
    ranking {
      id
      generatedAt
    }
    entries {
      id
      rank
      score
      user {
        id
        name
        avatarImageUrl
      }
    }
    isSufficientParticipants
    participantCount
    minimumParticipantsRequired
  }
}
    `;
export const ItemDetailDocument = gql`
    query itemDetail($id: Int!) {
  response(id: $id) {
    id
    form {
      id
      title
      questions {
        id
        position
        label
      }
    }
    user {
      id
      name
    }
    answers {
      ... on LongTextAnswer {
        __typename
        id
        questionId
        longTextValue: value
      }
      ... on ShortTextAnswer {
        __typename
        id
        questionId
        shortTextValue: value
      }
      ... on ReferenceAnswer {
        __typename
        id
        questionId
        referenceValue: value
      }
      ... on DateAnswer {
        __typename
        id
        questionId
        dateValue: value
      }
      ... on NumberAnswer {
        __typename
        id
        questionId
        numberValue: value
      }
      ... on LocationAnswer {
        __typename
        id
        questionId
        locationValue: value {
          latitude
          longitude
        }
      }
      ... on TextAnswer {
        __typename
        id
        questionId
        textValue: value
      }
      ... on UrlAnswer {
        __typename
        id
        questionId
        urlValue: value
      }
      ... on ImageUrlAnswer {
        __typename
        id
        questionId
        imageUrlValue: value
      }
    }
    createdAt
  }
}
    `;
export const WriteBlogWithLlmForYabaiDocument = gql`
    mutation writeBlogWithLlmForYabai($input: WriteBlogWithLlmInput!) {
  writeBlogWithLlm(input: $input) {
    adviceText
    draftText
  }
}
    `;
export const FindUserDocument = gql`
    query findUser($firebaseAuthId: String!) {
  userByFirebaseAuthId(firebaseAuthId: $firebaseAuthId) {
    name
    bio
  }
}
    `;
export const UserByFirebaseAuthIdDocument = gql`
    query userByFirebaseAuthId($firebaseAuthId: String!) {
  userByFirebaseAuthId(firebaseAuthId: $firebaseAuthId) {
    name
  }
}
    `;
export const CreateUserWithIdTokenDocument = gql`
    mutation createUserWithIdToken($name: String!, $bio: String, $firebaseIdToken: String!) {
  createUserWithIdToken(
    input: {name: $name, bio: $bio, firebaseIdToken: $firebaseIdToken}
  ) {
    user {
      id
    }
  }
}
    `;
export const MeDocument = gql`
    query me {
  me {
    id
    name
    bio
    avatarImageUrl
    isAdmin
  }
}
    `;
export const ListStaticFileUrlsDocument = gql`
    query listStaticFileUrls {
  s3StaticFiles {
    url
  }
}
    `;
export const CreateStaticFileDocument = gql`
    mutation createStaticFile($base64EncodedFile: String!, $fileName: String!) {
  uploadStaticFile(
    input: {base64EncodedFile: $base64EncodedFile, fileName: $fileName}
  ) {
    url
  }
}
    `;
export const SendActivityLogDocument = gql`
    mutation sendActivityLog($actionName: String!, $categoryId: Int, $dbFormId: Int, $dbResponseId: Int, $eventUnixTime: Int!, $fac: String, $ipAddress: String, $keyword: String, $pageName: String!, $path: String!, $questId: Int, $userAgent: String!, $userId: Int, $userName: String) {
  sendActivityLog(
    input: {item: {actionName: $actionName, categoryId: $categoryId, dbFormId: $dbFormId, dbResponseId: $dbResponseId, eventUnixTime: $eventUnixTime, fac: $fac, ipAddress: $ipAddress, keyword: $keyword, pageName: $pageName, path: $path, questId: $questId, userAgent: $userAgent, userId: $userId, userName: $userName}}
  ) {
    success
  }
}
    `;
export const MeShortAccountContentDocument = gql`
    query meShortAccountContent {
  me {
    id
    name
    bio
    avatarImageUrl
  }
}
    `;
export const MePointReportDocument = gql`
    query mePointReport {
  me {
    fussyPoints {
      ...point
    }
    fussyPointsByDate {
      date
      point {
        ...point
      }
    }
    fussyPointsByMonth {
      yearAndMonth
      point {
        ...point
      }
    }
  }
}
    ${PointFragmentDoc}`;
export const MeQuestTaskContentDocument = gql`
    query meQuestTaskContent {
  me {
    userQuestTaskProgresses(questTaskIds: []) {
      id
      media {
        id
        url
      }
      questTask {
        id
        title
        description
        quest {
          id
          title
          description
        }
      }
      user {
        id
        name
      }
      status
      createdAt
    }
  }
}
    `;
export const MeCommittedDatabaseDocument = gql`
    query meCommittedDatabase {
  me {
    responses {
      form {
        id
        title
        categories {
          id
          name
        }
      }
      createdAt
    }
  }
}
    `;
export const MeQuestContentDocument = gql`
    query meQuestContent {
  me {
    userQuestProgresses(questIds: []) {
      id
      quest {
        id
        title
        creatorPoint
        curatorPoint
        evangelistPoint
        expertPoint
        supporterPoint
        startAt
        endAt
        category {
          id
          name
        }
        user {
          id
          name
        }
      }
      status
    }
  }
}
    `;
export const MeRadioResponseMemoryContentDocument = gql`
    query meRadioResponseMemoryContent {
  me {
    radioResponses {
      id
      content
      isAdopted
      radioSegment {
        id
        name
        radioChannel {
          id
          title
        }
      }
      createdAt
    }
  }
}
    `;
export const MeFussyAttestationContentDocument = gql`
    query meFussyAttestationContent {
  me {
    fussyAttestationCards {
      id
      issuedAt
      user {
        id
        name
      }
      fussyAttestation {
        id
        imageUrl
        issuers {
          id
          name
        }
        fussyAttestationEvent {
          id
          title
          eventAt
        }
        fussyAttestationMethods {
          id
          name
        }
        fussyAttestedAchievement {
          id
          name
        }
      }
    }
  }
}
    `;
export const RegisterUserYoutubeAccountDocument = gql`
    mutation registerUserYoutubeAccount($youtubeChannelId: String!) {
  createYoutubeAccount(input: {youtubeChannelId: $youtubeChannelId}) {
    success
  }
}
    `;
export const MeMembershipShortcutContentDocument = gql`
    query meMembershipShortcutContent {
  me {
    id
    enabledMemberships {
      userId
      partnerCategoryMembership {
        id
        title
        pricePerMonth
        closed
        partner {
          id
          name
        }
        category {
          id
          name
        }
      }
      startedAt
      expiredAt
    }
  }
}
    `;
export const MeExamHistoryDocument = gql`
    query meExamHistory {
  me {
    userExamResults(order: desc) {
      id
      squareExamPurchaseId
      resultHash
      completedAt
      createdAt
      externalExam {
        internalId
        name
        category {
          id
        }
      }
    }
    squareExamPurchases(order: desc) {
      id
      examStatus
      resultHash
      purchasedAt
      createdAt
      updatedAt
      externalExam {
        internalId
        name
        category {
          id
        }
      }
    }
  }
}
    `;
export const CancelMembershipDocument = gql`
    mutation cancelMembership($membershipId: Int!) {
  cancelPartnerCategoryMembership(input: {id: $membershipId}) {
    success
  }
}
    `;
export const MarkAsReadNotificationDocument = gql`
    mutation markAsReadNotification($id: Int!) {
  changeOpenedNotification(input: {id: $id}) {
    success
  }
}
    `;
export const MarkAsReadAllNotificationsDocument = gql`
    mutation markAsReadAllNotifications {
  changeOpenedAllNotifications(input: {}) {
    success
  }
}
    `;
export const NotificationIndexContentDocument = gql`
    query notificationIndexContent {
  serviceNotifications(limit: 100, order: desc) {
    id
    title
    serviceNotificationKindName
    isRead
    createdAt
    publishedUser {
      id
      name
    }
  }
}
    `;
export const NotificationDetailContentDocument = gql`
    query notificationDetailContent($id: Int!) {
  serviceNotification(id: $id) {
    id
    title
    content
    serviceNotificationKindName
    isRead
    createdAt
    publishedUser {
      id
      name
    }
  }
}
    `;
export const FetchPartnerDetailAdminContentDocument = gql`
    query fetchPartnerDetailAdminContent {
  me {
    id
    name
    issuedFussyAttestations {
      id
      imageUrl
      fussyAttestationEvent {
        id
        title
        eventAt
      }
      fussyAttestationMethods {
        id
        name
      }
      holders {
        id
      }
    }
    managingCategories {
      id
      name
      partnerCategoryMemberships {
        id
        title
        description
        pricePerMonth
        closed
      }
      membershipLimitedContents {
        id
        title
        content
        createdAt
        hideAt
        visiblePartnerCategoryMemberships {
          id
          title
          pricePerMonth
        }
      }
    }
    isPartner
  }
}
    `;
export const FetchPartnerDetailAdminContentUserDetailsDocument = gql`
    query fetchPartnerDetailAdminContentUserDetails($categoryIds: [Int!]!, $userIds: [Int!]!) {
  users(ids: $userIds) {
    id
    name
    fussyPoints(categoryIds: $categoryIds) {
      category {
        id
        name
      }
      creatorPoint
      curatorPoint
      expertPoint
      evangelistPoint
      supporterPoint
    }
    completedQuests {
      id
      title
      category {
        id
        name
      }
    }
  }
}
    `;
export const CreateSpecialMessageDocument = gql`
    mutation createSpecialMessage($title: String!, $content: String!, $attestationIds: [Int!]!) {
  createSpecialMessage(
    input: {title: $title, content: $content, fussyAttestationIds: $attestationIds}
  ) {
    success
  }
}
    `;
export const CreateMembershipLimitedMessageDocument = gql`
    mutation createMembershipLimitedMessage($title: String!, $content: String!, $membershipIds: [Int!]!) {
  createLimitedContent(
    input: {title: $title, content: $content, membershipIds: $membershipIds}
  ) {
    membershipLimitedContent {
      id
      title
      content
    }
  }
}
    `;
export const FetchMembershipLimitedContentDocument = gql`
    query fetchMembershipLimitedContent($membershipId: Int!) {
  userVisibleMembershipLimitedContents(membershipIds: [$membershipId]) {
    id
    title
    content
    createdAt
  }
}
    `;
export const HideMembershipLimitedContentDocument = gql`
    mutation hideMembershipLimitedContent($id: Int!) {
  hideMembershipLimitedContent(input: {id: $id}) {
    success
  }
}
    `;
export const ReshowMembershipLimitedContentDocument = gql`
    mutation reshowMembershipLimitedContent($id: Int!) {
  reshowMembershipLimitedContent(input: {id: $id}) {
    success
  }
}
    `;
export const QuestDetailContentDocument = gql`
    query questDetailContent($id: Int!) {
  quest(id: $id) {
    id
    title
    description
    startAt
    endAt
    questTasks {
      id
      title
      description
      url
      position
      form {
        id
        title
        questions {
          id
          position
          answerType
          title
          description
          label
        }
      }
    }
    creatorPoint
    curatorPoint
    expertPoint
    evangelistPoint
    supporterPoint
    user {
      id
      name
    }
    category {
      id
      name
    }
    externalExams {
      id
      name
      description
      examMakerId
      internalId
      examAvailableFrom
      examAvailableTo
    }
  }
}
    `;
export const ApplyQuestTaskStartDocument = gql`
    mutation applyQuestTaskStart($input: ApplyQuestTaskStartInput!) {
  applyQuestTaskStart(input: $input) {
    success
  }
}
    `;
export const UploadEvidenceDocument = gql`
    mutation uploadEvidence($input: UploadFileInput!) {
  uploadFile(input: $input) {
    url
  }
}
    `;
export const ApplyQuestTaskDoneDocument = gql`
    mutation applyQuestTaskDone($input: ApplyQuestTaskDoneInput!) {
  applyQuestTaskDone(input: $input) {
    success
  }
}
    `;
export const FetchCurrentUserVerifyCodeDocument = gql`
    query fetchCurrentUserVerifyCode($questId: Int!) {
  currentUserQuestVerifyCode(questId: $questId)
}
    `;
export const QuestIndexContentDocument = gql`
    query questIndexContent {
  quests {
    id
    title
    description
    category {
      id
      name
    }
    questTasks {
      id
    }
    startAt
    endAt
    createdAt
    updatedAt
  }
  categories(column: FURIGANA, order: asc) {
    id
    name
    furigana
  }
}
    `;
export const RadioChannelsForSsgDocument = gql`
    query radioChannelsForSsg {
  radioChannels {
    id
  }
}
    `;
export const RadioFormContentDocument = gql`
    query radioFormContent($id: Int!) {
  radioChannel(id: $id) {
    id
    title
    customer {
      id
      name
    }
    category {
      id
      name
    }
    radioSegments {
      id
      name
    }
    createdAt
    updatedAt
  }
}
    `;
export const AddRadioResponseDocument = gql`
    mutation addRadioResponse($input: AddRadioResponseInput!) {
  addRadioResponse(input: $input) {
    radioResponse {
      id
    }
  }
}
    `;
export const UploadFileForRadioResponseDocument = gql`
    mutation uploadFileForRadioResponse($input: UploadFileInput!) {
  uploadFile(input: $input) {
    url
    mediumReference {
      id
      mediumType
    }
  }
}
    `;
export const RadioChannelsDocument = gql`
    query radioChannels {
  radioChannels {
    id
    title
    category {
      id
      name
    }
    customer {
      id
      name
    }
    radioSegments {
      id
      name
    }
    createdAt
    updatedAt
  }
}
    `;
export const RadioAdminContentDocument = gql`
    query radioAdminContent($channelId: Int!) {
  radioChannel(id: $channelId) {
    id
    title
    customer {
      id
      name
      issuedFussyAttestations {
        id
        category {
          id
          name
        }
        fussyAttestationEvent {
          id
          title
          eventAt
        }
      }
    }
    category {
      id
      name
    }
    radioSegments {
      id
      name
      radioResponses {
        id
        content
        createdAt
        updatedAt
        isAdopted
        isKept
        user {
          id
          name
        }
        userMediumReferences {
          id
          url
          mediumType
          createdAt
        }
      }
    }
    createdAt
    updatedAt
  }
}
    `;
export const AddRadioSegmentDocument = gql`
    mutation addRadioSegment($input: AddRadioSegmentInput!) {
  addRadioSegment(input: $input) {
    radioSegment {
      id
    }
  }
}
    `;
export const AdoptRadioResponseDocument = gql`
    mutation adoptRadioResponse($input: AdoptRadioResponseInput!) {
  adoptRadioResponse(input: $input) {
    radioResponse {
      id
    }
  }
}
    `;
export const RejectRadioResponseDocument = gql`
    mutation rejectRadioResponse($input: RejectAdoptRadioResponseInput!) {
  rejectAdoptRadioResponse(input: $input) {
    radioResponse {
      id
    }
  }
}
    `;
export const KeepRadioResponseDocument = gql`
    mutation keepRadioResponse($input: KeepRadioResponseInput!) {
  keepRadioResponse(input: $input) {
    radioResponse {
      id
    }
  }
}
    `;
export const UnKeepRadioResponseDocument = gql`
    mutation unKeepRadioResponse($input: UnKeepRadioResponseInput!) {
  unKeepRadioResponse(input: $input) {
    radioResponse {
      id
    }
  }
}
    `;
export const GiveRadioFanDocument = gql`
    mutation giveRadioFan($input: GiveFanInput!) {
  giveFan(input: $input) {
    fussyAttestationCard {
      id
    }
  }
}
    `;
export const RaidIndexContentForSsgDocument = gql`
    query raidIndexContentForSsg {
  raids {
    id
  }
}
    `;
export const RaidDetailContentDocument = gql`
    query raidDetailContent($id: Int!) {
  raid(id: $id) {
    id
    title
    description
    bannerImageUrl
    stage
    achievementPoint
    category {
      id
      accumulatedPoint
      name
      raids {
        id
        title
        stage
        bannerImageUrl
      }
    }
  }
}
    `;
export const ShareIndexContentDocument = gql`
    query shareIndexContent {
  categories(order: asc, column: FURIGANA) {
    id
    name
  }
}
    `;
export const FetchSitemapContentDocument = gql`
    query fetchSitemapContent {
  forms {
    id
  }
  categories {
    id
  }
  responses {
    id
  }
  quests {
    id
  }
}
    `;
export const RetrievePopCommentDocument = gql`
    query retrievePopComment($formIds: [Int!]!) {
  forms(ids: $formIds) {
    responses {
      id
      answers {
        __typename
        ... on LocationAnswer {
          id
          position
          locationValue: value {
            latitude
            longitude
          }
        }
        ... on NumberAnswer {
          id
          position
          numberValue: value
        }
        ... on TextAnswer {
          id
          position
          textValue: value
        }
        ... on ReferenceAnswer {
          id
          position
          referenceValue: value
        }
        ... on DateAnswer {
          id
          position
          dateValue: value
        }
        ... on ShortTextAnswer {
          id
          position
          shortTextValue: value
        }
        ... on LongTextAnswer {
          id
          position
          longTextValue: value
        }
        ... on UrlAnswer {
          id
          position
          urlValue: value
        }
        ... on ImageUrlAnswer {
          id
          position
          imageUrlValue: value
        }
      }
      user {
        id
        name
      }
      form {
        categories {
          id
        }
      }
    }
  }
}
    `;
export const CurrentUserQuestProgressDocument = gql`
    query currentUserQuestProgress($questIds: [Int!]!, $questTaskIds: [Int!]!) {
  me {
    id
    name
    userQuestProgresses(questIds: $questIds) {
      id
      status
      questId
    }
    userQuestTaskProgresses(questTaskIds: $questTaskIds) {
      id
      status
      questTaskId
    }
  }
}
    `;
export const SpecialLiveSaihateContentDocument = gql`
    query specialLiveSaihateContent($formId: Int!) {
  form(id: $formId) {
    id
    questions {
      id
      position
      answerType
    }
  }
}
    `;
export const SpecialLiveSaihateCommentsDocument = gql`
    query specialLiveSaihateComments($formId: Int!) {
  form(id: $formId) {
    responses {
      id
      createdAt
      answers {
        __typename
        ... on LocationAnswer {
          id
          position
          locationValue: value {
            latitude
            longitude
          }
        }
        ... on NumberAnswer {
          id
          position
          numberValue: value
        }
        ... on TextAnswer {
          id
          position
          textValue: value
        }
        ... on ReferenceAnswer {
          id
          position
          referenceValue: value
        }
        ... on DateAnswer {
          id
          position
          dateValue: value
        }
        ... on ShortTextAnswer {
          id
          position
          shortTextValue: value
        }
        ... on LongTextAnswer {
          id
          position
          longTextValue: value
        }
        ... on UrlAnswer {
          id
          position
          urlValue: value
        }
        ... on ImageUrlAnswer {
          id
          position
          imageUrlValue: value
        }
      }
    }
  }
}
    `;
export const SpecialLiveSaihateCreateCommentDocument = gql`
    mutation specialLiveSaihateCreateComment($input: CreateResponseInput!) {
  createResponse(input: $input) {
    response {
      id
    }
  }
}
    `;
export const SpecialComedianRadio2024SpringContentDocument = gql`
    query specialComedianRadio2024SpringContent {
  popForms: forms(ids: [1540, 1542, 495, 1539, 1541, 408, 452]) {
    ...radioFormFragment
  }
  recommendedForms: forms(ids: [1533, 1534, 1544, 1531, 1537, 1545, 1318]) {
    ...radioFormFragment
  }
  listenerForms: forms(ids: [1532, 1535, 1543, 1530, 1536, 1546, 1317]) {
    ...radioFormFragment
  }
}
    ${RadioFormFragmentFragmentDoc}`;
export const CheckInSaihateEvent202407Document = gql`
    mutation checkInSaihateEvent202407 {
  mintFan(input: {fanId: 27}) {
    fussyAttestationCard {
      id
    }
  }
}
    `;
export const SpecialWelcomeSaihateContentDocument = gql`
    query specialWelcomeSaihateContent {
  forms(ids: [1317, 1318, 1610, 451, 452]) {
    id
    title
    description
    responses {
      ...formResponse
    }
    questions {
      id
      position
      answerType
      title
      description
      label
    }
    categories {
      id
      name
    }
  }
}
    ${FormResponseFragmentDoc}`;
export const CheckInAbcRadioMatsuri202411Document = gql`
    mutation checkInAbcRadioMatsuri202411 {
  mintFan(input: {fanId: 54}) {
    fussyAttestationCard {
      id
    }
  }
}
    `;
export const CheckInNyanPokoraFes202411Document = gql`
    mutation checkInNyanPokoraFes202411 {
  mintFan(input: {fanId: 57}) {
    fussyAttestationCard {
      id
    }
  }
}
    `;
export const FindDestinationDocument = gql`
    query findDestination($token: String!) {
  shortenUrl(token: $token) {
    destination
    shortenUrlOgp {
      id
      title
      description
      imageUrl
    }
  }
}
    `;
export const IncrementVisitorCountDocument = gql`
    mutation incrementVisitorCount($token: String!) {
  incrementVisitorCount(input: {token: $token}) {
    clientMutationId
  }
}
    `;
export const TopContentDocument = gql`
    query topContent {
  categories {
    id
    name
    quests {
      id
    }
    currentRaid {
      stage
      achievementPoint
    }
    accumulatedPoint
    imageUrl
  }
  fussyEventReferences {
    ...discoveryFeed
  }
}
    ${DiscoveryFeedFragmentDoc}`;
export const TopContentFollowingCategoriesDocument = gql`
    query topContentFollowingCategories {
  me {
    followingCategories {
      id
      name
      quests {
        id
      }
      currentRaid {
        id
        stage
        achievementPoint
      }
      accumulatedPoint
      imageUrl
    }
  }
}
    `;
export const TopContentJoinedMembershipContentsDocument = gql`
    query topContentJoinedMembershipContents {
  userVisibleMembershipLimitedContents {
    id
    title
    content
    createdAt
    visiblePartnerCategoryMemberships {
      id
      title
      pricePerMonth
      category {
        id
        name
      }
    }
  }
}
    `;
export const CurrentUserContentDocument = gql`
    query currentUserContent {
  currentUserQuestProgresses(questIds: []) {
    questId
    quest {
      id
      title
      description
      category {
        id
        name
      }
      startAt
      endAt
    }
    status
    updatedAt
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    accountSignUpContent(variables?: AccountSignUpContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AccountSignUpContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccountSignUpContentQuery>(AccountSignUpContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'accountSignUpContent', 'query');
    },
    SignupExamContext(variables: SignupExamContextQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SignupExamContextQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignupExamContextQuery>(SignupExamContextDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SignupExamContext', 'query');
    },
    editUser(variables: EditUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EditUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditUserMutation>(EditUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'editUser', 'mutation');
    },
    uploadFileForProfile(variables: UploadFileForProfileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UploadFileForProfileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UploadFileForProfileMutation>(UploadFileForProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'uploadFileForProfile', 'mutation');
    },
    deleteAccount(variables?: DeleteAccountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteAccountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteAccountMutation>(DeleteAccountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteAccount', 'mutation');
    },
    adminCategoryAttachGenre(variables?: AdminCategoryAttachGenreQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminCategoryAttachGenreQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCategoryAttachGenreQuery>(AdminCategoryAttachGenreDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'adminCategoryAttachGenre', 'query');
    },
    attachGenreToCategory(variables: AttachGenreToCategoryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AttachGenreToCategoryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AttachGenreToCategoryMutation>(AttachGenreToCategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'attachGenreToCategory', 'mutation');
    },
    detachGenreFromCategory(variables: DetachGenreFromCategoryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DetachGenreFromCategoryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DetachGenreFromCategoryMutation>(DetachGenreFromCategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'detachGenreFromCategory', 'mutation');
    },
    addGenre(variables: AddGenreMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddGenreMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddGenreMutation>(AddGenreDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addGenre', 'mutation');
    },
    adminDatabaseTemplateDatabaseContent(variables?: AdminDatabaseTemplateDatabaseContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminDatabaseTemplateDatabaseContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDatabaseTemplateDatabaseContentQuery>(AdminDatabaseTemplateDatabaseContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'adminDatabaseTemplateDatabaseContent', 'query');
    },
    adminMembershipContent(variables?: AdminMembershipContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminMembershipContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminMembershipContentQuery>(AdminMembershipContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'adminMembershipContent', 'query');
    },
    createMembershipPlan(variables: CreateMembershipPlanMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateMembershipPlanMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateMembershipPlanMutation>(CreateMembershipPlanDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createMembershipPlan', 'mutation');
    },
    issuePaymentLink(variables: IssuePaymentLinkMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<IssuePaymentLinkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IssuePaymentLinkMutation>(IssuePaymentLinkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'issuePaymentLink', 'mutation');
    },
    issueShortenUrlContent(variables?: IssueShortenUrlContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<IssueShortenUrlContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IssueShortenUrlContentQuery>(IssueShortenUrlContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'issueShortenUrlContent', 'query');
    },
    issueShortenUrls(variables: IssueShortenUrlsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<IssueShortenUrlsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IssueShortenUrlsMutation>(IssueShortenUrlsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'issueShortenUrls', 'mutation');
    },
    categoriesContent(variables?: CategoriesContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CategoriesContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CategoriesContentQuery>(CategoriesContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'categoriesContent', 'query');
    },
    createCategory(variables: CreateCategoryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateCategoryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCategoryMutation>(CreateCategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createCategory', 'mutation');
    },
    kintaiContent(variables?: KintaiContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<KintaiContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<KintaiContentQuery>(KintaiContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'kintaiContent', 'query');
    },
    checkKintai(variables: CheckKintaiMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CheckKintaiMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckKintaiMutation>(CheckKintaiDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'checkKintai', 'mutation');
    },
    editWebhook(variables?: EditWebhookMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EditWebhookMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditWebhookMutation>(EditWebhookDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'editWebhook', 'mutation');
    },
    sampleDiscordWebhook(variables?: SampleDiscordWebhookMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SampleDiscordWebhookMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SampleDiscordWebhookMutation>(SampleDiscordWebhookDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sampleDiscordWebhook', 'mutation');
    },
    createPopCommentContent(variables?: CreatePopCommentContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreatePopCommentContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePopCommentContentQuery>(CreatePopCommentContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createPopCommentContent', 'query');
    },
    fetchFormsByCategories(variables: FetchFormsByCategoriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FetchFormsByCategoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchFormsByCategoriesQuery>(FetchFormsByCategoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchFormsByCategories', 'query');
    },
    createPopCommentForm(variables: CreatePopCommentFormMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreatePopCommentFormMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePopCommentFormMutation>(CreatePopCommentFormDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createPopCommentForm', 'mutation');
    },
    changeResponseUserContent(variables?: ChangeResponseUserContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ChangeResponseUserContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChangeResponseUserContentQuery>(ChangeResponseUserContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'changeResponseUserContent', 'query');
    },
    changeResponseUser(variables: ChangeResponseUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ChangeResponseUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChangeResponseUserMutation>(ChangeResponseUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'changeResponseUser', 'mutation');
    },
    staticFilesContent(variables?: StaticFilesContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StaticFilesContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StaticFilesContentQuery>(StaticFilesContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'staticFilesContent', 'query');
    },
    adminQuestDetailContent(variables: AdminQuestDetailContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminQuestDetailContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminQuestDetailContentQuery>(AdminQuestDetailContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'adminQuestDetailContent', 'query');
    },
    adminQuestCreateContent(variables?: AdminQuestCreateContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminQuestCreateContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminQuestCreateContentQuery>(AdminQuestCreateContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'adminQuestCreateContent', 'query');
    },
    createQuest(variables: CreateQuestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateQuestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateQuestMutation>(CreateQuestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createQuest', 'mutation');
    },
    adminQuestIndexContent(variables?: AdminQuestIndexContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminQuestIndexContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminQuestIndexContentQuery>(AdminQuestIndexContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'adminQuestIndexContent', 'query');
    },
    adminQuestTemplateContent(variables?: AdminQuestTemplateContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminQuestTemplateContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminQuestTemplateContentQuery>(AdminQuestTemplateContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'adminQuestTemplateContent', 'query');
    },
    verifyQuestTaskContent(variables?: VerifyQuestTaskContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VerifyQuestTaskContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VerifyQuestTaskContentQuery>(VerifyQuestTaskContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'verifyQuestTaskContent', 'query');
    },
    verifyQuestTask(variables: VerifyQuestTaskMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VerifyQuestTaskMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<VerifyQuestTaskMutation>(VerifyQuestTaskDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'verifyQuestTask', 'mutation');
    },
    rejectQuestTask(variables: RejectQuestTaskMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RejectQuestTaskMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RejectQuestTaskMutation>(RejectQuestTaskDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'rejectQuestTask', 'mutation');
    },
    createFussyAccessToken(variables: CreateFussyAccessTokenMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateFussyAccessTokenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateFussyAccessTokenMutation>(CreateFussyAccessTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createFussyAccessToken', 'mutation');
    },
    categoryDetailMembershipIndexContent(variables: CategoryDetailMembershipIndexContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CategoryDetailMembershipIndexContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CategoryDetailMembershipIndexContentQuery>(CategoryDetailMembershipIndexContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'categoryDetailMembershipIndexContent', 'query');
    },
    categoryDetailMembershipDetailContent(variables: CategoryDetailMembershipDetailContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CategoryDetailMembershipDetailContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CategoryDetailMembershipDetailContentQuery>(CategoryDetailMembershipDetailContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'categoryDetailMembershipDetailContent', 'query');
    },
    registerMembership(variables: RegisterMembershipMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegisterMembershipMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegisterMembershipMutation>(RegisterMembershipDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registerMembership', 'mutation');
    },
    meJoinedMembership(variables?: MeJoinedMembershipQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MeJoinedMembershipQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeJoinedMembershipQuery>(MeJoinedMembershipDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'meJoinedMembership', 'query');
    },
    categoryDetailsForGsp(variables?: CategoryDetailsForGspQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CategoryDetailsForGspQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CategoryDetailsForGspQuery>(CategoryDetailsForGspDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'categoryDetailsForGsp', 'query');
    },
    categoryDetail(variables: CategoryDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CategoryDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CategoryDetailQuery>(CategoryDetailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'categoryDetail', 'query');
    },
    meEligibleLimitation(variables: MeEligibleLimitationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MeEligibleLimitationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeEligibleLimitationQuery>(MeEligibleLimitationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'meEligibleLimitation', 'query');
    },
    categoryIndexContent(variables?: CategoryIndexContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CategoryIndexContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CategoryIndexContentQuery>(CategoryIndexContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'categoryIndexContent', 'query');
    },
    userQuestProgress(variables: UserQuestProgressQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserQuestProgressQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserQuestProgressQuery>(UserQuestProgressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userQuestProgress', 'query');
    },
    raidContent(variables: RaidContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RaidContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RaidContentQuery>(RaidContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'raidContent', 'query');
    },
    currentUserNotifications(variables?: CurrentUserNotificationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CurrentUserNotificationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrentUserNotificationsQuery>(CurrentUserNotificationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'currentUserNotifications', 'query');
    },
    isFollowingCategory(variables: IsFollowingCategoryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<IsFollowingCategoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IsFollowingCategoryQuery>(IsFollowingCategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'isFollowingCategory', 'query');
    },
    isFollowingCategories(variables: IsFollowingCategoriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<IsFollowingCategoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IsFollowingCategoriesQuery>(IsFollowingCategoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'isFollowingCategories', 'query');
    },
    followCategory(variables: FollowCategoryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FollowCategoryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FollowCategoryMutation>(FollowCategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'followCategory', 'mutation');
    },
    unfollowCategory(variables: UnfollowCategoryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnfollowCategoryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnfollowCategoryMutation>(UnfollowCategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unfollowCategory', 'mutation');
    },
    listCategories(variables?: ListCategoriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ListCategoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ListCategoriesQuery>(ListCategoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'listCategories', 'query');
    },
    createShortenUrls(variables: CreateShortenUrlsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateShortenUrlsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateShortenUrlsMutation>(CreateShortenUrlsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createShortenUrls', 'mutation');
    },
    databaseDetailContent(variables: DatabaseDetailContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DatabaseDetailContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DatabaseDetailContentQuery>(DatabaseDetailContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'databaseDetailContent', 'query');
    },
    databaseDetailTableContent(variables: DatabaseDetailTableContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DatabaseDetailTableContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DatabaseDetailTableContentQuery>(DatabaseDetailTableContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'databaseDetailTableContent', 'query');
    },
    createResponse(variables: CreateResponseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateResponseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateResponseMutation>(CreateResponseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createResponse', 'mutation');
    },
    editAnswer(variables: EditAnswerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EditAnswerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditAnswerMutation>(EditAnswerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'editAnswer', 'mutation');
    },
    updateForm(variables: UpdateFormMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateFormMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateFormMutation>(UpdateFormDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateForm', 'mutation');
    },
    uploadFileForResponse(variables: UploadFileForResponseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UploadFileForResponseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UploadFileForResponseMutation>(UploadFileForResponseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'uploadFileForResponse', 'mutation');
    },
    databaseDetailCsvContent(variables: DatabaseDetailCsvContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DatabaseDetailCsvContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DatabaseDetailCsvContentQuery>(DatabaseDetailCsvContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'databaseDetailCsvContent', 'query');
    },
    databaseCreateContent(variables?: DatabaseCreateContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DatabaseCreateContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DatabaseCreateContentQuery>(DatabaseCreateContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'databaseCreateContent', 'query');
    },
    createForm(variables: CreateFormMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateFormMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateFormMutation>(CreateFormDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createForm', 'mutation');
    },
    databaseContent(variables?: DatabaseContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DatabaseContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DatabaseContentQuery>(DatabaseContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'databaseContent', 'query');
    },
    createExamPaymentLink(variables: CreateExamPaymentLinkMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateExamPaymentLinkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateExamPaymentLinkMutation>(CreateExamPaymentLinkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createExamPaymentLink', 'mutation');
    },
    CreateExamProduct(variables: CreateExamProductMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateExamProductMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateExamProductMutation>(CreateExamProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateExamProduct', 'mutation');
    },
    createUserExamResult(variables: CreateUserExamResultMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateUserExamResultMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateUserExamResultMutation>(CreateUserExamResultDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createUserExamResult', 'mutation');
    },
    UpdateSquareExamPurchase(variables: UpdateSquareExamPurchaseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateSquareExamPurchaseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSquareExamPurchaseMutation>(UpdateSquareExamPurchaseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateSquareExamPurchase', 'mutation');
    },
    UpdateCertificateImage(variables: UpdateCertificateImageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCertificateImageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCertificateImageMutation>(UpdateCertificateImageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateCertificateImage', 'mutation');
    },
    StartExam(variables: StartExamMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StartExamMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<StartExamMutation>(StartExamDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'StartExam', 'mutation');
    },
    uploadCertificateImage(variables: UploadCertificateImageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UploadCertificateImageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UploadCertificateImageMutation>(UploadCertificateImageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'uploadCertificateImage', 'mutation');
    },
    examContent(variables?: ExamContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExamContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExamContentQuery>(ExamContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'examContent', 'query');
    },
    GetExamDetails(variables: GetExamDetailsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetExamDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetExamDetailsQuery>(GetExamDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetExamDetails', 'query');
    },
    GetAvailablePurchase(variables: GetAvailablePurchaseQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAvailablePurchaseQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAvailablePurchaseQuery>(GetAvailablePurchaseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetAvailablePurchase', 'query');
    },
    validateExamAccess(variables: ValidateExamAccessQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ValidateExamAccessQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ValidateExamAccessQuery>(ValidateExamAccessDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'validateExamAccess', 'query');
    },
    GetExamResultByHash(variables: GetExamResultByHashQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetExamResultByHashQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetExamResultByHashQuery>(GetExamResultByHashDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetExamResultByHash', 'query');
    },
    updateExamProduct(variables: UpdateExamProductMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateExamProductMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateExamProductMutation>(UpdateExamProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateExamProduct', 'mutation');
    },
    uploadExamSignupVisual(variables: UploadExamSignupVisualMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UploadExamSignupVisualMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UploadExamSignupVisualMutation>(UploadExamSignupVisualDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'uploadExamSignupVisual', 'mutation');
    },
    GetExamRanking(variables: GetExamRankingQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetExamRankingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetExamRankingQuery>(GetExamRankingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetExamRanking', 'query');
    },
    itemDetail(variables: ItemDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ItemDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ItemDetailQuery>(ItemDetailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'itemDetail', 'query');
    },
    writeBlogWithLlmForYabai(variables: WriteBlogWithLlmForYabaiMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WriteBlogWithLlmForYabaiMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<WriteBlogWithLlmForYabaiMutation>(WriteBlogWithLlmForYabaiDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'writeBlogWithLlmForYabai', 'mutation');
    },
    findUser(variables: FindUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindUserQuery>(FindUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findUser', 'query');
    },
    userByFirebaseAuthId(variables: UserByFirebaseAuthIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserByFirebaseAuthIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserByFirebaseAuthIdQuery>(UserByFirebaseAuthIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userByFirebaseAuthId', 'query');
    },
    createUserWithIdToken(variables: CreateUserWithIdTokenMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateUserWithIdTokenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateUserWithIdTokenMutation>(CreateUserWithIdTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createUserWithIdToken', 'mutation');
    },
    me(variables?: MeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeQuery>(MeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'me', 'query');
    },
    listStaticFileUrls(variables?: ListStaticFileUrlsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ListStaticFileUrlsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ListStaticFileUrlsQuery>(ListStaticFileUrlsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'listStaticFileUrls', 'query');
    },
    createStaticFile(variables: CreateStaticFileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateStaticFileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateStaticFileMutation>(CreateStaticFileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createStaticFile', 'mutation');
    },
    sendActivityLog(variables: SendActivityLogMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SendActivityLogMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendActivityLogMutation>(SendActivityLogDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendActivityLog', 'mutation');
    },
    meShortAccountContent(variables?: MeShortAccountContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MeShortAccountContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeShortAccountContentQuery>(MeShortAccountContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'meShortAccountContent', 'query');
    },
    mePointReport(variables?: MePointReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MePointReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MePointReportQuery>(MePointReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'mePointReport', 'query');
    },
    meQuestTaskContent(variables?: MeQuestTaskContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MeQuestTaskContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeQuestTaskContentQuery>(MeQuestTaskContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'meQuestTaskContent', 'query');
    },
    meCommittedDatabase(variables?: MeCommittedDatabaseQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MeCommittedDatabaseQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeCommittedDatabaseQuery>(MeCommittedDatabaseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'meCommittedDatabase', 'query');
    },
    meQuestContent(variables?: MeQuestContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MeQuestContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeQuestContentQuery>(MeQuestContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'meQuestContent', 'query');
    },
    meRadioResponseMemoryContent(variables?: MeRadioResponseMemoryContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MeRadioResponseMemoryContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeRadioResponseMemoryContentQuery>(MeRadioResponseMemoryContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'meRadioResponseMemoryContent', 'query');
    },
    meFussyAttestationContent(variables?: MeFussyAttestationContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MeFussyAttestationContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeFussyAttestationContentQuery>(MeFussyAttestationContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'meFussyAttestationContent', 'query');
    },
    registerUserYoutubeAccount(variables: RegisterUserYoutubeAccountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegisterUserYoutubeAccountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegisterUserYoutubeAccountMutation>(RegisterUserYoutubeAccountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registerUserYoutubeAccount', 'mutation');
    },
    meMembershipShortcutContent(variables?: MeMembershipShortcutContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MeMembershipShortcutContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeMembershipShortcutContentQuery>(MeMembershipShortcutContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'meMembershipShortcutContent', 'query');
    },
    meExamHistory(variables?: MeExamHistoryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MeExamHistoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeExamHistoryQuery>(MeExamHistoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'meExamHistory', 'query');
    },
    cancelMembership(variables: CancelMembershipMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CancelMembershipMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CancelMembershipMutation>(CancelMembershipDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'cancelMembership', 'mutation');
    },
    markAsReadNotification(variables: MarkAsReadNotificationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkAsReadNotificationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkAsReadNotificationMutation>(MarkAsReadNotificationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markAsReadNotification', 'mutation');
    },
    markAsReadAllNotifications(variables?: MarkAsReadAllNotificationsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkAsReadAllNotificationsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkAsReadAllNotificationsMutation>(MarkAsReadAllNotificationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markAsReadAllNotifications', 'mutation');
    },
    notificationIndexContent(variables?: NotificationIndexContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NotificationIndexContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NotificationIndexContentQuery>(NotificationIndexContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'notificationIndexContent', 'query');
    },
    notificationDetailContent(variables: NotificationDetailContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NotificationDetailContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NotificationDetailContentQuery>(NotificationDetailContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'notificationDetailContent', 'query');
    },
    fetchPartnerDetailAdminContent(variables?: FetchPartnerDetailAdminContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FetchPartnerDetailAdminContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchPartnerDetailAdminContentQuery>(FetchPartnerDetailAdminContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchPartnerDetailAdminContent', 'query');
    },
    fetchPartnerDetailAdminContentUserDetails(variables: FetchPartnerDetailAdminContentUserDetailsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FetchPartnerDetailAdminContentUserDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchPartnerDetailAdminContentUserDetailsQuery>(FetchPartnerDetailAdminContentUserDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchPartnerDetailAdminContentUserDetails', 'query');
    },
    createSpecialMessage(variables: CreateSpecialMessageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateSpecialMessageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSpecialMessageMutation>(CreateSpecialMessageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createSpecialMessage', 'mutation');
    },
    createMembershipLimitedMessage(variables: CreateMembershipLimitedMessageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateMembershipLimitedMessageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateMembershipLimitedMessageMutation>(CreateMembershipLimitedMessageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createMembershipLimitedMessage', 'mutation');
    },
    fetchMembershipLimitedContent(variables: FetchMembershipLimitedContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FetchMembershipLimitedContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchMembershipLimitedContentQuery>(FetchMembershipLimitedContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchMembershipLimitedContent', 'query');
    },
    hideMembershipLimitedContent(variables: HideMembershipLimitedContentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<HideMembershipLimitedContentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<HideMembershipLimitedContentMutation>(HideMembershipLimitedContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'hideMembershipLimitedContent', 'mutation');
    },
    reshowMembershipLimitedContent(variables: ReshowMembershipLimitedContentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReshowMembershipLimitedContentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReshowMembershipLimitedContentMutation>(ReshowMembershipLimitedContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'reshowMembershipLimitedContent', 'mutation');
    },
    questDetailContent(variables: QuestDetailContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuestDetailContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuestDetailContentQuery>(QuestDetailContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'questDetailContent', 'query');
    },
    applyQuestTaskStart(variables: ApplyQuestTaskStartMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ApplyQuestTaskStartMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApplyQuestTaskStartMutation>(ApplyQuestTaskStartDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'applyQuestTaskStart', 'mutation');
    },
    uploadEvidence(variables: UploadEvidenceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UploadEvidenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UploadEvidenceMutation>(UploadEvidenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'uploadEvidence', 'mutation');
    },
    applyQuestTaskDone(variables: ApplyQuestTaskDoneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ApplyQuestTaskDoneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApplyQuestTaskDoneMutation>(ApplyQuestTaskDoneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'applyQuestTaskDone', 'mutation');
    },
    fetchCurrentUserVerifyCode(variables: FetchCurrentUserVerifyCodeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FetchCurrentUserVerifyCodeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchCurrentUserVerifyCodeQuery>(FetchCurrentUserVerifyCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchCurrentUserVerifyCode', 'query');
    },
    questIndexContent(variables?: QuestIndexContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuestIndexContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuestIndexContentQuery>(QuestIndexContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'questIndexContent', 'query');
    },
    radioChannelsForSsg(variables?: RadioChannelsForSsgQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RadioChannelsForSsgQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RadioChannelsForSsgQuery>(RadioChannelsForSsgDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'radioChannelsForSsg', 'query');
    },
    radioFormContent(variables: RadioFormContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RadioFormContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RadioFormContentQuery>(RadioFormContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'radioFormContent', 'query');
    },
    addRadioResponse(variables: AddRadioResponseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddRadioResponseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddRadioResponseMutation>(AddRadioResponseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addRadioResponse', 'mutation');
    },
    uploadFileForRadioResponse(variables: UploadFileForRadioResponseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UploadFileForRadioResponseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UploadFileForRadioResponseMutation>(UploadFileForRadioResponseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'uploadFileForRadioResponse', 'mutation');
    },
    radioChannels(variables?: RadioChannelsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RadioChannelsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RadioChannelsQuery>(RadioChannelsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'radioChannels', 'query');
    },
    radioAdminContent(variables: RadioAdminContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RadioAdminContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RadioAdminContentQuery>(RadioAdminContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'radioAdminContent', 'query');
    },
    addRadioSegment(variables: AddRadioSegmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddRadioSegmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddRadioSegmentMutation>(AddRadioSegmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addRadioSegment', 'mutation');
    },
    adoptRadioResponse(variables: AdoptRadioResponseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdoptRadioResponseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdoptRadioResponseMutation>(AdoptRadioResponseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'adoptRadioResponse', 'mutation');
    },
    rejectRadioResponse(variables: RejectRadioResponseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RejectRadioResponseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RejectRadioResponseMutation>(RejectRadioResponseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'rejectRadioResponse', 'mutation');
    },
    keepRadioResponse(variables: KeepRadioResponseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<KeepRadioResponseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<KeepRadioResponseMutation>(KeepRadioResponseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'keepRadioResponse', 'mutation');
    },
    unKeepRadioResponse(variables: UnKeepRadioResponseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnKeepRadioResponseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnKeepRadioResponseMutation>(UnKeepRadioResponseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unKeepRadioResponse', 'mutation');
    },
    giveRadioFan(variables: GiveRadioFanMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GiveRadioFanMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GiveRadioFanMutation>(GiveRadioFanDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'giveRadioFan', 'mutation');
    },
    raidIndexContentForSsg(variables?: RaidIndexContentForSsgQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RaidIndexContentForSsgQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RaidIndexContentForSsgQuery>(RaidIndexContentForSsgDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'raidIndexContentForSsg', 'query');
    },
    raidDetailContent(variables: RaidDetailContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RaidDetailContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RaidDetailContentQuery>(RaidDetailContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'raidDetailContent', 'query');
    },
    shareIndexContent(variables?: ShareIndexContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShareIndexContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShareIndexContentQuery>(ShareIndexContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shareIndexContent', 'query');
    },
    fetchSitemapContent(variables?: FetchSitemapContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FetchSitemapContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchSitemapContentQuery>(FetchSitemapContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchSitemapContent', 'query');
    },
    retrievePopComment(variables: RetrievePopCommentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RetrievePopCommentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RetrievePopCommentQuery>(RetrievePopCommentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'retrievePopComment', 'query');
    },
    currentUserQuestProgress(variables: CurrentUserQuestProgressQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CurrentUserQuestProgressQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrentUserQuestProgressQuery>(CurrentUserQuestProgressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'currentUserQuestProgress', 'query');
    },
    specialLiveSaihateContent(variables: SpecialLiveSaihateContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SpecialLiveSaihateContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpecialLiveSaihateContentQuery>(SpecialLiveSaihateContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'specialLiveSaihateContent', 'query');
    },
    specialLiveSaihateComments(variables: SpecialLiveSaihateCommentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SpecialLiveSaihateCommentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpecialLiveSaihateCommentsQuery>(SpecialLiveSaihateCommentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'specialLiveSaihateComments', 'query');
    },
    specialLiveSaihateCreateComment(variables: SpecialLiveSaihateCreateCommentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SpecialLiveSaihateCreateCommentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpecialLiveSaihateCreateCommentMutation>(SpecialLiveSaihateCreateCommentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'specialLiveSaihateCreateComment', 'mutation');
    },
    specialComedianRadio2024SpringContent(variables?: SpecialComedianRadio2024SpringContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SpecialComedianRadio2024SpringContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpecialComedianRadio2024SpringContentQuery>(SpecialComedianRadio2024SpringContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'specialComedianRadio2024SpringContent', 'query');
    },
    checkInSaihateEvent202407(variables?: CheckInSaihateEvent202407MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CheckInSaihateEvent202407Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckInSaihateEvent202407Mutation>(CheckInSaihateEvent202407Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'checkInSaihateEvent202407', 'mutation');
    },
    specialWelcomeSaihateContent(variables?: SpecialWelcomeSaihateContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SpecialWelcomeSaihateContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpecialWelcomeSaihateContentQuery>(SpecialWelcomeSaihateContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'specialWelcomeSaihateContent', 'query');
    },
    checkInAbcRadioMatsuri202411(variables?: CheckInAbcRadioMatsuri202411MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CheckInAbcRadioMatsuri202411Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckInAbcRadioMatsuri202411Mutation>(CheckInAbcRadioMatsuri202411Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'checkInAbcRadioMatsuri202411', 'mutation');
    },
    checkInNyanPokoraFes202411(variables?: CheckInNyanPokoraFes202411MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CheckInNyanPokoraFes202411Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckInNyanPokoraFes202411Mutation>(CheckInNyanPokoraFes202411Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'checkInNyanPokoraFes202411', 'mutation');
    },
    findDestination(variables: FindDestinationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindDestinationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindDestinationQuery>(FindDestinationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findDestination', 'query');
    },
    incrementVisitorCount(variables: IncrementVisitorCountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<IncrementVisitorCountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IncrementVisitorCountMutation>(IncrementVisitorCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'incrementVisitorCount', 'mutation');
    },
    topContent(variables?: TopContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TopContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TopContentQuery>(TopContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'topContent', 'query');
    },
    topContentFollowingCategories(variables?: TopContentFollowingCategoriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TopContentFollowingCategoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TopContentFollowingCategoriesQuery>(TopContentFollowingCategoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'topContentFollowingCategories', 'query');
    },
    topContentJoinedMembershipContents(variables?: TopContentJoinedMembershipContentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TopContentJoinedMembershipContentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TopContentJoinedMembershipContentsQuery>(TopContentJoinedMembershipContentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'topContentJoinedMembershipContents', 'query');
    },
    currentUserContent(variables?: CurrentUserContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CurrentUserContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrentUserContentQuery>(CurrentUserContentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'currentUserContent', 'query');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;